/* eslint-disable */
import React, { useState, useEffect } from "react";
import { supabase } from "./supabaseClient";
import { CAMPUS_1, CAMPUS_2, CORRIDOR, LIBRARY, SPORTS_DAY, IND_DAY, AYUB_TRIP, ISLOO_TRIP, ASSEMBLY, DR_HAFIZ, IQBAL_DAY, SPORTS_DAY2, AYUB_TRIP2, ISLOO_TRIP2, EXT_SUNNY, EXT_ARCH, EXT_COURT, EXT_SIDE, EXT_GARDEN, SUNSET, CORR_QUOTE, CORR_QURAN, CORR_LONG1, CORR_LONG2, CORR_GIRLS, CORR_HIFZ, STAIRS, PS_ROOM1, PS_ROOM2, PS_ROOM3, PS_ROOM4, CLASS_SM, HIFZ_GRAD, COMP_LAB, COMP_LAB2, LIB_READING, LIB_GIRLS, SCI_LAB, SCI_LAB2, SCI_LAB3, CAMPUS_AERIAL, BOARDING_CAMPUS,
  TECH_ROOM, ACADEMY_BEAUTIFUL_1, AUGUST_TRIP_1, AYUB_PARK_2, CLASSROOM_1, CLASSROOM_2, CLASSROOM_3,
  NATIONAL_MUSEUM_1, NATIONAL_MUSEUM_2, SCHOOL_CHILDREN, STUDENTS_TECH_ROOM,
  TEACHERS_TRAINING_1, TEACHERS_TRAINING_2, NURSERY_CLASSES, SMALL_CLASSES_2, KG_CLASSES,
  PLAYGROUND_PREP_1, PLAYGROUND_PREP_2, TARBIYAH_CLASS_1, TARBIYAH_CLASS_2,
  HIFZ_CLASS_2, HIFZ_CLASS_3, AI_COURSE_1, AI_COURSE_2,
  CP_GREEN_1, CP_GREEN_2, CP_GREEN_3, CP_GREEN_POSTER,
  CP_SOCIAL_1, CP_SOCIAL_2, CP_SOCIAL_3,
  CP_CLEAN_1, CP_CLEAN_2, CP_CLEAN_3,
  CP_SOLAR_1, CP_SOLAR_2,
  CLASSROOM_PIC1, SCI_LAB_EQUIP,
  CAMPUS_COURTYARD, CAMPUS_COURTYARD_2,
  CLASS_ACTIVE, CLASS_PRESENT, SCI_DEMO, SCI_CLUB, ART_CLUB } from "./photos";
 
// ── Shared helpers ────────────────────────────────────────────────
const G = "#1a6b3c";   // primary green
const GD = "#0a4a24";  // dark green
const TEAL = "#0d9488";
const GOLD = "#f0a500";
const NAVY = "#1e3a5f";
const WHATSAPP_NUMBER = "923265632236"; // ← Change this to your WhatsApp number (country code + number, no +)
const CREAM = "#fdf8f0";

function AnnouncementCard({ a, gradStart }) {
  const CAT_COLOR = { News:"#0891b2", Event:"#7c3aed", Achievement:"#16a34a", Notice:"#d97706", Holiday:"#e11d48" };
  const c = CAT_COLOR[a.category] || gradStart;
  const [expanded, setExpanded] = React.useState(false);
  const isLong = a.body.length > 140;
  return (
    <div style={{ background:CREAM, borderRadius:16, padding:"22px 20px", border:`1px solid ${c}20`, borderLeft:`4px solid ${c}` }}>
      <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:12 }}>
        <span style={{ background:c, color:"white", borderRadius:20, padding:"3px 12px", fontSize:10, fontWeight:800 }}>{a.category.toUpperCase()}</span>
        <span style={{ fontSize:11, color:"#9ca3af", marginLeft:"auto" }}>{new Date(a.created_at).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"})}</span>
      </div>
      <h3 style={{ fontSize:15, fontWeight:900, color:"#111827", margin:"0 0 8px", lineHeight:1.4 }}>{a.title}</h3>
      <p style={{ fontSize:13, color:"#4b5563", lineHeight:1.8, margin:0, fontWeight:500 }}>
        {expanded || !isLong ? a.body : a.body.slice(0,140)+"..."}
      </p>
      {isLong && (
        <button onClick={()=>setExpanded(v=>!v)} style={{ marginTop:8, background:"none", border:"none", color:c, fontSize:12, fontWeight:700, cursor:"pointer", padding:0 }}>
          {expanded?"Show less ↑":"Read more →"}
        </button>
      )}
      {a.file_url && (
        <a href={a.file_url} target="_blank" rel="noopener noreferrer"
          style={{ display:"inline-flex", alignItems:"center", gap:6, marginTop:12, fontSize:12, color:"#7c3aed", fontWeight:700, textDecoration:"none", background:"#f3e8ff", borderRadius:8, padding:"6px 12px", border:"1px solid #c4b5fd" }}>
          {'📎'} {a.file_name||"View Attachment"}
        </a>
      )}
    </div>
  );
}

const Section = ({ id, children, style={} }) => (
  <section id={id} className="qka-section-pad" style={{ padding:"80px 0", ...style }}>{children}</section>
);
const Container = ({ children, style={} }) => (
  <div style={{ maxWidth:1100, margin:"0 auto", padding:"0 24px", ...style }} className="qka-container">{children}</div>
);
const Tag = ({ children, color=G }) => (
  <div style={{ fontSize:12, fontWeight:700, color, letterSpacing:1.5, textTransform:"uppercase", marginBottom:10 }}>
    {children}
  </div>
);
const H2 = ({ children, style={} }) => (
  <h2 style={{ fontSize:"clamp(26px,4vw,38px)", fontWeight:900, color:"#1a1a1a", margin:"0 0 16px", lineHeight:1.2, ...style }}>
    {children}
  </h2>
);
const Divider = ({ color=G }) => (
  <div style={{ width:56, height:4, background:`linear-gradient(90deg,${color},${color}80)`, borderRadius:2, marginBottom:24 }}/>
);
const Check = ({ color=G }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ flexShrink:0, marginTop:2 }}>
    <circle cx="8" cy="8" r="8" fill={color+"20"}/>
    <path d="M4 8l2.5 2.5 5.5-5" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// ── LOGIN MODAL ───────────────────────────────────────────────────
function LoginModal({ onClose, onLogin, S }) {
  const [email, setEmail] = React.useState("");
  const [pass, setPass]   = React.useState("");
  const [show, setShow]   = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [err, setErr]     = React.useState("");
  const grad = `linear-gradient(135deg,${G},${GD})`;

  const submit = async e => {
    e && e.preventDefault();
    if(!email||!pass) return setErr("Please enter email and password.");
    setLoading(true); setErr("");
    const { data, error } = await supabase.auth.signInWithPassword({ email, password: pass });
    if(error) { setErr(error.message); setLoading(false); }
    else onLogin(data.session);
  };

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.7)", zIndex:9999, display:"flex", alignItems:"center", justifyContent:"center", backdropFilter:"blur(6px)", padding:16 }}
      onClick={onClose}>
      <div style={{ background:"white", borderRadius:20, width:460, maxWidth:"100%", overflow:"hidden", boxShadow:"0 40px 100px rgba(0,0,0,0.45)" }}
        onClick={e=>e.stopPropagation()}>
        {/* Hero header with campus photo */}
        <div style={{ position:"relative", height:200, overflow:"hidden" }}>
          <img src={CAMPUS_AERIAL} alt="" style={{ position:"absolute", inset:0, width:"100%", height:"100%", objectFit:"cover", objectPosition:"center 55%", zIndex:0 }}/>
          <div style={{ position:"absolute", inset:0, background:`linear-gradient(135deg,${G}e2,${GD}d0)`, zIndex:1 }}/>
          <button onClick={onClose} style={{ position:"absolute", top:14, right:14, background:"rgba(255,255,255,0.18)", color:"white", border:"none", borderRadius:8, width:32, height:32, fontSize:16, cursor:"pointer", zIndex:3 }}>{'×'}</button>
          <div style={{ position:"relative", zIndex:2, height:"100%", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:0 }}>
            <div style={{ width:84, height:84, borderRadius:"50%", background:"white", display:"flex", alignItems:"center", justifyContent:"center", boxShadow:"0 6px 32px rgba(0,0,0,0.28)", marginBottom:11, border:"3px solid rgba(255,255,255,0.45)" }}>
              <img src="/Transparent Logo.png" alt="QKA Logo" style={{ width:60, height:60, objectFit:"contain" }}/>
            </div>
            <div style={{ fontSize:14, fontWeight:900, color:"white", letterSpacing:1.5, textTransform:"uppercase", textShadow:"0 1px 8px rgba(0,0,0,0.3)" }}>QK Academy</div>
            <div style={{ fontSize:10, color:"rgba(255,255,255,0.72)", marginTop:4, letterSpacing:2, textTransform:"uppercase" }}>Staff Portal</div>
          </div>
        </div>
        <form onSubmit={submit} style={{ padding:"24px 32px 28px" }}>
          <div style={{ marginBottom:16 }}>
            <label style={{ fontSize:11, fontWeight:700, color:"#374151", display:"block", marginBottom:6 }}>Email Address</label>
            <input type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="admin@qkacademy.edu.pk" autoComplete="email"
              style={{ width:"100%", border:"1.5px solid #e5e7eb", borderRadius:10, padding:"11px 14px", fontSize:14, outline:"none", boxSizing:"border-box" }}
              onFocus={e=>e.target.style.borderColor=G} onBlur={e=>e.target.style.borderColor="#e5e7eb"}/>
          </div>
          <div style={{ marginBottom:20 }}>
            <label style={{ fontSize:11, fontWeight:700, color:"#374151", display:"block", marginBottom:6 }}>Password</label>
            <div style={{ position:"relative" }}>
              <input type={show?"text":"password"} value={pass} onChange={e=>setPass(e.target.value)} placeholder="••••••••" autoComplete="current-password"
                style={{ width:"100%", border:"1.5px solid #e5e7eb", borderRadius:10, padding:"11px 42px 11px 14px", fontSize:14, outline:"none", boxSizing:"border-box" }}
                onFocus={e=>e.target.style.borderColor=G} onBlur={e=>e.target.style.borderColor="#e5e7eb"}/>
              <button type="button" onClick={()=>setShow(p=>!p)}
                style={{ position:"absolute", right:12, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", cursor:"pointer", color:"#9ca3af", fontSize:16 }}>
                {show?"🙈":"👁"}
              </button>
            </div>
          </div>
          {err && <div style={{ background:"#fff0f3", border:"1px solid #fda4af", borderRadius:8, padding:"9px 12px", fontSize:13, color:"#e11d48", marginBottom:16 }}>⚠️ {err}</div>}
          <button type="submit" disabled={loading}
            style={{ width:"100%", background:loading?"#9ca3af":grad, color:"white", border:"none", borderRadius:10, padding:"13px", fontWeight:800, fontSize:15, cursor:loading?"not-allowed":"pointer" }}>
            {loading?"Signing in…":"Sign In →"}
          </button>
          <div style={{ textAlign:"center", marginTop:16, fontSize:12, color:"#9ca3af" }}>{'🔒'} Authorised staff only {'·'} Contact admin for password reset</div>
        </form>
      </div>
    </div>
  );
}

// ── ONLINE ADMISSION FORM MODAL ──────────────────────────────────
function AdmissionFormModal({ onClose, gradStart, G, GOLD, CREAM, GD }) {
  const [step, setStep] = React.useState(1);
  const [submitted, setSubmitted] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [form, setForm] = React.useState({
    studentName:"", dob:"", gender:"", fatherName:"", fatherPhone:"",
    fatherCnic:"", address:"", program:"", prevSchool:"", howHeard:"", notes:""
  });

  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  const inputStyle = { width:"100%", border:"1.5px solid #e5e7eb", borderRadius:10, padding:"11px 13px", fontSize:14, outline:"none", boxSizing:"border-box", background:"white" };
  const grad = `linear-gradient(135deg,${G},${GD})`;

  const submit = async () => {
    if(!form.studentName || !form.fatherName || !form.fatherPhone || !form.program) {
      alert("Please fill all required fields.");
      return;
    }
    setLoading(true);
    const payload = {
      student_name: form.studentName,
      date_of_birth: form.dob || null,
      gender: form.gender || null,
      father_name: form.fatherName,
      father_phone: form.fatherPhone,
      father_cnic: form.fatherCnic || null,
      address: form.address || null,
      program_applied: form.program,
      previous_school: form.prevSchool || null,
      how_heard: form.howHeard || null,
      notes: form.notes || null,
      status: "pending",
      applied_at: new Date().toISOString()
    };
    const { error } = await supabase.from("admission_applications").insert([payload]);
    setLoading(false);
    if(error) {
      alert(error.message || "Submission failed. Please try again.");
      return;
    }
    setSubmitted(true);
  };

  const L = ({children}) => <div style={{ fontSize:11, fontWeight:700, color:"#374151", marginBottom:6 }}>{children}</div>;

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.76)", zIndex:9999, display:"flex", alignItems:"center", justifyContent:"center", padding:16, backdropFilter:"blur(8px)", overflowY:"auto" }} onClick={onClose}>
      <div style={{ background:"white", borderRadius:20, width:620, maxWidth:"100%", overflow:"hidden", boxShadow:"0 40px 100px rgba(0,0,0,0.45)", margin:"auto" }} onClick={e=>e.stopPropagation()}>
        <div style={{ background:grad, padding:"24px 28px", position:"relative" }}>
          <div style={{ fontSize:11, fontWeight:700, color:"rgba(255,255,255,0.72)", letterSpacing:2, textTransform:"uppercase", marginBottom:6 }}>Online Admission</div>
          <div style={{ fontSize:24, fontWeight:900, color:"white" }}>Apply Online for Admission</div>
          <button onClick={onClose} style={{ position:"absolute", top:16, right:16, background:"rgba(255,255,255,0.18)", color:"white", border:"none", borderRadius:8, width:34, height:34, fontSize:18, cursor:"pointer" }}>{'×'}</button>
        </div>

        {submitted ? (
          <div style={{ padding:"38px 32px", textAlign:"center" }}>
            <div style={{ fontSize:54, marginBottom:12 }}>{'✅'}</div>
            <div style={{ fontSize:24, fontWeight:900, color:G, marginBottom:10 }}>Application Received</div>
            <p style={{ fontSize:15, color:"#374151", lineHeight:1.8, maxWidth:480, margin:"0 auto 24px" }}>Your online admission form has been received successfully. Our team will review the details and contact you for the admission test. Submission stays in the admissions portal for staff review only.</p>
            <div style={{ background:CREAM, borderRadius:14, padding:"18px 20px", textAlign:"left", maxWidth:480, margin:"0 auto 24px", border:`1px solid ${G}14` }}>
              <div style={{ fontWeight:800, color:gradStart, marginBottom:8 }}>Next steps</div>
              {["Admission team reviews the application","Staff sees it in Admissions Received","Student is contacted for test/interview","After review, staff can accept or reject"].map((s,i)=>(<div key={i} style={{ display:"flex", gap:10, marginBottom:6, fontSize:13, color:"#374151" }}><span style={{ color:G, fontWeight:800 }}>{i+1}.</span><span>{s}</span></div>))}
            </div>
            <button onClick={onClose} style={{ background:grad, color:"white", border:"none", borderRadius:10, padding:"12px 28px", fontWeight:800, fontSize:14, cursor:"pointer" }}>Close</button>
          </div>
        ) : (
          <div style={{ padding:"28px 32px 32px" }}>
            <div style={{ display:"flex", gap:8, marginBottom:28 }}>
              {["Student","Guardian","Program"].map((s,i)=>(<div key={s} style={{ flex:1 }}><div style={{ height:4, borderRadius:2, background: step >= i+1 ? G : "#e5e7eb", marginBottom:6 }}/><div style={{ fontSize:11, fontWeight:700, color: step >= i+1 ? G : "#9ca3af", textAlign:"center" }}>{s}</div></div>))}
            </div>

            {step===1 && <div style={{ display:"grid", gap:16 }}>
              <div><L>Student Full Name *</L><input value={form.studentName} onChange={e=>set('studentName',e.target.value)} style={inputStyle} placeholder="Enter student's full name" /></div>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(200px, 1fr))", gap:16 }}>
                <div><L>Date of Birth</L><input type="date" value={form.dob} onChange={e=>set('dob',e.target.value)} style={inputStyle} /></div>
                <div><L>Gender</L><select value={form.gender} onChange={e=>set('gender',e.target.value)} style={inputStyle}><option value="">Select</option><option value="Male">Male</option><option value="Female">Female</option></select></div>
              </div>
              <div><L>Previous School</L><input value={form.prevSchool} onChange={e=>set('prevSchool',e.target.value)} style={inputStyle} placeholder="Previous school, if any" /></div>
            </div>}

            {step===2 && <div style={{ display:"grid", gap:16 }}>
              <div><L>Father / Guardian Name *</L><input value={form.fatherName} onChange={e=>set('fatherName',e.target.value)} style={inputStyle} placeholder="Guardian full name" /></div>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(200px, 1fr))", gap:16 }}>
                <div><L>Phone Number *</L><input value={form.fatherPhone} onChange={e=>set('fatherPhone',e.target.value)} style={inputStyle} placeholder="03xx-xxxxxxx" /></div>
                <div><L>CNIC</L><input value={form.fatherCnic} onChange={e=>set('fatherCnic',e.target.value)} style={inputStyle} placeholder="xxxxx-xxxxxxx-x" /></div>
              </div>
              <div><L>Address</L><textarea value={form.address} onChange={e=>set('address',e.target.value)} rows={3} style={{...inputStyle, resize:'vertical'}} placeholder="Village / city / full address" /></div>
            </div>}

            {step===3 && <div style={{ display:"grid", gap:16 }}>
              <div><L>Program Applying For *</L><select value={form.program} onChange={e=>set('program',e.target.value)} style={inputStyle}>
                <option value="">Select program</option>
                <option value="Pre-School">Pre-School</option>
                <option value="Primary School">Primary School</option>
                <option value="Middle School with Hifz">Middle School with Hifz</option>
                <option value="Regular Middle School">Regular Middle School</option>
                <option value="Secondary (9–10)">Secondary (9{'–'}10)</option>
                <option value="Higher Secondary">Higher Secondary</option>
              </select></div>
              <div style={{ background:"#f0fdf4", borderRadius:12, padding:"14px 16px", border:`1px solid ${G}20` }}>
                <div style={{ fontSize:13, fontWeight:800, color:gradStart, marginBottom:6 }}>Full Scholarship Opportunity</div>
                <div style={{ fontSize:12, color:"#374151", lineHeight:1.7 }}>Boarding with Hifz + School stream is fully scholarship based for deserving bright students. Only selected students are accepted after assessment.</div>
              </div>
              <div><L>How did you hear about us?</L><input value={form.howHeard} onChange={e=>set('howHeard',e.target.value)} style={inputStyle} placeholder="Friend, social media, visit, etc." /></div>
              <div><L>Additional Notes</L><textarea value={form.notes} onChange={e=>set('notes',e.target.value)} rows={3} style={{...inputStyle, resize:'vertical'}} placeholder="Anything you want us to know" /></div>
            </div>}

            <div style={{ display:"flex", justifyContent:"space-between", marginTop:26 }}>
              <button onClick={()=> step>1 ? setStep(step-1) : onClose()} style={{ background:"#f3f4f6", color:"#374151", border:"none", borderRadius:10, padding:"11px 20px", fontWeight:800, fontSize:14, cursor:"pointer" }}>{step>1 ? '← Back' : 'Cancel'}</button>
              {step<3 ? (
                <button onClick={()=>setStep(step+1)} style={{ background:grad, color:"white", border:"none", borderRadius:10, padding:"11px 22px", fontWeight:800, fontSize:14, cursor:"pointer" }}>Next {'→'}</button>
              ) : (
                <button onClick={submit} disabled={loading} style={{ background:loading?"#9ca3af":grad, color:"white", border:"none", borderRadius:10, padding:"11px 22px", fontWeight:800, fontSize:14, cursor:loading?"not-allowed":"pointer" }}>{loading ? 'Submitting…' : 'Submit Application'}</button>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ── MAIN PUBLIC SITE ──────────────────────────────────────────────
export default function PublicSite({ onLogin, settings: S, onPortalClick }) {
  const [page, setPage] = React.useState("home");
  const [showLogin, setShowLogin] = React.useState(false);
  const [progTab, setProgTab] = React.useState(0);
  const [mobileNav, setMobileNav] = React.useState(false);
  const [admissionFormOpen, setAdmissionFormOpen] = React.useState(false);
  const [lightbox, setLightbox] = React.useState(null);
  const [announcements, setAnnouncements] = React.useState([]);

  React.useEffect(()=>{
    supabase.from("announcements").select("*").eq("is_published",true).order("created_at",{ascending:false}).limit(6)
      .then(({data})=>{ if(data) setAnnouncements(data); });
  },[]);

  // ── LIGHTBOX ────────────────────────────────────────────────────
  const Lightbox = () => !lightbox ? null : (
    <div onClick={()=>setLightbox(null)} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.92)", zIndex:9999, display:"flex", alignItems:"center", justifyContent:"center", padding:16, cursor:"zoom-out" }}>
      <img src={lightbox} alt="" style={{ maxWidth:"95vw", maxHeight:"92vh", borderRadius:12, boxShadow:"0 24px 80px rgba(0,0,0,0.6)", objectFit:"contain" }}/>
      <button onClick={()=>setLightbox(null)} style={{ position:"absolute", top:20, right:24, background:"rgba(255,255,255,0.15)", color:"white", border:"none", borderRadius:8, width:40, height:40, fontSize:22, cursor:"pointer" }}>{'×'}</button>
    </div>
  );

  const gradStart = (S?.header_gradient||`${G},${GD}`).split(",")[0];
  const gradEnd   = (S?.header_gradient||`${G},${GD}`).split(",")[1]||GD;
  const accent    = S?.header_accent||GOLD;
  const schoolEn  = S?.school_name_en||"QUR'AN-E-KARIM ACADEMY";
  const schoolUr  = S?.school_name_ur||"قرآن کریم اکیڈمی";
  const address   = S?.address||"Gorsian, Devi Rd., Jatli, Dist. Rawalpindi";
  const affil     = S?.affiliation||"Registered with Wifaq-ul Madaris Al-Arabia Pakistan";
  const regNo     = S?.reg_no||"CMR-199/2015";
  const grad      = `linear-gradient(135deg,${gradStart},${gradEnd})`;

  // Define PROGRAMS here so all pages can access it to navigate
  const PROGRAMS = [
    { id:"preschool", label:"Pre-School",          icon:"🌱", color:TEAL },
    { id:"primary",   label:"Primary",             icon:"📚", color:gradStart },
    { id:"regular",   label:"Regular Middle",      icon:"📗", color:NAVY },
    { id:"hifz",      label:"Middle + Hifz",       icon:"📖", color:"#7c3aed" },
    { id:"secondary", label:"Secondary (9–10)",    icon:"🎓", color:"#d97706" },
    { id:"higher",    label:"Higher Secondary",    icon:"🏛️", color:"#e11d48" },
    { id:"nizami",    label:"Dars-e-Nizami",       icon:"☪️", color:"#7c3aed" },
    { id:"special",   label:"Beyond the Classroom",icon:"✨", color:"#0891b2" },
  ];

  const PAGES = ["home","about","programs","admissions","facilities","campus-life","activities","community","contact"];
  const NAV   = ["Home","About","Programs","Admissions","Facilities","Campus Life","Activities","Community","Contact"];

  const go = p => { setPage(p); setMobileNav(false); window.scrollTo({top:0,behavior:"smooth"}); };

  // ── NAV ──────────────────────────────────────────────────────────
  const Nav = () => (
    <nav style={{ position:"sticky", top:0, zIndex:200, background:"rgba(255,255,255,0.97)", backdropFilter:"blur(12px)", borderBottom:`1px solid ${G}18`, boxShadow:`0 2px 24px ${G}10` }}>
      <style>{`
        @media(max-width:768px){
          .qka-desk-nav{display:none!important}
          .qka-mob-btn{display:flex!important}
          .qka-mob-menu{display:block!important}
          .qka-photo-strip{grid-template-columns:1fr 1fr!important;height:auto!important}
          .qka-photo-strip>div{height:160px!important}
          .qka-strip-4{grid-template-columns:1fr 1fr!important;height:auto!important}
          .qka-strip-4>div{height:130px!important}
          .qka-hero-stats{position:absolute;bottom:0;left:0;right:0;zIndex:4}
          @media(max-width:768px){
            .qka-hero{overflow:visible!important;height:auto!important;min-height:500px!important;padding-bottom:0!important}
            .qka-hero-stats{position:relative!important;bottom:auto!important;margin-top:auto}
            .qka-2col{grid-template-columns:1fr!important}
            .qka-pre-grid{grid-template-columns:1fr 1fr!important}
          }
          .qka-section-pad{padding:44px 0!important}
          .qka-container{padding:0 16px!important}
          .qka-login-btn{font-size:11px!important;padding:7px 12px!important}
        }
        @media(min-width:769px){
          .qka-mob-btn{display:none!important}
          .qka-mob-menu{display:none!important}
        }
      `}</style>
      <Container style={{ height:64, display:"flex", alignItems:"center", gap:8 }}>
        <button onClick={()=>go("home")} style={{ display:"flex", alignItems:"center", gap:10, background:"none", border:"none", cursor:"pointer", padding:0, flexShrink:0 }}>
          <img src="/Transparent Logo.png" alt="QKA Logo" style={{ width:42, height:42, objectFit:"contain" }}/>
          <div style={{ textAlign:"left" }}>
            <div style={{ fontSize:12, fontWeight:900, color:gradStart, lineHeight:1 }}>QK ACADEMY</div>
            <div style={{ fontSize:9, color:"#9ca3af", lineHeight:1, marginTop:1 }}>Islamic School System</div>
          </div>
        </button>
        {/* Desktop nav */}
        <div className="qka-desk-nav" style={{ display:"flex", gap:0, flex:1, justifyContent:"center", flexWrap:"nowrap", overflow:"hidden" }}>
          {PAGES.map((p,i) => (
            <button key={p} onClick={()=>go(p)}
              style={{ background:page===p?`${gradStart}12`:"transparent", color:page===p?gradStart:"#6b7280", border:"none", borderRadius:8, padding:"7px 10px", fontWeight:700, fontSize:11.5, cursor:"pointer", transition:"all .15s", whiteSpace:"nowrap" }}>
              {NAV[i]}
            </button>
          ))}
        </div>
        <div style={{ flexShrink:0, marginLeft:"auto", display:"flex", alignItems:"center", gap:8 }}>
          <button className="qka-login-btn" onClick={()=>{ if(onPortalClick) onPortalClick(); else setShowLogin(true); }}
            style={{ background:grad, color:"white", border:"none", borderRadius:9, padding:"9px 18px", fontWeight:800, fontSize:12, cursor:"pointer", boxShadow:`0 2px 14px ${gradStart}40`, whiteSpace:"nowrap" }}>
            Staff Portal
          </button>
          {/* Hamburger */}
          <button className="qka-mob-btn" onClick={()=>setMobileNav(v=>!v)}
            style={{ display:"none", flexDirection:"column", gap:5, background:"none", border:`1.5px solid ${G}30`, borderRadius:8, padding:"8px 10px", cursor:"pointer" }}>
            <span style={{ display:"block", width:20, height:2, background:gradStart, borderRadius:2, transition:"all .2s" }}/>
            <span style={{ display:"block", width:20, height:2, background:gradStart, borderRadius:2, transition:"all .2s" }}/>
            <span style={{ display:"block", width:14, height:2, background:gradStart, borderRadius:2, transition:"all .2s" }}/>
          </button>
        </div>
      </Container>
      {/* Mobile dropdown menu */}
      {mobileNav && (
        <div style={{ background:"white", borderTop:`1px solid ${G}15`, padding:"8px 0 16px" }}>
          {PAGES.map((p,i)=>(
            <button key={p} onClick={()=>{ go(p); setMobileNav(false); }}
              style={{ display:"block", width:"100%", textAlign:"left", background:page===p?`${gradStart}10`:"transparent", color:page===p?gradStart:"#374151", border:"none", padding:"12px 24px", fontWeight:700, fontSize:14, cursor:"pointer", borderLeft:page===p?`3px solid ${gradStart}`:"3px solid transparent" }}>
              {NAV[i]}
            </button>
          ))}
        </div>
      )}
    </nav>
  );

  // ── HOME ─────────────────────────────────────────────────────────
  const Home = () => (
    <div>
      {/* Hero */}
      <div className="qka-hero" style={{ position:"relative", height:"92vh", minHeight:560, overflow:"hidden" }}>
        <img src={CAMPUS_COURTYARD} alt="QKA Campus" style={{ position:"absolute", inset:0, width:"100%", height:"100%", objectFit:"cover", objectPosition:"center 40%", zIndex:0 }}/>
        <div style={{ position:"absolute", inset:0, background:`linear-gradient(135deg,${gradStart}e0 0%,${gradStart}95 45%,${GD}b0 100%)`, zIndex:1 }}/>
        <div style={{ position:"absolute", top:0, right:0, width:"45%", height:"100%", background:`linear-gradient(135deg,${gradStart}00,${accent}18)`, zIndex:2, clipPath:"polygon(20% 0,100% 0,100% 100%,0 100%)" }}/>
        <div style={{ position:"absolute", bottom:0, left:0, right:0, height:160, background:`linear-gradient(to top,rgba(0,0,0,0.3),transparent)`, zIndex:2 }}/>

        <div style={{ position:"relative", zIndex:3, minHeight:480, display:"flex", alignItems:"center", paddingTop:80, paddingBottom:24 }}>
          <Container>
            <div style={{ maxWidth:680 }}>
              <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:20 }}>
                <div style={{ width:40, height:2, background:accent }}/>
                <span style={{ fontSize:"clamp(9px,2vw,12px)", fontWeight:700, color:accent, letterSpacing:2, textTransform:"uppercase" }}>Established 2000 {'·'} Gorsian, Jatli</span>
              </div>
              <div style={{ fontFamily:"'Noto Nastaliq Urdu',serif", fontSize:"clamp(14px,4vw,18px)", color:"rgba(255,255,255,0.75)", marginBottom:12, lineHeight:2 }}>
                {'بِسْمِ'} {'اللَّهِ'} {'الرَّحْمَٰنِ'} {'الرَّحِيمِ'}
              </div>
              <h1 style={{ fontSize:"clamp(26px,6vw,62px)", fontWeight:900, color:"white", lineHeight:1.1, margin:"0 0 10px", textShadow:`0 2px 20px ${GD}60` }}>
                {schoolEn}
              </h1>
              <div style={{ fontFamily:"'Noto Nastaliq Urdu',serif", fontSize:"clamp(18px,5vw,28px)", color:"rgba(255,255,255,0.88)", marginBottom:20, lineHeight:1.8, textShadow:`0 2px 8px ${GD}40` }}>
                {schoolUr}
              </div>
              <div style={{ width:64, height:4, background:accent, borderRadius:2, marginBottom:24 }}/>
              <p style={{ fontSize:"clamp(13px,2.5vw,17px)", color:"rgba(255,255,255,0.82)", lineHeight:1.8, marginBottom:36, maxWidth:520 }}>
                Nation and Human development through the principles of Quranic Sciences and state of the art modern science and technological development.
              </p>
              <div style={{ display:"flex", gap:14, flexWrap:"wrap", marginBottom:8 }}>
                <button onClick={()=>go("programs")}
                  style={{ background:"white", color:gradStart, border:"none", borderRadius:10, padding:"14px 32px", fontWeight:800, fontSize:14, cursor:"pointer", boxShadow:"0 4px 24px rgba(0,0,0,0.15)" }}>
                  Explore Programs
                </button>
                <button onClick={()=>setAdmissionFormOpen(true)}
                  style={{ background:"transparent", color:"white", border:"2px solid rgba(255,255,255,0.6)", borderRadius:10, padding:"14px 28px", fontWeight:700, fontSize:14, cursor:"pointer" }}>
                  Apply Now {'→'}
                </button>
              </div>
            </div>
          </Container>
        </div>

        {/* Floating stats */}
        <div className="qka-hero-stats" style={{ position:"absolute", bottom:0, left:0, right:0, zIndex:4 }}>
          <Container>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(130px, 1fr))", gap:1, background:"rgba(255,255,255,0.1)", backdropFilter:"blur(20px)", borderRadius:16, overflow:"hidden" }}>
              {[["25+","Years of Service"],["2000+","Total Graduates"],["300+","Students Enrolled"],["30+","Classrooms"]].map(([n,l])=>(
                <div key={l} style={{ padding:"18px 20px", textAlign:"center", borderRight:"1px solid rgba(255,255,255,0.1)" }}>
                  <div style={{ fontSize:28, fontWeight:900, color:"white" }}>{n}</div>
                  <div style={{ fontSize:11, color:"rgba(255,255,255,0.7)", marginTop:3 }}>{l}</div>
                </div>
              ))}
            </div>
          </Container>
        </div>
      </div>

      {/* Mission strip */}
      <div style={{ background:CREAM, padding:"24px 0", borderBottom:`1px solid ${G}18` }}>
        <Container>
          <div style={{ display:"flex", gap:32, alignItems:"center", flexWrap:"wrap" }}>
            <div style={{ fontFamily:"'Noto Nastaliq Urdu',serif", fontSize:17, color:gradStart, fontWeight:700, flex:"0 0 auto" }}>
              {'طَلَبُ'} {'الْعِلْمِ'} {'فَرِيضَةٌ'} {'عَلَى'} {'كُلِّ'} {'مُسْلِمٍ'}
            </div>
            <div style={{ width:1, height:32, background:`${G}30`, flex:"0 0 auto", display: ["none", "block"] }}/>
            <div style={{ fontSize:13, color:"#6b7280", fontStyle:"italic" }}>Seeking knowledge is an obligation upon every Muslim {'—'} Prophet Muhammad {'ﷺ'}</div>
          </div>
        </Container>
      </div>

      {/* News & Announcements */}
      {announcements.length > 0 && (
        <Section style={{ background:"white", borderBottom:`1px solid ${G}12` }}>
          <Container>
            <div style={{ display:"flex", alignItems:"flex-end", justifyContent:"space-between", marginBottom:36, flexWrap:"wrap", gap:16 }}>
              <div>
                <div style={{ display:'inline-flex', alignItems:'center', gap:8, background:`${G}10`, borderRadius:20, padding:'5px 16px', marginBottom:12 }}>
                  <span style={{ fontSize:16 }}>{'📢'}</span>
                  <span style={{ fontSize:14, fontWeight:800, color:gradStart, letterSpacing:1.5, textTransform:'uppercase' }}>What's Happening at QKA</span>
                </div>
                <H2 style={{ margin:0 }}>Latest News & Announcements</H2>
                <div style={{ width:48, height:3, background:gradStart, borderRadius:2, marginTop:10 }}/>
                <p style={{ fontSize:14, color:"#6b7280", marginTop:10, maxWidth:480 }}>Stay up to date with events, achievements and important notices from QKA.</p>
              </div>
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(260px,1fr))", gap:18 }}>
              {announcements.map(a=><AnnouncementCard key={a.id} a={a} gradStart={gradStart}/>)}
            </div>
          </Container>
        </Section>
      )}

      {/* Programs overview */}
      <Section style={{ background:"white" }}>
        <Container>
          <div style={{ textAlign:"center", marginBottom:56 }}>
            <Tag>Academic Programs</Tag>
            <H2>Three Pathways to Excellence</H2>
            <Divider/>
            <p style={{ fontSize:16, color:"#6b7280", maxWidth:560, margin:"0 auto" }}>
              From pre-school through higher secondary, we offer a complete Cambridge-aligned education woven with Quranic learning.
            </p>
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))", gap:24 }}>
            {[
              { icon:"🌱", title:"Pre-School & Primary", sub:"Playgroup → Class 5", color:TEAL, bg:"#f0fdfa", desc:"Cambridge curriculum with Norani Qaeda, Nazira, Islamic education and core subjects. Age 3–10.", tag:"Age 3–10 years", tabId:"preschool" },
              { icon:"📖", title:"Middle School with Hifz", sub:"Class 6 → 8", color:gradStart, bg:CREAM, desc:"Full Scholarship — only bright students accepted. Boarding, meals, uniforms and books provided free for selected students.", tag:"Full Scholarship · Selected Only", tabId:"hifz" },
              { icon:"🎓", title:"Secondary & Higher Secondary", sub:"Class 9 → FSc/FA/ICS", color:NAVY, bg:"#eff6ff", desc:"Affiliated with BISE Rawalpindi. Compulsory & elective subjects. Sciences, Arts and Computer groups.", tag:"New from 2025", tabId:"secondary" },
            ].map(p=>(
              <div key={p.title} style={{ background:p.bg, borderRadius:16, padding:"32px 28px", border:`1px solid ${p.color}18`, position:"relative", overflow:"hidden" }}>
                <div style={{ position:"absolute", top:-20, right:-20, width:100, height:100, borderRadius:"50%", background:`${p.color}08` }}/>
                <div style={{ fontSize:44, marginBottom:16 }}>{p.icon}</div>
                <div style={{ display:"inline-block", background:`${p.color}15`, color:p.color, borderRadius:20, padding:"3px 12px", fontSize:11, fontWeight:700, marginBottom:10 }}>{p.tag}</div>
                <h3 style={{ fontSize:20, fontWeight:800, color:p.color, margin:"0 0 4px" }}>{p.title}</h3>
                <div style={{ fontSize:13, color:"#9ca3af", marginBottom:12 }}>{p.sub}</div>
                <p style={{ fontSize:14, color:"#374151", lineHeight:1.7, margin:0 }}>{p.desc}</p>
                <button onClick={()=>{ go("programs"); setTimeout(()=>{ const idx = PROGRAMS.findIndex(x=>x.id===p.tabId); if(idx >= 0) setProgTab(idx); }, 50); }}
                  style={{ marginTop:20, background:"transparent", color:p.color, border:`1.5px solid ${p.color}40`, borderRadius:8, padding:"8px 18px", fontSize:12, fontWeight:700, cursor:"pointer" }}>
                  Learn more {'→'}
                </button>
              </div>
            ))}
          </div>
        </Container>
      </Section>

      {/* Why QKA */}
      <Section style={{ background:CREAM }}>
        <Container>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(300px, 1fr))", gap:64, alignItems:"center" }}>
            <div>
              <Tag>Why Choose QKA</Tag>
              <H2>State-of-the-Art Education Rooted in Islam</H2>
              <Divider/>
              <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
                {[
                  "Broad, balanced English-medium Cambridge curriculum",
                  "Creative and innovative teaching methods",
                  "Hifz and Tajweed program using modern technology",
                  "Full fee scholarships for bright students",
                  "Advisory council from UK, Canada, Saudi Arabia & Pakistan",
                  "Dedicated Technology Room with LCD screens",
                  "Computer lab, Library and Sports facilities",
                  "Monthly report cards signed by all teachers",
                  "Online portal for parents, teachers & staff — fully digitalized school management system",
                  "AI & modern skills courses integrated with traditional Islamic education",
                ].map(f=>(
                  <div key={f} style={{ display:"flex", gap:10, alignItems:"flex-start" }}>
                    <Check color={gradStart}/>
                    <span style={{ fontSize:14, color:"#374151", lineHeight:1.6 }}>{f}</span>
                  </div>
                ))}
              </div>
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(140px, 1fr))", gap:14 }}>
              {[
                { n:"1400+", l:"Hifz graduates", c:gradStart },
                { n:"400+", l:"Fashion & Design graduates", c:TEAL },
                { n:"45", l:"Dars-e-Nizami (Girls)", c:NAVY },
                { n:"Free", l:"Education, Hostel, Meals, Medical & Uniform", c:"#d97706" },
              ].map(k=>(
                <div key={k.l} style={{ background:"white", borderRadius:14, padding:"22px 18px", boxShadow:"0 2px 16px rgba(0,0,0,0.06)", border:`1px solid ${k.c}14` }}>
                  <div style={{ fontSize:32, fontWeight:900, color:k.c, lineHeight:1 }}>{k.n}</div>
                  <div style={{ fontSize:12, color:"#6b7280", marginTop:6, lineHeight:1.5 }}>{k.l}</div>
                </div>
              ))}
            </div>
          </div>
        </Container>
      </Section>

      {/* Campus photo strip */}
      <div className="qka-photo-strip" style={{ display:"grid", gridTemplateColumns:"repeat(4, 1fr)", height:300, overflow:"hidden" }}>
          <div style={{ overflow:"hidden", position:"relative", cursor:"zoom-in" }} onClick={()=>setLightbox(CAMPUS_1)}>
            <img src={CAMPUS_1} style={{ width:"100%", height:"100%", objectFit:"cover", objectPosition:"center 55%"}} alt="Campus"/>
            <div style={{ position:"absolute", inset:0, background:"rgba(0,0,0,0.25)" }}/>
            <div style={{ position:"absolute", bottom:16, left:20, color:"white", fontWeight:700, fontSize:13, textShadow:"0 1px 4px rgba(0,0,0,0.5)" }}>{'🏫'} Our Academy</div>
          </div>
          <div style={{ overflow:"hidden", position:"relative", cursor:"zoom-in" }} onClick={()=>setLightbox(EXT_SUNNY)}>
            <img src={EXT_SUNNY} style={{ width:"100%", height:"100%", objectFit:"cover", objectPosition:"center 35%"}} alt="Campus Exterior"/>
            <div style={{ position:"absolute", inset:0, background:"rgba(26,107,60,0.2)" }}/>
            <div style={{ position:"absolute", bottom:16, left:20, color:"white", fontWeight:700, fontSize:13, textShadow:"0 1px 4px rgba(0,0,0,0.5)" }}>{'🌿'} Campus Grounds</div>
          </div>
          <div style={{ overflow:"hidden", position:"relative", cursor:"zoom-in" }} onClick={()=>setLightbox(EXT_COURT)}>
            <img src={EXT_COURT} style={{ width:"100%", height:"100%", objectFit:"cover", objectPosition:"center 40%"}} alt="Campus Court"/>
            <div style={{ position:"absolute", inset:0, background:"rgba(8,145,178,0.2)" }}/>
            <div style={{ position:"absolute", bottom:16, left:20, color:"white", fontWeight:700, fontSize:13, textShadow:"0 1px 4px rgba(0,0,0,0.5)" }}>{'🏛️'} Academy Courtyard</div>
          </div>
          <div style={{ overflow:"hidden", position:"relative", cursor:"zoom-in" }} onClick={()=>setLightbox(ACADEMY_BEAUTIFUL_1)}>
            <img src={ACADEMY_BEAUTIFUL_1} style={{ width:"100%", height:"100%", objectFit:"cover", objectPosition:"center 30%"}} alt="Academy"/>
            <div style={{ position:"absolute", inset:0, background:"rgba(30,58,95,0.25)" }}/>
            <div style={{ position:"absolute", bottom:16, left:20, color:"white", fontWeight:700, fontSize:13, textShadow:"0 1px 4px rgba(0,0,0,0.5)" }}>{'✨'} Beautiful Campus</div>
          </div>
        </div>

      {/* Free facilities strip */}
      <Section style={{ position:"relative", overflow:"hidden" }}>
        <img src={EXT_GARDEN} alt="" style={{ position:"absolute", inset:0, width:"100%", height:"100%", objectFit:"cover", objectPosition:"center 50%", zIndex:0 }}/>
        <div style={{ position:"absolute", inset:0, background:`linear-gradient(135deg,${gradStart}f2,${GD}e8)`, zIndex:1 }}/>
        <Container style={{ position:"relative", zIndex:2 }}>
          <div style={{ textAlign:"center", marginBottom:40 }}>
            <div style={{ fontSize:12, fontWeight:700, color:"rgba(255,255,255,0.7)", letterSpacing:2, textTransform:"uppercase", marginBottom:8 }}>For Deserving Students</div>
            <h2 style={{ fontSize:32, fontWeight:900, color:"white", margin:"0 0 12px" }}>Everything Free of Cost</h2>
            <p style={{ color:"rgba(255,255,255,0.8)", fontSize:15 }}>So children from every background can access quality Islamic education</p>
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(150px, 1fr))", gap:16 }}>
            {[["🏫","Education","Full Islamic & school education"],["🏠","Boarding","Separate hostel for boys & girls"],["👕","Uniform","Free uniforms provided as needed"],["🏥","Medical","Free checkup & medicines"],["🍽️","3 Meals","Daily meals & milk included"]].map(([i,t,d])=>(
              <div key={t} style={{ background:"rgba(255,255,255,0.1)", borderRadius:12, padding:"20px 14px", textAlign:"center", border:"1px solid rgba(255,255,255,0.15)" }}>
                <div style={{ fontSize:32, marginBottom:8 }}>{i}</div>
                <div style={{ fontWeight:800, color:"white", fontSize:13, marginBottom:4 }}>{t}</div>
                <div style={{ fontSize:11, color:"rgba(255,255,255,0.7)", lineHeight:1.5 }}>{d}</div>
              </div>
            ))}
          </div>
        </Container>
      </Section>

      {/* Campus photo */}
      <Section style={{ background:"white" }}>
        <Container>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(300px, 1fr))", gap:48, alignItems:"center" }}>
            <div>
              {/* Big hero photo */}
              <div style={{ borderRadius:20, overflow:"hidden", boxShadow:"0 8px 48px rgba(0,0,0,0.15)", position:"relative", marginBottom:10 }}>
                <img src={CAMPUS_AERIAL} style={{ width:"100%", height:"260px", objectFit:"cover", objectPosition:"center 55%", display:"block" }} alt="QKA Campus"/>
                <div style={{ position:"absolute", bottom:14, left:14, background:grad, borderRadius:10, padding:"7px 14px" }}>
                  <div style={{ color:"white", fontSize:11, fontWeight:700 }}>Gorsian, Jatli {'—'} Est. 2000</div>
                </div>
              </div>
              {/* 3 smaller photos */}
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:10 }}>
                <div style={{ borderRadius:12, overflow:"hidden", boxShadow:"0 3px 14px rgba(0,0,0,0.1)", cursor:"zoom-in" }} onClick={()=>setLightbox(CORRIDOR)}>
                  <img src={CORRIDOR} style={{ width:"100%", height:110, objectFit:"cover", objectPosition:"center 40%", display:"block" }} alt="Corridor"/>
                </div>
                <div style={{ borderRadius:12, overflow:"hidden", boxShadow:"0 3px 14px rgba(0,0,0,0.1)", cursor:"zoom-in" }} onClick={()=>setLightbox(CORR_GIRLS)}>
                  <img src={CORR_GIRLS} style={{ width:"100%", height:110, objectFit:"cover", objectPosition:"center 30%", display:"block" }} alt="Girls Corridor"/>
                </div>
                <div style={{ borderRadius:12, overflow:"hidden", boxShadow:"0 3px 14px rgba(0,0,0,0.1)", cursor:"zoom-in" }} onClick={()=>setLightbox(CLASS_SM)}>
                  <img src={CLASS_SM} style={{ width:"100%", height:110, objectFit:"cover", objectPosition:"center 35%", display:"block" }} alt="Classroom"/>
                </div>
              </div>
            </div>
            <div>
              <Tag>Our Campus</Tag>
              <H2>A Peaceful Place Built for Learning</H2>
              <Divider/>
              <p style={{ fontSize:15, color:"#6b7280", lineHeight:1.8, marginBottom:20 }}>
                Located in Gorsian, Jatli {'—'} our two-storey campus features traditional Islamic architecture with pointed arches, a spacious green courtyard, and a 3000-capacity Jamia Masjid. A calm, focused environment for Deen and Duniya.
              </p>
              <div style={{ display:"flex", gap:10, flexWrap:"wrap" }}>
                {["Spacious Classrooms","Green Courtyard","Boarding for Boys & Girls","Jamia Masjid (3000 capacity)","Computer Lab","Sports Ground"].map(f=>(
                  <span key={f} style={{ background:CREAM, color:gradStart, borderRadius:20, padding:"5px 14px", fontSize:12, fontWeight:600, border:`1px solid ${G}20` }}>{'✓'} {f}</span>
                ))}
              </div>
            </div>
          </div>
        </Container>
      </Section>

      {/* CTA */}
      <div style={{ position:"relative", padding:"64px 24px", textAlign:"center", overflow:"hidden" }}>
        <img src={BOARDING_CAMPUS} alt="" style={{ position:"absolute", inset:0, width:"100%", height:"100%", objectFit:"cover", objectPosition:"center 40%", zIndex:0 }}/>
        <div style={{ position:"absolute", inset:0, background:"rgba(253,248,240,0.93)", zIndex:1 }}/>
        <div style={{ maxWidth:600, margin:"0 auto", position:"relative", zIndex:2 }}>
          <div style={{ fontFamily:"'Noto Nastaliq Urdu',serif", fontSize:20, color:gradStart, marginBottom:16 }}>
            {'وَأَمَّا'} {'بِنِعْمَةِ'} {'رَبِّكَ'} {'فَحَدِّثْ'}
          </div>
          <h2 style={{ fontSize:30, fontWeight:900, color:"#1a1a1a", margin:"0 0 12px" }}>Admissions Open for 2025{'–'}2026</h2>
          <p style={{ fontSize:15, color:"#6b7280", marginBottom:28 }}>Classes start 1st March. Limited seats available {'—'} first come, first served.</p>
          <div style={{ display:"flex", gap:14, justifyContent:"center", flexWrap:"wrap" }}>
            <button onClick={()=>setAdmissionFormOpen(true)} style={{ background:grad, color:"white", border:"none", borderRadius:10, padding:"13px 28px", fontWeight:800, fontSize:14, cursor:"pointer" }}>Apply Online for Admission</button>
            <button onClick={()=>go("contact")} style={{ background:"white", color:gradStart, border:`2px solid ${G}30`, borderRadius:10, padding:"13px 24px", fontWeight:700, fontSize:14, cursor:"pointer" }}>Contact Us</button>
          </div>
        </div>
      </div>

    </div>
  );

  // ── ABOUT ─────────────────────────────────────────────────────────
  const About = () => (
    <div>
      {/* Hero */}
      <div style={{ position:"relative", padding:"72px 0 60px", overflow:"hidden" }}>
        <img src={EXT_SUNNY} alt="QKA" style={{ position:"absolute", inset:0, width:"100%", height:"100%", objectFit:"cover", objectPosition:"center 30%", zIndex:0 }}/>
        <div style={{ position:"absolute", inset:0, background:`linear-gradient(135deg,${gradStart}e8,${GD}cc)`, zIndex:1 }}/>
        <Container style={{ position:"relative", zIndex:2 }}>
          <Tag color="rgba(255,255,255,0.7)">Who We Are</Tag>
          <h1 style={{ fontSize:"clamp(28px,5vw,48px)", fontWeight:900, color:"white", margin:"0 0 16px", maxWidth:640 }}>25 Years of Nurturing Minds & Hearts</h1>
          <p style={{ fontSize:16, color:"rgba(255,255,255,0.8)", maxWidth:600, lineHeight:1.8 }}>
            Quran Karim Academy (Waqf) Pakistan {'—'} established September 2000 in Gorsian village, near Chakwal Rawalpindi. A journey from a small institution to a world-class Islamic school system.
          </p>
        </Container>
      </div>

      {/* Founder message */}
      <Section style={{ background:"white" }}>
        <Container>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(300px, 1fr))", gap:56, alignItems:"start" }}>
            <div>
              <Tag>Message from the Founder</Tag>
              <H2>A Letter to Parents</H2>
              <Divider/>
              <div style={{ fontSize:14, color:"#374151", lineHeight:1.9, fontStyle:"italic", borderLeft:`3px solid ${gradStart}`, paddingLeft:20, marginBottom:28 }}>
                "It gives me immense pleasure to welcome you. QKA offers a complete career path to children, ensuring their full mental and physical growth to play a leading role with Islamic philosophy and global competencies. We have developed a broad, balanced and exciting curriculum. Our committed teachers give each child education in an innovative way."
              </div>
              <div style={{ display:"flex", alignItems:"center", gap:20, background:CREAM, borderRadius:16, padding:"20px 22px", border:`1px solid ${G}20` }}>
                <img src={DR_HAFIZ} alt="Dr. Hafiz Muhammad Afzal" style={{ width:130, height:130, borderRadius:16, objectFit:"cover", objectPosition:"center top", border:`3px solid ${G}`, flexShrink:0 }}/>
                <div>
                  <div style={{ fontSize:17, fontWeight:900, color:"#1a1a1a" }}>Dr. Hafiz Muhammad Afzal</div>
                  <div style={{ fontSize:13, color:G, fontWeight:700, marginTop:3 }}>Founder & President {'—'} QKA</div>
                  <div style={{ fontSize:12, color:"#6b7280", marginTop:2 }}>Professor of Quranic Sciences<br/>King Fahd University of Petroleum & Minerals, Dhahran, Saudi Arabia</div>
                </div>
              </div>
            </div>
            <div>
              <Tag>Message from Head Teacher</Tag>
              <H2 style={{ fontSize:24 }}>To Our Parents</H2>
              <Divider/>
              <p style={{ fontSize:14, color:"#374151", lineHeight:1.9, marginBottom:16 }}>
                At QKA, both parents and children experience the most wonderful growth in their love for the Quran and Deen. Such a perfect educational environment is exceptional, well valued, and rewarded. We try to go above and beyond to make our school a world class institution.
              </p>
              <p style={{ fontSize:14, color:"#374151", lineHeight:1.9 }}>
                Currently, QKA offers three academic programs including Pre-School, Primary School and Middle School. The primary curriculum is based on the Cambridge curriculum, contextualized to our local needs, taught in English with the exception of language and Islamic education classes.
              </p>
              <div style={{ marginTop:20, display:"flex", alignItems:"center", gap:16, background:CREAM, borderRadius:14, padding:"16px 18px", border:`1px solid ${G}20` }}>
                <div style={{ width:64, height:64, borderRadius:"50%", background:`linear-gradient(135deg,${gradStart}22,${GD}11)`, border:`2px solid ${gradStart}30`, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, overflow:"hidden" }}>
                  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="18" cy="14" r="7" fill={`${gradStart}50`}/>
                    <ellipse cx="18" cy="32" rx="12" ry="8" fill={`${gradStart}50`}/>
                  </svg>
                </div>
                <div>
                  <div style={{ fontSize:15, fontWeight:900, color:"#1a1a1a" }}>Head Teacher</div>
                  <div style={{ fontSize:12, color:G, fontWeight:700, marginTop:2 }}>QKA Islamic School System</div>
                  <div style={{ fontSize:12, color:"#9ca3af", marginTop:1 }}>Leading academic excellence at QKA</div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </Section>

      {/* Vision & Mission */}
      <Section style={{ background:CREAM }}>
        <Container>
          <div style={{ textAlign:"center", marginBottom:48 }}>
            <Tag>Our Purpose</Tag>
            <H2>Vision & Mission</H2>
            <Divider/>
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(300px, 1fr))", gap:32 }}>
            <div style={{ background:"white", borderRadius:16, padding:"36px 32px", boxShadow:"0 2px 20px rgba(0,0,0,0.06)", border:`1px solid ${G}14` }}>
              <div style={{ fontSize:36, marginBottom:16 }}>{'🌟'}</div>
              <h3 style={{ fontSize:20, fontWeight:800, color:gradStart, marginBottom:12 }}>Our Vision</h3>
              <p style={{ fontSize:15, color:"#374151", lineHeight:1.9, fontWeight:500 }}>
                Nation and Human development through the principles of Quranic Sciences and state of the art modern sciences and technological developments.
              </p>
            </div>
            <div style={{ background:grad, borderRadius:16, padding:"36px 32px" }}>
              <div style={{ fontSize:36, marginBottom:16 }}>{'🎯'}</div>
              <h3 style={{ fontSize:20, fontWeight:800, color:"white", marginBottom:16 }}>Our Mission</h3>
              {["To present the fundamental and authentic knowledge of the Quran and Sunnah","Provide quality education which strikes a balance between religious and academic learning","To produce individuals with strong Islamic morals and excellent leadership skills"].map((m,i)=>(
                <div key={i} style={{ display:"flex", gap:12, marginBottom:14 }}>
                  <div style={{ width:24, height:24, borderRadius:"50%", background:"rgba(255,255,255,0.2)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:11, fontWeight:800, color:"white", flexShrink:0 }}>{i+1}</div>
                  <span style={{ fontSize:14, color:"rgba(255,255,255,0.9)", lineHeight:1.7 }}>{m}</span>
                </div>
              ))}
            </div>
          </div>
        </Container>
      </Section>

      {/* Advisory Council */}
      <Section style={{ background:"white" }}>
        <Container>
          <div style={{ textAlign:"center", marginBottom:48 }}>
            <Tag>Global Leadership</Tag>
            <H2>Advisory Council</H2>
            <Divider/>
            <p style={{ fontSize:15, color:"#6b7280", maxWidth:600, margin:"0 auto" }}>
              Renowned academics, educationists, scientists and technological leaders from UK, Canada, Saudi Arabia, UAE and Pakistan.
            </p>
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(220px,1fr))", gap:20, marginBottom:40 }}>
            {[
              { n:"Dr. Khadim Hussain", r:"(R) Scientist, Saudi Aramco, Saudi Arabia" },
              { n:"Dr. Ashfaq Bukhari", r:"Professor of Mathematics, King Fahd University · Head of Math, Namal University" },
              { n:"Dr. Anwar Hamid", r:"Manager & Scientist, Centre for Engineering Research, King Fahd University" },
              { n:"Dr. Muhammad Arsalan", r:"Lead Scientist, Aramco, Saudi Arabia" },
              { n:"Dr. Salman Khan", r:"Professor, Karachi Institute of Economics and Technology, Pakistan" },
            ].map(p=>(
              <div key={p.n} style={{ background:CREAM, borderRadius:14, padding:"22px 20px", border:`1px solid ${G}12` }}>
                <div style={{ width:44, height:44, borderRadius:"50%", background:grad, display:"flex", alignItems:"center", justifyContent:"center", marginBottom:12 }}>
                  <span style={{ color:"white", fontWeight:900, fontSize:14 }}>{p.n.split(" ").map(w=>w[0]).slice(0,2).join("")}</span>
                </div>
                <div style={{ fontSize:13, fontWeight:800, color:"#1a1a1a", marginBottom:5 }}>{p.n}</div>
                <div style={{ fontSize:11, color:"#6b7280", lineHeight:1.6 }}>{p.r}</div>
              </div>
            ))}
          </div>

          {/* Management Council */}
          <div style={{ background:NAVY, borderRadius:16, padding:"36px 32px" }}>
            <h3 style={{ fontSize:20, fontWeight:800, color:"white", marginBottom:6 }}>Management Council</h3>
            <p style={{ fontSize:13, color:"rgba(255,255,255,0.65)", marginBottom:28 }}>Implementing strategy with expertise from Saudi Arabia and UK</p>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(240px,1fr))", gap:20 }}>
              {[
                { n:"Dr. Hafiz Muhammad Afzal", r:"President · Professor of Quranic Sciences, King Fahd University of Petroleum & Minerals, Saudi Arabia" },
                { n:"Dr. Muhammad Akram", r:"Academic Affairs · Professor of Business Management, University of Abertay, Scotland, UK" },
                { n:"Abdul Aziz Afzal, BSc/MSc Eng.", r:"Operations · Lecturer of Mechanical Engineering, Prince Mohamed bin Fahd University, Saudi Arabia" },
                { n:"Abdul Rahman Afzal, BSc/MSc Eng.", r:"Faculty & Consultant, Industrial Engineering · King Fahd University of Petroleum & Minerals, Saudi Arabia" },
                { n:"Muhammad Akmal, MBA", r:"Director of Administration & Community Relations · Overseeing institutional operations, community engagement and strategic development" },
              ].map(m=>(
                <div key={m.n} style={{ background:"rgba(255,255,255,0.08)", borderRadius:12, padding:"18px 16px" }}>
                  <div style={{ fontSize:13, fontWeight:800, color:"white", marginBottom:4 }}>{m.n}</div>
                  <div style={{ fontSize:11, color:"rgba(255,255,255,0.6)", lineHeight:1.6 }}>{m.r}</div>
                </div>
              ))}
            </div>
          </div>
        </Container>
      </Section>

      {/* History timeline */}
      <Section style={{ background:CREAM }}>
        <Container style={{ maxWidth:760 }}>
          <div style={{ textAlign:"center", marginBottom:48 }}>
            <Tag>Our Journey</Tag>
            <H2>Background & History</H2>
            <Divider/>
          </div>
          {[
            { yr:"2000", t:"Founded", d:"Quran Karim Academy (Waqf) established in Gorsian village, near Chakwal Rawalpindi, in September 2000. First students enrolled in Hifz and Nazira programs." },
            { yr:"2000s", t:"Programs & Community Welfare", d:"• Middle School launched with compulsory Hifz\n• Aalima (Dars-e-Nizami) 6-year program for girls introduced\n• Dressmaking & Vocational Skills program started for women\n• Norani Qaeda and Nazira programs expanded\n• Al-Noor School established for Nursery and Pre-School students\n• Dars-e-Nizami for Women started\n• Jamia Masjid (3,000 capacity) constructed for the community\n• Clean water wells project initiated for four neighbouring villages" },
            { yr:"2010s", t:"Start of Hifz + School Stream", d:"• Integrated School + Hifz Stream launched for Grades 6, 7 and 8 — enabling students to complete Hifz alongside formal schooling\n• Boarding (Hostel) facilities established, providing a safe, disciplined and spiritually nurturing environment for out-of-village students\n• Technical and Skill-Based Courses introduced, including basic computing, tailoring and practical life-skills training" },
            { yr:"2020", t:"Modern Expansion", d:"• English-medium primary school launched with selective Cambridge & Oxford curriculum alongside internationally recognised Islamic education\n• New Computer Lab and Library added\n• Advisory Council formed with scholars from UK, Canada, Saudi Arabia and Pakistan\n• Integrated School + Hifz Stream further strengthened — students completing Hifz alongside school up to Class 8", img:HIFZ_GRAD, cap:"Dr. Hafiz Muhammad Afzal presenting awards to graduating students" },
            { yr:"2023", t:"Technology & Growth", d:"• Technology Room and Science Lab added\n• Nursery and Montessori started officially with an active, learning-focused curriculum\n• Teacher training programmes conducted regularly\n• Short courses delivered via Technology Room — AI and Engineering courses by international faculty (online)\n• Several creative and life-skills based short courses introduced for students" },
            { yr:"2025+", t:"Growing Strong", d:"• Launch of Secondary (Class 9–10, BISE Rawalpindi) and Higher Secondary (FSc/FA/ICS) programmes\n• Real Community Impact Projects — Summer initiatives where students work on genuine local challenges, applying Islamic values and practical problem-solving to benefit surrounding villages\n• Skill-Based Learning Expansion — Technology, vocational and Quranic programmes enhanced to prepare students for real-world needs" },
          ].map((e,i)=>(
            <div key={i} style={{ display:"flex", gap:24, marginBottom:i<6?32:0 }}>
              <div style={{ display:"flex", flexDirection:"column", alignItems:"center" }}>
                <div style={{ width:48, height:48, borderRadius:"50%", background:i===6?grad:`${G}15`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:11, fontWeight:800, color:i===6?"white":gradStart, flexShrink:0 }}>{e.yr}</div>
                {i<6 && <div style={{ width:2, flex:1, background:`${G}20`, margin:"8px 0" }}/>}
              </div>
              <div style={{ paddingTop:12 }}>
                <div style={{ fontSize:16, fontWeight:800, color:"#1a1a1a", marginBottom:8 }}>{e.t}</div>
                <div style={{ fontSize:13, color:"#4b5563", lineHeight:1.9 }}>
                  {e.d.split('\n').map((line,li)=>(
                    <div key={li} style={{ display:"flex", gap:8, marginBottom:4 }}>
                      {line.startsWith('•') ? <span style={{ color:gradStart, fontWeight:700, flexShrink:0 }}>•</span> : null}
                      <span style={{ fontWeight:line.startsWith('•')?500:400 }}>{line.startsWith('•')?line.slice(2):line}</span>
                    </div>
                  ))}
                </div>
                {e.img && <div style={{ marginTop:14, maxWidth:340 }}>
                  <div style={{ borderRadius:12, overflow:"hidden" }}><img src={e.img} style={{ width:"100%", height:"180px", objectFit:"cover", objectPosition:"center 30%", display:"block" }} alt={e.t}/></div>
                  {e.cap && <div style={{ fontSize:12, color:"#6b7280", textAlign:"center", marginTop:6, fontStyle:"italic" }}>{e.cap}</div>}
                </div>}
              </div>
            </div>
          ))}
          {/* Graduates table */}
          <div style={{ background:grad, borderRadius:16, padding:"32px", marginTop:40 }}>
            <div style={{ fontWeight:800, fontSize:17, color:"white", marginBottom:6 }}>{'🎓'} Students Graduated Since Inception</div>
            <div style={{ fontSize:13, color:"rgba(255,255,255,0.7)", marginBottom:20 }}>Estimated figures {'—'} as of 2025</div>
            <div style={{ overflowX: "auto" }}>
              <table style={{ width:"100%", borderCollapse:"collapse", fontSize:14 }}>
                <tbody>
                  {[
                    ["Hifz + School / Wifaq graduates (Boys & Girls)","1,400+"],
                    ["Fashion & Design course graduates (Girls)","400+"],
                    ["Dars-e-Nizami (Aalima) graduates (Girls)","200+"],
                  ].map(([l,n],i)=>(
                    <tr key={i} style={{ borderBottom:"1px solid rgba(255,255,255,0.15)" }}>
                      <td style={{ padding:"13px 18px", color:"rgba(255,255,255,0.85)" }}>{l}</td>
                      <td style={{ padding:"13px 18px", textAlign:"right", fontWeight:900, fontSize:22, color:"white" }}>{n}</td>
                    </tr>
                  ))}
                  <tr style={{ background:"rgba(255,255,255,0.12)" }}>
                    <td style={{ padding:"16px 18px", color:"white", fontWeight:800, fontSize:15 }}>Total ~ Graduates</td>
                    <td style={{ padding:"16px 18px", textAlign:"right", fontWeight:900, fontSize:28, color:GOLD }}>2,000+</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Container>
      </Section>

      {/* Affiliations & Recognition */}
      <Section style={{ background:CREAM }}>
        <Container>
          <Tag>Official Recognition</Tag>
          <H2>Affiliations & Accreditations</H2>
          <Divider/>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))", gap:20 }}>
            <div style={{ background:"white", borderRadius:16, padding:"24px", border:`1px solid ${G}20`, boxShadow:"0 2px 12px rgba(0,0,0,0.04)" }}>
              <div style={{ fontSize:32, marginBottom:12 }}>{'📜'}</div>
              <div style={{ fontWeight:800, color:gradStart, fontSize:15, marginBottom:6 }}>Wifaq-ul Madaris Al-Arabia Pakistan</div>
              <div style={{ fontSize:13, color:"#6b7280", lineHeight:1.7, marginBottom:8 }}>Registered and affiliated with Wifaq-ul Madaris Al-Arabia Pakistan {'—'} the leading Islamic education board in Pakistan.</div>
              <div style={{ fontSize:12, fontWeight:700, color:gradStart }}>Reg. No: {regNo}</div>
            </div>
            <div style={{ background:"white", borderRadius:16, padding:"24px", border:"1px solid #d9770620", boxShadow:"0 2px 12px rgba(0,0,0,0.04)" }}>
              <div style={{ fontSize:32, marginBottom:12 }}>{'🏛️'}</div>
              <div style={{ fontWeight:800, color:"#d97706", fontSize:15, marginBottom:6 }}>BISE Rawalpindi</div>
              <div style={{ fontSize:13, color:"#6b7280", lineHeight:1.7, marginBottom:8 }}>Affiliated with the Board of Intermediate and Secondary Education (BISE) Rawalpindi for Secondary (Class 9{'–'}10) and Higher Secondary (Class 11{'–'}12) programmes.</div>
              <div style={{ fontSize:12, fontWeight:700, color:"#d97706" }}>Affiliation confirmed {'·'} License details to follow</div>
            </div>
            <div style={{ background:"white", borderRadius:16, padding:"24px", border:`1px solid ${TEAL}20`, boxShadow:"0 2px 12px rgba(0,0,0,0.04)" }}>
              <div style={{ fontSize:32, marginBottom:12 }}>{'🌍'}</div>
              <div style={{ fontWeight:800, color:TEAL, fontSize:15, marginBottom:6 }}>International Advisory Council</div>
              <div style={{ fontSize:13, color:"#6b7280", lineHeight:1.7 }}>Guided by an advisory council of scholars and educators from the UK, Canada, Saudi Arabia and Pakistan {'—'} bringing global perspective to local education.</div>
            </div>
          </div>
        </Container>
      </Section>

    </div>
  );

  // ── PROGRAMS ──────────────────────────────────────────────────────
  const ProgHero = ({ img, color, title, subtitle, tags, pos="center 35%" }) => (
    <div style={{ position:"relative", height:300, overflow:"hidden", borderRadius:16, marginBottom:32 }}>
      <img src={img} style={{ position:"absolute", inset:0, width:"100%", height:"100%", objectFit:"cover", objectPosition:pos }} alt={title}/>
      <div style={{ position:"absolute", inset:0, background:`linear-gradient(105deg,${color}f0 0%,${color}a0 55%,rgba(0,0,0,0.25) 100%)` }}/>
      <div style={{ position:"absolute", inset:0, display:"flex", flexDirection:"column", justifyContent:"flex-end", padding:"28px 32px" }}>
        <div style={{ fontSize:11, fontWeight:700, color:"rgba(255,255,255,0.7)", letterSpacing:2, textTransform:"uppercase", marginBottom:6 }}>{subtitle}</div>
        <div style={{ fontSize:"clamp(22px,4vw,36px)", fontWeight:900, color:"white", marginBottom:14, lineHeight:1.2 }}>{title}</div>
        <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
          {tags.map(t=><span key={t} style={{ background:"rgba(255,255,255,0.18)", backdropFilter:"blur(4px)", WebkitBackdropFilter:"blur(4px)", border:"1px solid rgba(255,255,255,0.3)", borderRadius:20, padding:"4px 12px", fontSize:11, fontWeight:700, color:"white" }}>{t}</span>)}
        </div>
      </div>
    </div>
  );

  const Programs = () => (
    <div>
      <div style={{ background:grad, padding:"64px 0 52px", position:"relative", overflow:"hidden" }}>
        <img src={CAMPUS_2} alt="QKA Programs" style={{ position:"absolute", inset:0, width:"100%", height:"100%", objectFit:"cover", objectPosition:"center 40%", zIndex:0 }}/>
        <div style={{ position:"absolute", inset:0, background:`linear-gradient(135deg,${gradStart}e8,${GD}cc)`, zIndex:1 }}/>
        <Container style={{ position:"relative", zIndex:2 }}>
          <Tag color="rgba(255,255,255,0.7)">Academic Programs</Tag>
          <h1 style={{ fontSize:"clamp(28px,5vw,46px)", fontWeight:900, color:"white", margin:"0 0 14px" }}>Our Complete Program Offering</h1>
          <p style={{ fontSize:16, color:"rgba(255,255,255,0.8)", maxWidth:580 }}>From Playgroup to FSc {'—'} an unbroken pathway of Islamic and modern education under one roof.</p>
        </Container>
      </div>

      <div style={{ background:"white", borderBottom:"1px solid #e5e7eb", position:"sticky", top:64, zIndex:100 }}>
        <Container>
          <div style={{ display:"flex", gap:8, flexWrap:"wrap", padding:"14px 0" }}>
            {PROGRAMS.map((p,i)=>(
              <button key={p.id} data-tab={p.id} onClick={()=>setProgTab(i)}
                style={{ padding:"9px 16px", fontWeight:700, fontSize:12.5, cursor:"pointer", whiteSpace:"nowrap",
                  border: progTab===i ? "none" : "1.5px solid #e5e7eb",
                  borderRadius:24, color: progTab===i ? "white" : "#6b7280",
                  background: progTab===i ? p.color : "white",
                  display:"flex", alignItems:"center", gap:6,
                  boxShadow: progTab===i ? `0 4px 12px ${p.color}50` : "0 1px 3px rgba(0,0,0,0.06)",
                  transition:"all .2s" }}>
                {p.icon} {p.label}
              </button>
            ))}
          </div>
        </Container>
      </div>

      <Section style={{ background:CREAM, paddingTop:48 }}>
        <Container>

          {progTab===0 && (
            <div>
              <ProgHero img={PLAYGROUND_PREP_1} color={TEAL} title="Pre-School Programme" subtitle="QK Academy · Ages 2½ to 5" tags={["Playgroup","Nursery","Prep"]} pos="center 40%"/>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:8, marginBottom:32, borderRadius:12, overflow:"hidden" }}>
                {[[PS_ROOM1,"Classroom"],[PS_ROOM2,"Activity Corner"],[PS_ROOM3,"Learning Space"],[PS_ROOM4,"Playing Area"]].map(([src,cap],i)=>(
                  <div key={i} onClick={()=>setLightbox(src)} style={{ position:"relative", cursor:"zoom-in", overflow:"hidden", height:160 }}>
                    <img src={src} style={{ width:"100%", height:"100%", objectFit:"cover" }} alt={cap}/>
                    <div style={{ position:"absolute", bottom:0, left:0, right:0, background:"linear-gradient(transparent,rgba(0,0,0,0.62))", padding:"8px 10px" }}>
                      <div style={{ fontSize:11, fontWeight:700, color:"white" }}>{cap}</div>
                    </div>
                  </div>
                ))}
              </div>
              {/* 3-stage progression */}
              <div style={{ display:"grid", gridTemplateColumns:"1fr auto 1fr auto 1fr", alignItems:"center", gap:0, marginBottom:32 }}>
                {[
                  { icon:"🌱", stage:"Playgroup", age:"Ages 2½–3", desc:"Sensory & play-based" },
                  { icon:"🌿", stage:"Nursery",   age:"Ages 3–4",   desc:"Building foundations" },
                  { icon:"🌳", stage:"Prep",       age:"Ages 4–5",   desc:"Ready for Grade 1" },
                ].map(({icon,stage,age,desc},i)=>(
                  <React.Fragment key={stage}>
                    <div style={{ background:`linear-gradient(135deg,${TEAL},#0f766e)`, borderRadius:14, padding:"20px 16px", textAlign:"center", color:"white", boxShadow:`0 4px 16px ${TEAL}35` }}>
                      <div style={{ fontSize:30, marginBottom:8 }}>{icon}</div>
                      <div style={{ fontWeight:900, fontSize:16, marginBottom:3 }}>{stage}</div>
                      <div style={{ fontSize:11, fontWeight:700, opacity:0.85, marginBottom:4 }}>{age}</div>
                      <div style={{ fontSize:11, opacity:0.72 }}>{desc}</div>
                    </div>
                    {i < 2 && <div style={{ textAlign:"center", fontSize:22, color:TEAL, fontWeight:900, padding:"0 10px" }}>{'→'}</div>}
                  </React.Fragment>
                ))}
              </div>

              {/* Intro */}
              <div style={{ background:`linear-gradient(135deg,${TEAL}10,${TEAL}04)`, borderRadius:16, padding:"24px", border:`1px solid ${TEAL}25`, marginBottom:32 }}>
                <p style={{ fontSize:14, color:"#374151", lineHeight:1.9, margin:"0 0 16px" }}>
                  A 3-year programme for children aged 2{'½'} to 5 years. At QKA, we believe every child is unique {'—'} our pre-school is designed to foster emotional wellbeing, cognitive growth and imaginative potential in a safe, loving and stimulating Islamic environment. Children learn by playing, exploring and discovering {'—'} never by rote.
                </p>
                <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginBottom:16 }}>
                  {["Tarbiyah & Character","Academic Foundation","Personal Growth","Islamic Identity","Technology Exposure"].map(t=>(
                    <span key={t} style={{ background:`${TEAL}15`, color:TEAL, borderRadius:20, padding:"5px 14px", fontSize:12, fontWeight:700 }}>{'✓'} {t}</span>
                  ))}
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:10 }}>
                  {[["3","Stages"],["2½–5","Age Range"],["7+","Subjects"],["Islamic","Environment"]].map(([v,l])=>(
                    <div key={l} style={{ background:"white", borderRadius:10, padding:"12px 8px", textAlign:"center", boxShadow:"0 1px 6px rgba(0,0,0,0.05)" }}>
                      <div style={{ fontWeight:900, fontSize:20, color:TEAL, lineHeight:1 }}>{v}</div>
                      <div style={{ fontSize:10, fontWeight:700, color:"#6b7280", marginTop:5, textTransform:"uppercase", letterSpacing:0.5 }}>{l}</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* 3 core pillars */}
              <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:16, marginBottom:36 }}>
                {[
                  { icon:"🎮", title:"Active Learning", color:TEAL,
                    desc:"Children learn by doing, moving and creating — not by passive listening or rote memorisation. Every lesson sparks genuine curiosity." },
                  { icon:"🌍", title:"Play-Based Exploration", color:"#0891b2",
                    desc:"Every subject is wrapped in play — games, stories, sensory trays and imaginative activities that feel like adventures, not lessons." },
                  { icon:"🔧", title:"Practical Hands-On", color:"#0f766e",
                    desc:"Real objects, manipulatives and real-world tasks — because young children learn with their hands, not just their eyes." },
                ].map(({icon,title,color,desc})=>(
                  <div key={title} style={{ background:"white", borderRadius:14, padding:"28px 20px 24px", borderTop:`5px solid ${color}`, boxShadow:"0 4px 18px rgba(0,0,0,0.07)", textAlign:"center" }}>
                    <div style={{ fontSize:42, marginBottom:14, lineHeight:1 }}>{icon}</div>
                    <div style={{ fontWeight:900, fontSize:16, color, marginBottom:10, lineHeight:1.3 }}>{title}</div>
                    <div style={{ fontSize:13, color:"#374151", lineHeight:1.85 }}>{desc}</div>
                  </div>
                ))}
              </div>

              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(300px, 1fr))", gap:28, alignItems:"start", marginBottom:32 }}>
                {/* Play Group detailed */}
                <div>
                  <div style={{ fontWeight:900, color:"#0f4c4f", fontSize:20, marginBottom:14, letterSpacing:"-0.3px" }}>Play Group</div>
                  <p style={{ fontSize:13, color:"#6b7280", marginBottom:14, lineHeight:1.8 }}>A gentle introduction to learning through play, movement and sensory activities:</p>
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
                    {[
                      ["📐 Math", "Counting objects, identifying shapes and patterns using toys and manipulatives"],
                      ["☪️ Islamic Ed.", "Arabic alphabet, basic Kalimah and Akhlaq through stories and role-play"],
                      ["🔤 English", "Alphabet sounds, word recognition via flashcards, songs and interactive games"],
                      ["اردو Urdu", "Letter recognition through tracing, sand writing and picture association"],
                      ["🌍 General Know.", "Seasons, animals and life cycles through pictures, models and nature activities"],
                      ["🧩 Active Learning", "Blocks, puzzles, sensory trays and story-based hands-on exploration"],
                      ["📺 Technology Room", "Projectors and age-appropriate documentaries to spark curiosity about the world"],
                    ].map(([subj, desc])=>(
                      <div key={subj} style={{ background:"white", borderRadius:10, padding:"12px 14px", borderLeft:`4px solid ${TEAL}`, boxShadow:"0 1px 5px rgba(0,0,0,0.05)" }}>
                        <div style={{ fontSize:12, fontWeight:800, color:TEAL, marginBottom:4 }}>{subj}</div>
                        <div style={{ fontSize:12, color:"#374151", lineHeight:1.65 }}>{desc}</div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Nursery & Prep + photos */}
                <div>
                  <div style={{ fontWeight:900, color:"#0f4c4f", fontSize:20, marginBottom:14, letterSpacing:"-0.3px" }}>Nursery & Prep</div>
                  <p style={{ fontSize:13, color:"#6b7280", marginBottom:14, lineHeight:1.8 }}>The same rich curriculum deepens progressively, with age-appropriate challenges added at each stage:</p>
                  <div style={{ background:"white", borderRadius:12, overflow:"hidden", border:`1px solid ${TEAL}20`, marginBottom:16, boxShadow:"0 2px 10px rgba(0,0,0,0.05)" }}>
                    <div style={{ background:`linear-gradient(135deg,${TEAL},#0f766e)`, padding:"14px 20px" }}>
                      <div style={{ fontWeight:900, color:"white", fontSize:15 }}>🌿 Nursery</div>
                      <div style={{ fontSize:11, color:"rgba(255,255,255,0.78)", marginTop:2 }}>Ages 3–4 · Deepening foundations</div>
                    </div>
                    <div style={{ padding:"16px 20px" }}>
                      {[
                        "Same subjects as Play Group with age-appropriate depth and practice",
                        "Math: Simple addition using beads and counters",
                        "English & Urdu: Early reading readiness through phonics and interactive storytelling",
                        "Islamic Education: Short duas, manners and Islamic stories",
                        "Active Learning: Group tasks, learning corners and guided play to build confidence",
                      ].map(i=>(
                        <div key={i} style={{ display:"flex", gap:8, marginBottom:6 }}><Check color={TEAL}/><span style={{ fontSize:13, color:"#374151" }}>{i}</span></div>
                      ))}
                    </div>
                  </div>
                  <div style={{ background:"white", borderRadius:12, overflow:"hidden", border:`1px solid ${TEAL}20`, marginBottom:20, boxShadow:"0 2px 10px rgba(0,0,0,0.05)" }}>
                    <div style={{ background:`linear-gradient(135deg,#0f766e,#134e4a)`, padding:"14px 20px" }}>
                      <div style={{ fontWeight:900, color:"white", fontSize:15 }}>🌳 Prep (KG–2)</div>
                      <div style={{ fontSize:11, color:"rgba(255,255,255,0.78)", marginTop:2 }}>Ages 4–5 · Ready for Grade 1</div>
                    </div>
                    <div style={{ padding:"16px 20px" }}>
                      {[
                        "Advanced Noorani Qaeda completion with proper pronunciation and Tajweed basics",
                        "Math: Number operations, patterns and measurements through real-life objects",
                        "English: Early reading, sentence formation and vocabulary through storybooks and phonics games",
                        "Urdu: Reading simple words and sentences, writing practice",
                        "Islamic Education: Short duas, surahs and daily Islamic etiquette",
                        "Active Learning: Manipulatives, charts, role-play, classroom stations and mini project tasks",
                      ].map(i=>(
                        <div key={i} style={{ display:"flex", gap:8, marginBottom:6 }}><Check color={TEAL}/><span style={{ fontSize:13, color:"#374151" }}>{i}</span></div>
                      ))}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          )}

          {progTab===1 && (
            <div>
              <ProgHero img={CLASS_ACTIVE} color={gradStart} title="Primary School" subtitle="QK Academy · Class 1 to 5" tags={["Ages 5–10","Cambridge Curriculum","Islamic Education"]} pos="center 40%"/>
              <Tag color={gradStart}>Primary School Program</Tag>
              <H2>Class 1 to Class 5</H2>
              <Divider/>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(300px, 1fr))", gap:40 }}>
                <div>
                  <p style={{ fontSize:15, color:"#374151", lineHeight:1.8, marginBottom:16 }}>Cambridge-aligned English medium curriculum, contextualized to local needs. Complete school education for ages 5{'–'}10 with strong Islamic education integrated throughout.</p>
                  <p style={{ fontSize:15, color:"#374151", lineHeight:1.8 }}>Special emphasis on reading Quran and Arabic fluently, memorizing and understanding surahs in Juz Amma, fundamental rules of Tajweed with accurate pronunciation (Makharij).</p>
                </div>
                <div style={{ background:"white", borderRadius:14, padding:"24px", border:`1px solid ${G}20` }}>
                  <div style={{ fontWeight:800, color:gradStart, marginBottom:14, fontSize:14 }}>Curriculum (All Classes 1{'–'}5)</div>
                  {["English","Mathematics","Science","Knowledge of World","Islamic Curriculum (Seerah, Islamic history, Adaab & Akhlaq, Tajweed and Qiraat, Arabic Language)","Urdu","Moral Education","Computer Science","Physical Education"].map(s=>(
                    <div key={s} style={{ display:"flex", gap:8, marginBottom:8 }}><Check/><span style={{ fontSize:13, color:"#374151" }}>{s}</span></div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {progTab===3 && (
            <div>
              <ProgHero img={HIFZ_CLASS_2} color="#7c3aed" title="Hifz with School" subtitle="QK Academy · Class 6 to 8" tags={["Quran Memorisation","3-Year Programme","Selected Students"]} pos="center 35%"/>
              <Tag color="#7c3aed">Middle School with Compulsory Hifz</Tag>
              <H2>Class 6 {'→'} 7 {'→'} 8</H2>
              <Divider color="#7c3aed"/>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(300px, 1fr))", gap:40, marginBottom:40 }}>
                <div>
                  <p style={{ fontSize:15, color:"#374151", lineHeight:1.8, marginBottom:16 }}>An intense and comprehensive 3-year program where exceptional students {'—'} selected based on the Hifz Policy criteria {'—'} memorize the Holy Quran with correct pronunciation and Tajweed, alongside Cambridge school education.</p>
                  <p style={{ fontSize:15, color:"#374151", lineHeight:1.8 }}>Due to the intense Hifz schedule, core subjects only: English, Math, Science and Computer Science. Islamic education periods cover Qiraat, Tajweed, Seerat, Islamic History and Akhlaq & Adaab.</p>
                </div>
                <div style={{ background:"#f5f3ff", borderRadius:14, padding:"24px", border:"1px solid #c4b5fd" }}>
                  <div style={{ fontWeight:800, color:"#7c3aed", marginBottom:14 }}>Hifz Criteria (for admission from Class 6)</div>
                  {[["Playgroup–Prep","Noorani Qaeda completed + recommended duas memorized"],["Class 1–2","Started Nazirah + memorized last 15 surahs of Juz 30"],["Class 3–5","Completed 10 juz Nazirah + Surah Mulk + Surah Ya-sin"]].map(([s,c])=>(
                    <div key={s} style={{ marginBottom:14, paddingBottom:14, borderBottom:"1px solid #e9d5ff" }}>
                      <div style={{ fontWeight:700, color:"#7c3aed", fontSize:12, marginBottom:4 }}>{s}</div>
                      <div style={{ fontSize:13, color:"#374151" }}>{c}</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Daily schedule */}
              <div style={{ background:NAVY, borderRadius:16, padding:"28px 32px" }}>
                <h3 style={{ fontSize:18, fontWeight:800, color:"white", marginBottom:20 }}>Daily Schedule {'—'} Hifz Students</h3>
                <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(250px, 1fr))", gap:8 }}>
                  {[["Before Fajr","Memorizing + Reciting Sabaq"],["After Fajr – 7:00am","Continuous Memorization"],["7:30–8:00am","Breakfast and Assembly"],["8:00–9:15am","Sabaqi"],["9:15–10:00am","Islamic Curriculum (Qiraat, Seerah, Fiqah, Hadith)"],["10:00am–12:15pm","School (English, Science, Math, Computer)"],["12:15–2:00pm","Lunch and Rest"],["2:00–4:30pm","Manzil"],["4:30–6:00pm","Sports / Physical Education"],["6:00–8:00pm","Memorization of New Sabaq"],["After Isha","Dinner and Library Hour"],["9:30pm","Sleep"]].map(([t,a])=>(
                    <div key={t} style={{ display:"flex", gap:12, background:"rgba(255,255,255,0.06)", borderRadius:8, padding:"10px 14px", alignItems:"flex-start" }}>
                      <div style={{ fontSize:11, fontWeight:700, color:GOLD, minWidth:100, flexShrink:0 }}>{t}</div>
                      <div style={{ fontSize:12, color:"rgba(255,255,255,0.8)" }}>{a}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {progTab===2 && (
            <div>
              <ProgHero img={CLASSROOM_2} color={NAVY} title="Regular Middle School" subtitle="QK Academy · Class 6 to 8" tags={["Cambridge Curriculum","English Medium","Critical Thinking"]} pos="center 35%"/>
              <Tag color={NAVY}>Regular Middle School</Tag>
              <H2>Class 6 {'→'} 7 {'→'} 8</H2>
              <Divider color={NAVY}/>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(300px, 1fr))", gap:40 }}>
                <div>
                  <p style={{ fontSize:15, color:"#374151", lineHeight:1.8, marginBottom:16 }}>For students seeking a strong academic focus. The 3-year program prioritizes contemporary Cambridge education in English from Class 6 to 8, with rigorous learning that fosters critical thinking and problem-solving.</p>
                  <p style={{ fontSize:15, color:"#374151", lineHeight:1.8 }}>While not including compulsory Hifz, students learn important surahs, develop correct Quranic pronunciation, and benefit from dedicated Islamic education covering Seerat, History of Islam, Akhlaq and Adaab.</p>
                </div>
                <div style={{ background:"white", borderRadius:14, padding:"24px", border:`1px solid ${NAVY}20` }}>
                  <div style={{ fontWeight:800, color:NAVY, marginBottom:14 }}>Curriculum (Classes 6{'–'}8)</div>
                  {["English (all subjects in English medium)","Mathematics","Science","Computer Science","Islamic Education (Qiraat, Tajweed, Seerat, History of Islam, Akhlaq & Adaab)","Arabic Language","Hifz of selective surahs with correct Makharij"].map(s=>(
                    <div key={s} style={{ display:"flex", gap:8, marginBottom:8 }}><Check color={NAVY}/><span style={{ fontSize:13, color:"#374151" }}>{s}</span></div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {progTab===4 && (
            <div>
              <ProgHero img={SCI_DEMO} color="#d97706" title="Secondary School" subtitle="QK Academy · Class 9 & 10" tags={["Matric","BISE Rawalpindi","Science Group"]} pos="center 35%"/>
              <Tag color="#d97706">Secondary School Program</Tag>
              <H2>Class 9 & 10 {'—'} Matric</H2>
              <Divider color="#d97706"/>
              <div style={{ background:"#fffbeb", border:"1.5px solid #fcd34d", borderRadius:12, padding:"14px 18px", marginBottom:28, fontSize:13, color:"#92400e", fontWeight:600 }}>
                {'🆕'} New from 2025 {'—'} Admissions now open. Affiliated with BISE Rawalpindi.
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(300px, 1fr))", gap:40 }}>
                <div>
                  <p style={{ fontSize:15, color:"#374151", lineHeight:1.8, marginBottom:16 }}>Affiliated with the Board of Intermediate and Secondary Education (BISE) Rawalpindi. Annual board examinations at end of Grade 9 (Part I) and Grade 10 (Part II).</p>
                  {["Modern Science Lab and Computer Lab for practicals","Qualified and experienced teaching faculty","Scholarship opportunities for outstanding students","Extracurricular activities for leadership and creativity"].map(f=>(
                    <div key={f} style={{ display:"flex", gap:8, marginBottom:10 }}><Check color="#d97706"/><span style={{ fontSize:14, color:"#374151" }}>{f}</span></div>
                  ))}
                </div>
                <div>
                  <div style={{ background:"white", borderRadius:14, padding:"24px", border:"1px solid #fde68a", marginBottom:16 }}>
                    <div style={{ fontWeight:800, color:"#d97706", marginBottom:12 }}>{'📋'} Compulsory Subjects (All Groups)</div>
                    {["English","Urdu","Pakistan Studies","Islamic Studies","Mathematics"].map(s=>(<div key={s} style={{ display:"flex", gap:8, marginBottom:6 }}><Check color="#d97706"/><span style={{ fontSize:13 }}>{s}</span></div>))}
                  </div>
                  <div style={{ background:"white", borderRadius:14, padding:"24px", border:"1px solid #fde68a" }}>
                    <div style={{ fontWeight:800, color:"#d97706", marginBottom:12 }}>{'🔬'} Science Group {'—'} Additional Subjects</div>
                    <div style={{ fontSize:12, color:"#6b7280", marginBottom:10 }}>Physics and Chemistry are compulsory. Then choose one:</div>
                    <div style={{ display:"flex", gap:8, marginBottom:6 }}><Check color="#d97706"/><span style={{ fontSize:13 }}>Biology <span style={{ color:"#9ca3af" }}>(for Pre-Medical pathway)</span></span></div>
                    <div style={{ display:"flex", gap:8, marginBottom:6 }}><Check color="#d97706"/><span style={{ fontSize:13 }}>Computer Science <span style={{ color:"#9ca3af" }}>(for Computer/ICS pathway)</span></span></div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {progTab===5 && (
            <div>
              <ProgHero img={STUDENTS_TECH_ROOM} color="#e11d48" title="Higher Secondary" subtitle="QK Academy · Class 11 & 12" tags={["FSc","ICS","BISE Rawalpindi","New from 2025"]} pos="center 30%"/>
              <Tag color="#e11d48">Higher Secondary Program</Tag>
              <H2>Class 11 & 12 {'—'} FSc / ICS</H2>
              <Divider color="#e11d48"/>
              <div style={{ background:"#fff0f3", border:"1.5px solid #fda4af", borderRadius:12, padding:"14px 18px", marginBottom:28, fontSize:13, color:"#9f1239", fontWeight:600 }}>
                {'🆕'} New from 2025 {'—'} Affiliated with BISE Rawalpindi. Admissions open after board exams.
              </div>
              <p style={{ fontSize:14, color:"#6b7280", marginBottom:24, lineHeight:1.8 }}>
                All groups share compulsory subjects: <strong>English, Urdu, Pakistan Studies, Islamic Studies.</strong> The elective group determines your pathway.
              </p>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(280px, 1fr))", gap:24 }}>
                {[
                  { g:"Pre-Medical (FSc)", c:"#e11d48", icon:"🔬",
                    must:["Physics","Biology"],
                    note:"Physics and Biology are compulsory. Chemistry is also compulsory." },
                  { g:"Pre-Engineering (FSc)", c:"#7c3aed", icon:"⚙️",
                    must:["Physics","Chemistry","Mathematics"],
                    elective:["Biology (optional elective)"],
                    note:"Physics, Chemistry and Mathematics are compulsory." },
                  { g:"ICS (Computer Science)", c:NAVY, icon:"💻",
                    must:["Physics","Mathematics","Computer Science"],
                    note:"Physics and Mathematics are compulsory alongside Computer Science." },
                ].map(g=>(
                  <div key={g.g} style={{ background:"white", borderRadius:14, padding:"22px", border:`1px solid ${g.c}20`, boxShadow:"0 2px 12px rgba(0,0,0,0.04)" }}>
                    <div style={{ fontSize:24, marginBottom:8 }}>{g.icon}</div>
                    <div style={{ fontWeight:900, color:g.c, marginBottom:6, fontSize:15 }}>{g.g}</div>
                    <div style={{ fontSize:12, color:"#6b7280", marginBottom:12, lineHeight:1.6 }}>{g.note}</div>
                    <div style={{ fontWeight:700, color:"#374151", fontSize:12, marginBottom:8 }}>Elective subjects:</div>
                    {g.must.map(s=>(<div key={s} style={{ display:"flex", gap:8, marginBottom:5 }}><Check color={g.c}/><span style={{ fontSize:13 }}>{s}</span></div>))}
                    {g.elective&&g.elective.map(s=>(<div key={s} style={{ display:"flex", gap:8, marginBottom:5 }}>
                      <span style={{ color:"#9ca3af", fontSize:13 }}>{'○'}</span><span style={{ fontSize:13, color:"#9ca3af" }}>{s}</span>
                    </div>))}
                  </div>
                ))}
              </div>
            </div>
          )}

          {progTab===7 && (
            <div>
              <ProgHero img={AI_COURSE_1} color="#0891b2" title="Special & Additional Courses" subtitle="QK Academy · Beyond the Classroom" tags={["AI","English Club","Arabic","Tajweed","Engineering"]} pos="center 40%"/>
              <Tag color="#0891b2">Special & Additional Courses</Tag>
              <H2>Beyond the Classroom</H2>
              <Divider color="#0891b2"/>
              <p style={{ fontSize:15, color:"#6b7280", lineHeight:1.8, marginBottom:36, maxWidth:680 }}>
                At QKA, education extends far beyond textbooks. We offer a rich selection of special courses that develop the whole person {'—'} spiritually, academically and professionally.
              </p>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))", gap:24, marginBottom:48 }}>
                {[
                  { t:"Spoken English & English Club", icon:"🗣️", c:NAVY, d:"Weekly sessions focused entirely on spoken fluency, confidence and communication. Students engage in debates, storytelling, public speaking and listening activities — building the English skills that matter most in the real world." },
                  { t:"Mathematics Club", icon:"🔢", c:"#0891b2", d:"A fun, challenge-based club where students explore Mathematics beyond the textbook — through puzzles, mental arithmetic, problem-solving competitions and real-life applications. Building logical thinking and a genuine love for numbers." },
                  { t:"Quran with Tajweed", icon:"📿", c:"#0891b2", d:"Learn accurate and beautiful recitation of the Holy Quran with correct Makharij and Tajweed rules. Taught using whiteboards, LED screens and audio/video resources for mastery in approximately 4 months." },
                  { t:"Islamic Knowledge", icon:"📖", c:gradStart, d:"Strengthen your faith and understanding through structured lessons in Seerat, Hadith, Islamic History, Akhlaq and Adaab — woven into daily academic life at QKA." },
                  { t:"Arabic Language", icon:"🌐", c:TEAL, d:"Develop essential skills in the language of the Quran and Paradise. Weekly Arabic Club sessions cover pronunciation, speaking, grammar and writing for all students." },
                  { t:"Artificial Intelligence", icon:"🤖", c:"#7c3aed", d:"Discover the exciting world of AI. Our students have completed a comprehensive AI course covering ChatGPT, Copilot, Google Gemini, Claude and more — integrating modern technology with traditional education.", img:AI_COURSE_1 },
                  { t:"Personality Development", icon:"💡", c:NAVY, d:"Build confidence and essential life skills through regular seminars by our Management Council. Covers public speaking, leadership, career guidance and strength/weakness assessment." },
                  { t:"Engineering & Design", icon:"⚙️", c:"#d97706", d:"Hands-on creativity for young innovators. Students explore basic engineering concepts, design thinking and practical problem-solving in an engaging and interactive environment." },
                  { t:"Growth & Career Guidance", icon:"🚀", c:"#e11d48", d:"Prepare for a successful future with structured counselling sessions, career pathway discussions and goal-setting workshops — guided by professionals from across the world." },
                ].map(c=>(
                  <div key={c.t} style={{ background:"white", borderRadius:16, overflow:"hidden", border:`1px solid ${c.c}20`, boxShadow:"0 2px 16px rgba(0,0,0,0.05)" }}>
                    {c.img && <div onClick={()=>setLightbox(c.img)} style={{ height:180, overflow:"hidden", cursor:"zoom-in" }}><img src={c.img} alt={c.t} style={{ width:"100%", height:"100%", objectFit:"cover", objectPosition:"center 30%" }}/></div>}
                    <div style={{ padding:"24px 22px" }}>
                      <div style={{ fontSize:36, marginBottom:14 }}>{c.icon}</div>
                      <h3 style={{ fontSize:17, fontWeight:800, color:c.c, margin:"0 0 12px" }}>{c.t}</h3>
                      <p style={{ fontSize:14, color:"#374151", lineHeight:1.8, margin:0 }}>{c.d}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Fashion & Design Course */}
              <div style={{ background:CREAM, borderRadius:20, padding:"36px 32px", border:`1px solid ${GOLD}30` }}>
                <div style={{ display:"flex", gap:14, alignItems:"center", marginBottom:20 }}>
                  <div style={{ fontSize:40 }}>{'🪡'}</div>
                  <div>
                    <div style={{ fontSize:11, fontWeight:700, color:GOLD, letterSpacing:1.5, textTransform:"uppercase", marginBottom:4 }}>Vocational & Creative Skills</div>
                    <h3 style={{ fontSize:22, fontWeight:900, color:"#1a1a1a", margin:0 }}>Fashion & Design Course</h3>
                  </div>
                </div>
                <p style={{ fontSize:15, color:"#374151", lineHeight:1.9, marginBottom:24 }}>
                  A comprehensive 13-week course open to both boys and girls, delivered under expert guidance. Students master sewing, fabric selection, garment construction and basic fashion business concepts {'—'} building a practical, creative and entrepreneurial skill set.
                </p>
                <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(240px,1fr))", gap:12 }}>
                  {[
                    { w:"Week 1–2", t:"Introduction & Hand Stitching", d:"Fashion basics, tools, safety and fundamental hand-stitching techniques" },
                    { w:"Week 3–4", t:"Fabrics & Sewing Machine", d:"Types of fabrics, their uses, sewing machine parts, threading, oiling and maintenance" },
                    { w:"Week 5–6", t:"Measuring & Cutting", d:"Accurate fabric measuring, marking and cutting techniques for professional results" },
                    { w:"Week 7–9", t:"Stitching & Creating", d:"Straight stitch, backstitch, creating bags, aprons and simple clothing items" },
                    { w:"Week 11–12", t:"Design & Business", d:"Fashion design concepts, current trends and the business side of fashion" },
                    { w:"Week 13", t:"Final Showcase", d:"Students present a personal project — bag, clothing item or accessory — to complete the course" },
                  ].map(s=>(
                    <div key={s.w} style={{ background:"white", borderRadius:12, padding:"16px 14px", border:`1px solid ${GOLD}20` }}>
                      <div style={{ fontSize:10, fontWeight:800, color:GOLD, letterSpacing:1, textTransform:"uppercase", marginBottom:4 }}>{s.w}</div>
                      <div style={{ fontSize:13, fontWeight:800, color:"#1a1a1a", marginBottom:6 }}>{s.t}</div>
                      <div style={{ fontSize:12, color:"#6b7280", lineHeight:1.5 }}>{s.d}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* ── DARS-E-NIZAMI (separate tab equivalent section) ── */}
          {progTab===6 && (
            <div>
              <ProgHero img={CORR_HIFZ} color="#5b21b6" title="Dars-e-Nizami — Aalima" subtitle="QK Academy · Islamic Higher Education" tags={["6-Year Programme","Girls Only","Classical Islamic Sciences"]} pos="center 30%"/>
              <Tag color="#7c3aed">Islamic Higher Education</Tag>
              <H2>Dars-e-Nizami {'—'} Aalima Programme</H2>
              <Divider color="#7c3aed"/>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))", gap:40, alignItems:"start" }}>
                <div>
                  <p style={{ fontSize:15, color:"#374151", lineHeight:1.9, marginBottom:20 }}>
                    A full-time 6-year Islamic scholarship programme for girls, taught by specialist scholars. Students gain deep knowledge across all classical Islamic sciences {'—'} from Quran and Hadith to Arabic grammar, jurisprudence and philosophy {'—'} emerging as qualified Aalimas ready to serve their communities.
                  </p>
                  <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                    {["Islamic Theology & Aqeedah","Hadith & Usool ul-Hadith","Quran & Tafsir","Arabic Morphology & Grammar (Sarf & Nahw)","Islamic Jurisprudence (Fiqh)","Logic & Philosophy","Ethics & Spiritual Development"].map(s=>(
                      <div key={s} style={{ display:"flex", gap:10 }}><Check color="#7c3aed"/><span style={{ fontSize:14, color:"#374151" }}>{s}</span></div>
                    ))}
                  </div>
                </div>
                <div style={{ background:"linear-gradient(135deg,#7c3aed,#5b21b6)", borderRadius:20, padding:"36px 28px", textAlign:"center", color:"white" }}>
                  <div style={{ fontSize:56, marginBottom:16 }}>{'🎓'}</div>
                  <div style={{ fontSize:20, fontWeight:900, marginBottom:10, lineHeight:1.4 }}>6-Year Aalima Programme</div>
                  <div style={{ fontSize:13, color:"rgba(255,255,255,0.82)", lineHeight:1.8, marginBottom:20 }}>
                    A rigorous, classical Islamic education delivered by qualified scholars {'—'} combining traditional learning with spiritual development.
                  </div>
                  <div style={{ background:"rgba(255,255,255,0.12)", borderRadius:12, padding:"14px 20px" }}>
                    <div style={{ fontSize:12, fontWeight:700, color:"rgba(255,255,255,0.7)", marginBottom:4 }}>Programme Duration</div>
                    <div style={{ fontSize:18, fontWeight:900 }}>6 Years {'·'} Full Time</div>
                  </div>
                </div>
              </div>
            </div>
          )}


        </Container>
      </Section>
    </div>
  );

  // ── ADMISSIONS ────────────────────────────────────────────────────
  const Admissions = () => (
    <div>
      <div style={{ background:grad, padding:"64px 0 52px", position:"relative", overflow:"hidden" }}>
        <img src={EXT_ARCH} alt="QKA Admissions" style={{ position:"absolute", inset:0, width:"100%", height:"100%", objectFit:"cover", objectPosition:"center 30%", zIndex:0 }}/>
        <div style={{ position:"absolute", inset:0, background:`linear-gradient(135deg,${gradStart}e8,${GD}cc)`, zIndex:1 }}/>
        <Container style={{ position:"relative", zIndex:2 }}>
          <Tag color="rgba(255,255,255,0.7)">Join QKA</Tag>
          <h1 style={{ fontSize:"clamp(28px,5vw,46px)", fontWeight:900, color:"white", margin:"0 0 14px" }}>Admissions 2025{'–'}2026</h1>
          <p style={{ fontSize:16, color:"rgba(255,255,255,0.8)", maxWidth:560 }}>Strictly first come, first serve with limited seats. Classes start 1st March every year.</p>
        </Container>
      </div>

      {/* Age table */}
      <Section style={{ background:"white" }}>
        <Container>
          <Tag>Age Requirements</Tag>
          <H2>Program Age Chart</H2>
          <Divider/>
          <div style={{ overflowX:"auto" }}>
            <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
              <thead>
                <tr style={{ background:NAVY }}>
                  {["Program","Class","Min. Age","Max. Age"].map(h=>(
                    <th key={h} style={{ padding:"12px 16px", color:"white", textAlign:"left", fontWeight:700 }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {[
                  ["Pre-School","Playgroup","3 years","3.5 years",TEAL],
                  ["Pre-School","Nursery","3.5 years","4.5 years",TEAL],
                  ["Pre-School","Prep","4 years","5 years",TEAL],
                  ["Primary","Class 1","5 years","6 years",gradStart],
                  ["Primary","Class 2–5","6–9 years","7–10 years",gradStart],
                  ["Middle School","Class 6","10 years","11 years","#7c3aed"],
                  ["Middle School","Class 7–8","11–12 years","12–13 years","#7c3aed"],
                  ["Secondary","Class 9–10","13 years","15 years","#d97706"],
                  ["Higher Secondary","Class 11–12","15 years","16 years","#e11d48"],
                ].map(([prog,cls,min,max,c],i)=>(
                  <tr key={i} style={{ borderBottom:"1px solid #f3f4f6", background:i%2===0?"white":"#f9fafb" }}>
                    <td style={{ padding:"11px 16px" }}><span style={{ background:`${c}15`, color:c, borderRadius:6, padding:"2px 10px", fontSize:12, fontWeight:700 }}>{prog}</span></td>
                    <td style={{ padding:"11px 16px", fontWeight:600 }}>{cls}</td>
                    <td style={{ padding:"11px 16px", color:"#6b7280" }}>{min}</td>
                    <td style={{ padding:"11px 16px", color:"#6b7280" }}>{max}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Container>
      </Section>

      {/* Process */}
      <Section style={{ background:CREAM }}>
        <Container>
          <Tag>Step by Step</Tag>
          <H2>Admission Process</H2>
          <Divider/>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))", gap:20, marginBottom:40 }}>
            {[
              { n:"01", t:"Visit Our Academy", d:"Schedule a visit or simply walk in during school hours. Our team will warmly welcome you and give you a full tour of the campus, facilities and programs." },
              { n:"02", t:"Collect the Prospectus", d:"Receive our detailed prospectus, official application form and complete fee information — everything you need to make an informed decision." },
              { n:"03", t:"Admission Assessment", d:"Students applying for Primary and Middle programs sit a short, friendly assessment to help us place them in the right class and stream for their abilities." },
              { n:"04", t:"Interview & Documentation", d:"The student and parent are invited for a brief interview. Please bring the required documents — our team will guide you through every step." },
              { n:"05", t:"Enrolment Confirmed", d:"You will be notified of the outcome promptly. Upon confirmation, complete the enrolment process and welcome your child to the QKA family!" },
            ].map(s=>(
              <div key={s.n} style={{ background:"white", borderRadius:14, padding:"24px 20px", boxShadow:"0 2px 12px rgba(0,0,0,0.06)", border:`1px solid ${G}10` }}>
                <div style={{ fontSize:28, fontWeight:900, color:`${G}30`, marginBottom:8 }}>{s.n}</div>
                <div style={{ fontWeight:800, color:"#1a1a1a", marginBottom:8 }}>{s.t}</div>
                <p style={{ fontSize:13, color:"#6b7280", lineHeight:1.7, margin:0 }}>{s.d}</p>
              </div>
            ))}
          </div>

          {/* Documents */}
          <div style={{ background:"white", borderRadius:16, padding:"28px 32px", border:`1px solid ${G}18` }}>
            <h3 style={{ fontSize:18, fontWeight:800, color:gradStart, marginBottom:20 }}>Required Documents</h3>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(250px, 1fr))", gap:10 }}>
              {["Original & Photocopy of Birth Certificate","Original & Photocopy of Form 'B'","Three recent passport-sized photographs","Photocopies of CNICs of both parents","Photocopy of last progress report / report card","Original & Photocopy of School Leaving Certificate"].map(d=>(
                <div key={d} style={{ display:"flex", gap:10, alignItems:"flex-start" }}>
                  <Check/><span style={{ fontSize:13, color:"#374151" }}>{d}</span>
                </div>
              ))}
            </div>
          </div>
        </Container>
      </Section>

      {/* Fee structure */}
      <Section style={{ background:"white" }}>
        <Container>
          <Tag>Transparent Pricing</Tag>
          <H2>Fee Structure & Scholarship Opportunities</H2>
          <Divider/>
          <div style={{ background:`linear-gradient(135deg,${G},${GD})`, borderRadius:20, padding:"34px 34px", marginBottom:34, color:"white", position:"relative", overflow:"hidden" }}>
            <div style={{ position:"absolute", right:-40, top:-40, width:180, height:180, borderRadius:"50%", background:"rgba(255,255,255,0.06)" }}/>
            <div style={{ position:"absolute", left:-30, bottom:-30, width:120, height:120, borderRadius:"50%", background:"rgba(255,255,255,0.05)" }}/>
            <div style={{ position:"relative", zIndex:1 }}>
              <div style={{ fontSize:12, letterSpacing:2, textTransform:"uppercase", color:"rgba(255,255,255,0.72)", fontWeight:800, marginBottom:10 }}>{'🎓'} Full Scholarship Available</div>
              <div style={{ fontSize:"clamp(20px,3.5vw,32px)", fontWeight:900, marginBottom:12, lineHeight:1.3 }}>Full Scholarship for Bright Students {'—'} Hifz + School Stream with Free Boarding</div>
              <p style={{ fontSize:15, lineHeight:1.8, color:"rgba(255,255,255,0.9)", maxWidth:700, margin:"0 0 18px" }}>Exceptional students selected for the Hifz + School boarding stream receive <strong>everything free</strong> {'—'} education, boarding, meals, uniforms and books. We invest fully in those who show commitment and potential.</p>
              <div style={{ display:"flex", gap:10, flexWrap:"wrap" }}>
                {["✓ Free Education","✓ Free Boarding","✓ Free Meals","✓ Free Uniforms","✓ Assessment-Based Selection"].map(t=>(<span key={t} style={{ background:"rgba(255,255,255,0.12)", border:"1px solid rgba(255,255,255,0.18)", borderRadius:22, padding:"6px 14px", fontSize:12, fontWeight:700 }}>{t}</span>))}
              </div>
            </div>
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(280px, 1fr))", gap:24 }}>
            <div style={{ background:CREAM, borderRadius:16, padding:"28px 24px", border:`1px solid ${G}20` }}>
              <div style={{ fontWeight:800, color:gradStart, fontSize:15, marginBottom:18 }}>One-Time Fees</div>
              {[["Registration Fee","PKR 2,500"],["Admission Fee","PKR 2,500"]].map(([l,v])=>(
                <div key={l} style={{ display:"flex", justifyContent:"space-between", padding:"10px 0", borderBottom:"1px solid #e5e7eb", fontSize:14 }}>
                  <span style={{ color:"#374151" }}>{l}</span><span style={{ fontWeight:700, color:gradStart }}>{v}</span>
                </div>
              ))}
            </div>
            <div style={{ background:CREAM, borderRadius:16, padding:"28px 24px", border:`1px solid ${G}20` }}>
              <div style={{ fontWeight:800, color:gradStart, fontSize:15, marginBottom:18 }}>Monthly Tuition Fee</div>
              {[["Pre-School","1,500"],["Primary School","2,000"],["Middle School","2,500"],["Secondary (9–10)","3,000"],["Higher Secondary","3,500"]].map(([l,v])=>(
                <div key={l} style={{ display:"flex", justifyContent:"space-between", padding:"9px 0", borderBottom:"1px solid #e5e7eb", fontSize:13 }}>
                  <span style={{ color:"#374151" }}>{l}</span><span style={{ fontWeight:700, color:gradStart }}>PKR {v}</span>
                </div>
              ))}
            </div>
            <div style={{ background:CREAM, borderRadius:16, padding:"28px 24px", border:`1px solid ${G}20` }}>
              <div style={{ fontWeight:800, color:gradStart, fontSize:15, marginBottom:18 }}>Annual Fees</div>
              {[["Technology Fee","PKR 1,000"],["Science Lab Fee","PKR 1,000"],["Exam Fee","PKR 1,000"]].map(([l,v])=>(
                <div key={l} style={{ display:"flex", justifyContent:"space-between", padding:"10px 0", borderBottom:"1px solid #e5e7eb", fontSize:14 }}>
                  <span style={{ color:"#374151" }}>{l}</span><span style={{ fontWeight:700, color:gradStart }}>{v}</span>
                </div>
              ))}
              <div style={{ marginTop:16, background:`${G}10`, borderRadius:10, padding:"12px 14px", fontSize:12, color:gradStart, fontWeight:600 }}>
                {'💡'} Big scholarship support available for bright and deserving students {'—'} especially Boarding with Hifz + School stream
              </div>
            </div>
          </div>
        </Container>
      </Section>

      {/* Hifz policy */}
      <Section style={{ background:CREAM }}>
        <Container style={{ maxWidth:820 }}>
          <Tag color="#7c3aed">Pathway to Excellence</Tag>
          <H2>Hifz + School Stream {'—'} Entry Criteria</H2>
          <Divider color="#7c3aed"/>
          <p style={{ fontSize:15, color:"#374151", lineHeight:1.9, marginBottom:10 }}>
            The <strong>Hifz + School Stream</strong> is our flagship full-scholarship programme for exceptional students. Beginning from Grade 6, students who meet the criteria below may be assessed and {'—'} if selected {'—'} join this prestigious stream where all costs are covered by the academy.
          </p>
          <p style={{ fontSize:14, color:"#6b7280", lineHeight:1.8, marginBottom:28 }}>
            Assessment is conducted by our Hifz teachers. Meeting the criteria makes a student <em>eligible</em> {'—'} selection is based on assessment performance and available places.
          </p>
          <div style={{ background:"white", borderRadius:16, overflow:"hidden", border:"1.5px solid #c4b5fd", boxShadow:"0 4px 20px rgba(124,58,237,0.08)" }}>
            <div style={{ background:"#7c3aed", padding:"14px 22px", display:"flex", gap:16 }}>
              <div style={{ flex:"0 0 140px", fontSize:12, fontWeight:800, color:"rgba(255,255,255,0.8)", textTransform:"uppercase", letterSpacing:1, minWidth:"100px" }}>Class Level</div>
              <div style={{ fontSize:12, fontWeight:800, color:"rgba(255,255,255,0.8)", textTransform:"uppercase", letterSpacing:1 }}>Required Criteria for Hifz Entry</div>
            </div>
            {[
              { stage:"Playgroup – Prep", criteria:["Completed Noorani Qaeda by end of Prep", "Memorized recommended short duas and basic supplications"] },
              { stage:"Class 1 – 2", criteria:["Started Nazirah study of the Holy Quran", "Memorized the last 15 surahs of Juz 30 with correct Makharij"] },
              { stage:"Class 3 – 5", criteria:["Completed at least 10 juz of Nazirah", "Memorized Surah Mulk and Surah Ya-sin with Tajweed"] },
            ].map((r,i)=>(
              <div key={i} style={{ display:"flex", gap:0, borderBottom:i<2?"1px solid #e9d5ff":"none" }}>
                <div style={{ padding:"14px 18px", background:"#f5f3ff", fontWeight:800, color:"#6d28d9", fontSize:13, flex:"0 0 140px", minWidth:"100px", display:"flex", alignItems:"flex-start", borderRight:"1px solid #e9d5ff" }}>{r.stage}</div>
                <div style={{ padding:"16px 22px", fontSize:13, color:"#374151", lineHeight:1.8 }}>
                  {r.criteria.map((c,ci)=>(
                    <div key={ci} style={{ display:"flex", gap:8, marginBottom:ci<r.criteria.length-1?6:0 }}>
                      <span style={{ color:"#7c3aed", fontWeight:700, flexShrink:0 }}>{'✓'}</span>
                      <span>{c}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div style={{ marginTop:18, background:"#fef9c3", borderRadius:12, padding:"14px 18px", borderLeft:"4px solid #d97706" }}>
            <div style={{ fontSize:14, fontWeight:800, color:"#92400e", lineHeight:1.8 }}>
              {'📌'} Students who do not meet the above criteria are welcome to continue in the regular school programme. They may still attend Hifz sessions on weekends and work towards memorizing selected surahs of the Holy Quran.
            </div>
          </div>
        </Container>
      </Section>

      {/* Uniform policy */}
      <Section style={{ background:"white" }}>
        <Container style={{ maxWidth:800 }}>
          <Tag>School Policy</Tag>
          <H2>Uniform Policy</H2>
          <Divider/>
          <p style={{ fontSize:15, color:"#374151", lineHeight:1.8, marginBottom:28 }}>
            Our uniform is shalwar kameez {'—'} loose, east-centric and closer to Sunnah. It is also our national dress. Students are expected to maintain a neat, clean and well-groomed appearance at all times.
          </p>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(250px, 1fr))", gap:24, marginBottom:24 }}>
            <div style={{ background:CREAM, borderRadius:14, padding:"24px", border:`1px solid ${G}20` }}>
              <div style={{ fontWeight:800, color:gradStart, marginBottom:14 }}>{'👦'} Boys' Uniform</div>
              {["White shalwar and kurta","Plain black joggers","White socks with no visible logo","Cap is mandatory for Hifz students, encouraged for all"].map(i=>(<div key={i} style={{ display:"flex", gap:8, marginBottom:8 }}><Check/><span style={{ fontSize:13 }}>{i}</span></div>))}
            </div>
            <div style={{ background:CREAM, borderRadius:14, padding:"24px", border:`1px solid ${G}20` }}>
              <div style={{ fontWeight:800, color:gradStart, marginBottom:14 }}>{'👧'} Girls' Uniform</div>
              {["White shalwar kameez","Black scarf (optional for pre-school girls)","Kameez length below knee","White socks (no logo, designs or lace)","Black school shoes"].map(i=>(<div key={i} style={{ display:"flex", gap:8, marginBottom:8 }}><Check/><span style={{ fontSize:13 }}>{i}</span></div>))}
            </div>
          </div>
          <div style={{ background:"#fef9c3", borderRadius:12, padding:"18px 20px", border:"1px solid #fde68a", fontSize:13, color:"#374151", borderLeft:"4px solid #d97706" }}>
            <strong style={{ color:"#92400e" }}>{'❄️'} Winter Policy (Boys & Girls all classes):</strong> Black V-neck sweaters and jackets {'·'} White leggings/polo-necks under uniform only {'·'} Black gloves, earmuffs or woollen caps in cold weather
          </div>
        </Container>
      </Section>
    </div>
  );

  // ── FACILITIES ────────────────────────────────────────────────────
  const Facilities = () => (
    <div>
      <div style={{ position:"relative", padding:"80px 0 64px", overflow:"hidden" }}>
        <img src={EXT_COURT} alt="QKA Facilities" style={{ position:"absolute", inset:0, width:"100%", height:"100%", objectFit:"cover", objectPosition:"center 40%", zIndex:0 }}/>
        <div style={{ position:"absolute", inset:0, background:`linear-gradient(135deg,${gradStart}e0 0%,${GD}cc 100%)`, zIndex:1 }}/>
        <Container style={{ position:"relative", zIndex:2 }}>
          <Tag color="rgba(255,255,255,0.75)">Our Campus</Tag>
          <h1 style={{ fontSize:"clamp(28px,5vw,46px)", fontWeight:900, color:"white", margin:"0 0 14px" }}>World-Class Facilities</h1>
          <p style={{ fontSize:16, color:"rgba(255,255,255,0.85)", maxWidth:560, lineHeight:1.8 }}>Modern, state-of-the-art and environment-friendly campus designed to nurture every student {'—'} in Deen and Duniya.</p>
          <div style={{ display:"flex", gap:10, flexWrap:"wrap", marginTop:24 }}>
            {["Library","Computer Lab","Science Lab","Technology Room","Sports Ground","Free Boarding"].map(t=>(
              <span key={t} style={{ background:"rgba(255,255,255,0.15)", border:"1px solid rgba(255,255,255,0.3)", borderRadius:22, padding:"5px 14px", fontSize:12, fontWeight:700, color:"white" }}>{'✓'} {t}</span>
            ))}
          </div>
        </Container>
      </div>

      {/* ── Library Spotlight — full-width video hero ── */}
      <div style={{ position:"relative", height:620, overflow:"hidden", background:"#0a1a0f" }}>
        {/* Blurred background fill — hides letterbox bars */}
        <div style={{
          position:"absolute", inset:0, zIndex:0,
          backgroundImage:`url(${LIB_READING})`,
          backgroundSize:"cover", backgroundPosition:"center",
          filter:"blur(5px) brightness(0.75)",
          transform:"scale(1.08)",
        }}/>
        {/* Main video */}
        <video
          autoPlay muted loop playsInline
          poster={LIB_READING}
          style={{ position:"absolute", inset:0, width:"100%", height:"100%", objectFit:"contain", zIndex:1, opacity:0.92 }}
        >
          <source src="/library-video.mp4" type="video/mp4"/>
        </video>
        {/* Gradient overlay — left-heavy so text is readable */}
        <div style={{ position:"absolute", inset:0, background:`linear-gradient(105deg,rgba(10,26,15,0.88) 0%,rgba(10,26,15,0.65) 55%,rgba(0,0,0,0.20) 100%)`, zIndex:2 }}/>

        <Container style={{ position:"relative", zIndex:3, height:"100%", display:"flex", alignItems:"center", paddingTop:48, paddingBottom:48 }}>
          <div style={{ display:"grid", gridTemplateColumns:"1fr auto", gap:40, alignItems:"center", width:"100%" }}>

            {/* Left — text */}
            <div>
              <div style={{ display:"flex", alignItems:"center", gap:14, marginBottom:20 }}>
                <div style={{ width:3, height:48, background:accent, borderRadius:2, flexShrink:0 }}/>
                <div>
                  <div style={{ fontSize:10, fontWeight:700, color:accent, letterSpacing:3, textTransform:"uppercase", marginBottom:4 }}>Facility Spotlight</div>
                  <h2 style={{ fontSize:"clamp(26px,5vw,46px)", fontWeight:900, color:"white", margin:0, lineHeight:1.1 }}>School Library</h2>
                </div>
              </div>
              <p style={{ fontSize:"clamp(13px,2vw,16px)", color:"rgba(255,255,255,0.82)", lineHeight:1.9, maxWidth:520, margin:"0 0 28px" }}>
                Our library is open daily under staff supervision with a rich collection spanning Islamic History, Seerat, Fiqa, fiction, non-fiction, and contemporary science &amp; technology — hand-picked for growing young minds.
              </p>
              <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                {["📖 Islamic Collection","🔬 Science & Technology","📕 Fiction & Non-Fiction","👩‍🏫 Supervised Reading Hours","🌐 All Subjects Covered"].map(t=>(
                  <span key={t} style={{ background:"rgba(255,255,255,0.12)", border:"1px solid rgba(255,255,255,0.25)", backdropFilter:"blur(6px)", borderRadius:22, padding:"6px 14px", fontSize:12, fontWeight:600, color:"white" }}>{t}</span>
                ))}
              </div>
            </div>

            {/* Right — stat tiles */}
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, flexShrink:0, minWidth:240 }}>
              {[
                ["📚","5,000+","Books"],
                ["🕐","Daily","Library Hours"],
                ["👩‍🏫","Supervised","By Staff"],
                ["🌟","All Classes","Welcome"],
              ].map(([icon,n,l])=>(
                <div key={l} style={{ background:"rgba(255,255,255,0.10)", backdropFilter:"blur(14px)", WebkitBackdropFilter:"blur(14px)", border:"1px solid rgba(255,255,255,0.18)", borderRadius:16, padding:"18px 14px", textAlign:"center" }}>
                  <div style={{ fontSize:26, marginBottom:4 }}>{icon}</div>
                  <div style={{ fontSize:20, fontWeight:900, color:"white", lineHeight:1 }}>{n}</div>
                  <div style={{ fontSize:11, color:"rgba(255,255,255,0.65)", marginTop:4 }}>{l}</div>
                </div>
              ))}
            </div>

          </div>
        </Container>
      </div>

      {/* Science Lab Hero */}
      <div style={{ position:"relative", height:540, overflow:"hidden", background:"#06141f" }}>
        <div style={{ position:"absolute", inset:0, zIndex:0, backgroundImage:`url(${SCI_CLUB})`, backgroundSize:"cover", backgroundPosition:"center 30%", filter:"blur(5px) brightness(0.6)", transform:"scale(1.08)" }}/>
        <img src={SCI_CLUB} alt="Science Lab" style={{ position:"absolute", inset:0, width:"100%", height:"100%", objectFit:"cover", objectPosition:"center 30%", zIndex:1, opacity:0.88 }}/>
        <div style={{ position:"absolute", inset:0, background:"linear-gradient(105deg,rgba(6,20,31,0.92) 0%,rgba(6,20,31,0.70) 55%,rgba(0,0,0,0.18) 100%)", zIndex:2 }}/>
        <Container style={{ position:"relative", zIndex:3, height:"100%", display:"flex", alignItems:"center" }}>
          <div style={{ display:"grid", gridTemplateColumns:"1fr auto", gap:52, alignItems:"center", width:"100%", padding:"48px 0" }}>
            <div>
              <div style={{ fontSize:11, fontWeight:700, color:"rgba(255,255,255,0.6)", letterSpacing:2, textTransform:"uppercase", marginBottom:10 }}>Hands-On Learning</div>
              <h2 style={{ fontSize:"clamp(24px,4vw,42px)", fontWeight:900, color:"white", margin:"0 0 16px", lineHeight:1.15 }}>Science Laboratory</h2>
              <p style={{ fontSize:15, color:"rgba(255,255,255,0.82)", lineHeight:1.9, marginBottom:12, maxWidth:540 }}>
                QKA's Science Laboratory is equipped with dedicated benches and professional apparatus for <strong style={{color:"white"}}>Chemistry</strong> and <strong style={{color:"white"}}>Physics</strong> practicals. Students run real experiments — titrations, circuits, acid-base reactions and more.
              </p>
              <p style={{ fontSize:14, color:"rgba(255,255,255,0.68)", lineHeight:1.8, marginBottom:22, maxWidth:540 }}>
                From Science Club activities to board exam practicals, the lab is available to all Secondary and Higher Secondary students under expert teacher supervision. Students don't just read about science — they do it.
              </p>
              <div style={{ display:"flex", gap:10, flexWrap:"wrap" }}>
                {["Chemistry Practicals","Physics Experiments","Science Club","Board Exam Ready","Expert Supervision"].map(t=>(
                  <span key={t} style={{ background:"rgba(255,255,255,0.15)", backdropFilter:"blur(4px)", border:"1px solid rgba(255,255,255,0.25)", borderRadius:20, padding:"5px 14px", fontSize:11, fontWeight:700, color:"white" }}>{t}</span>
                ))}
              </div>
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, minWidth:340 }}>
              {[["⚗️","Chemistry","Titrations, reactions & practical experiments"],["⚡","Physics","Circuits, measurements & force experiments"],["🧪","Apparatus","Full set of professional lab equipment"],["🥼","Supervised","Always under expert teacher guidance"]].map(([icon,t,d])=>(
                <div key={t} style={{ background:"rgba(255,255,255,0.10)", backdropFilter:"blur(12px)", WebkitBackdropFilter:"blur(12px)", borderRadius:14, padding:"18px 16px", border:"1px solid rgba(255,255,255,0.15)" }}>
                  <div style={{ fontSize:26, marginBottom:8 }}>{icon}</div>
                  <div style={{ fontWeight:800, color:"white", fontSize:13, marginBottom:4 }}>{t}</div>
                  <div style={{ fontSize:11, color:"rgba(255,255,255,0.65)", lineHeight:1.55 }}>{d}</div>
                </div>
              ))}
            </div>
          </div>
        </Container>
      </div>

      <Section style={{ background:"white" }}>
        <Container>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))", gap:28 }}>
            {[
              { icon:"💻", t:"Computer Lab", c:NAVY, d:"Equipped with laptops, wide screen and projector. Used to teach Computer Science subjects and run multimedia learning activities including science documentaries.", img:COMP_LAB },
              { icon:"📺", t:"Technology Room", c:TEAL, d:"Smart screen, computer and speakers. Used to teach Qiraat and Tajweed through audio/video resources, and for the English Club with speaking and listening activities.", img:STUDENTS_TECH_ROOM, imgPos:"20% 10%" },
              { icon:"⚽", t:"Sports Ground", c:"#d97706", d:"A large dedicated ground for cricket, volleyball and PT exercises under trained staff. Sports is integral and compulsory — builds character and discipline." },
              { icon:"🎯", t:"Career Counselling", c:"#7c3aed", d:"Regular personality development sessions and counselling seminars by management council and board of directors. Strength/weakness assessment and career guidance." },
              { icon:"🏠", t:"Free Boarding", c:gradStart, d:"Separate hostel facilities for boys and girls. Free housing provided to all full-time students and academy staff.", img:BOARDING_CAMPUS },
              { icon:"🎨", t:"Islamic Art Corridors", c:"#7c3aed", d:"Every corridor at QKA is a gallery — hand-painted Quranic verses, Islamic calligraphy, inspiring quotes and scenic murals decorate the walls from ground to ceiling.", img:CORR_QURAN, img2:CORR_QUOTE },
            ].map(f=>(
              <div key={f.t} onClick={f.img?()=>setLightbox(f.img):undefined} style={{ borderRadius:16, overflow:"hidden", border:`1px solid ${f.c}18`, background:"white", boxShadow:"0 2px 16px rgba(0,0,0,0.04)", cursor:f.img?"zoom-in":"default" }}>
                {f.img && (
                  f.img2
                    ? <div style={{ display:"grid", gridTemplateColumns:"2fr 1fr", height:160, overflow:"hidden" }}>
                        <img src={f.img} style={{ width:"100%", height:"100%", objectFit:"cover" }} alt={f.t}/>
                        <div onClick={e=>{e.stopPropagation();setLightbox(f.img2);}} style={{ cursor:"zoom-in" }}>
                          <img src={f.img2} style={{ width:"100%", height:"100%", objectFit:"cover" }} alt={f.t+" 2"}/>
                        </div>
                      </div>
                    : <div style={{ height:160, overflow:"hidden" }}><img src={f.img} style={{ width:"100%", height:"100%", objectFit:"cover", objectPosition:f.imgPos||"center 30%" }} alt={f.t}/></div>
                )}
                <div style={{ padding:"24px 22px" }}>
                  <div style={{ width:48, height:48, borderRadius:12, background:`${f.c}12`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:24, marginBottom:14 }}>{f.icon}</div>
                  <h3 style={{ fontSize:17, fontWeight:800, color:f.c, margin:"0 0 10px" }}>{f.t}</h3>
                  <p style={{ fontSize:14, color:"#374151", lineHeight:1.7, margin:0 }}>{f.d}</p>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </Section>

      {/* Labs photo strip */}
      <div className="qka-strip-4" style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr 1fr", height:280, overflow:"hidden" }}>
        {[[COMP_LAB2,"💻 Computer Lab"],[LIB_GIRLS,"📚 Library — Girls Section"],[SCI_LAB,"🔬 Science Lab"],[SCI_LAB2,"⚗️ Chemistry & Physics"]].map(([src,cap])=>(
          <div key={cap} onClick={()=>setLightbox(src)} style={{ position:"relative", overflow:"hidden", cursor:"zoom-in" }}>
            <img src={src} style={{ width:"100%", height:"100%", objectFit:"cover", objectPosition:"center 30%" }} alt={cap}/>
            <div style={{ position:"absolute", inset:0, background:"rgba(0,0,0,0.3)" }}/>
            <div style={{ position:"absolute", bottom:12, left:14, color:"white", fontSize:12, fontWeight:700, textShadow:"0 1px 4px rgba(0,0,0,0.7)" }}>{cap}</div>
          </div>
        ))}
      </div>

      {/* Free facilities */}
      <Section style={{ position:"relative", overflow:"hidden" }}>
        <img src={EXT_ARCH} alt="QKA Campus" style={{ position:"absolute", inset:0, width:"100%", height:"100%", objectFit:"cover", objectPosition:"center 50%", zIndex:0 }}/>
        <div style={{ position:"absolute", inset:0, background:"rgba(253,248,240,0.93)", zIndex:1 }}/>
        <Container style={{ position:"relative", zIndex:2 }}>
          <Tag>For Deserving Students</Tag>
          <H2>Free Facilities {'—'} No Student Left Behind</H2>
          <Divider/>
          <p style={{ fontSize:15, color:"#6b7280", lineHeight:1.8, marginBottom:36, maxWidth:680 }}>
            So children from disadvantaged backgrounds can access quality Islamic education along with the essentials they need for a full and stable life.
          </p>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(250px,1fr))", gap:20 }}>
            {[
              { icon:"🏫", t:"Free Education", d:"Complete Islamic and English medium school education for 3 years (Grade 6–8)" },
              { icon:"🏠", t:"Free Boarding", d:"Separate hostel for boys and girls. Free housing for all full-time students and staff" },
              { icon:"👕", t:"Free Uniform", d:"Free uniforms are provided as needed so that no student is left behind." },
              { icon:"🏥", t:"Free Medical", d:"Medical checkup and medicines from private local clinic for students and staff" },
              { icon:"🍽️", t:"Free Three Daily Meals", d:"Students and staff provided with 3 daily meals and milk" },
            ].map(f=>(
              <div key={f.t} style={{ background:"white", borderRadius:14, padding:"24px 20px", border:`1px solid ${G}14`, boxShadow:"0 2px 12px rgba(0,0,0,0.04)" }}>
                <div style={{ fontSize:36, marginBottom:12 }}>{f.icon}</div>
                <div style={{ fontWeight:800, color:gradStart, fontSize:15, marginBottom:8 }}>{f.t}</div>
                <p style={{ fontSize:13, color:"#6b7280", lineHeight:1.7, margin:0 }}>{f.d}</p>
              </div>
            ))}
          </div>
        </Container>
      </Section>

    </div>
  );

  // ── CAMPUS LIFE ───────────────────────────────────────────────────
  const CampusLife = () => (
    <div>
      <div style={{ position:"relative", padding:"72px 0 60px", overflow:"hidden" }}>
        <img src={EXT_SIDE} alt="Campus Life" style={{ position:"absolute", inset:0, width:"100%", height:"100%", objectFit:"cover", objectPosition:"center 40%", zIndex:0 }}/>
        <div style={{ position:"absolute", inset:0, background:`linear-gradient(135deg,${gradStart}e0,${GD}c0)`, zIndex:1 }}/>
        <Container style={{ position:"relative", zIndex:2 }}>
          <Tag color="rgba(255,255,255,0.7)">Life at QKA</Tag>
          <h1 style={{ fontSize:"clamp(28px,5vw,46px)", fontWeight:900, color:"white", margin:"0 0 14px" }}>Campus Life</h1>
          <p style={{ fontSize:16, color:"rgba(255,255,255,0.85)", maxWidth:580, lineHeight:1.8 }}>
            From morning Hifz sessions to classroom learning, playground activities to Tarbiyah circles {'—'} life at QKA is vibrant, purposeful and deeply rooted in Islamic values.
          </p>
        </Container>
      </div>

      {/* Classrooms */}
      <Section style={{ background:"white" }}>
        <Container>
          <Tag>Our Spaces</Tag>
          <H2>Classrooms & Learning Spaces</H2>
          <Divider/>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(260px,1fr))", gap:14, marginBottom:48 }}>
            {[[CLASS_ACTIVE,"Active Learning"],[CLASS_PRESENT,"Student Presentation"],[CLASSROOM_3,"Students Learning"],[SCHOOL_CHILDREN,"Students"],[SCI_DEMO,"Science Demo"],[ART_CLUB,"Art & Drawing Club"]].map(([src,cap])=>(
              <div key={cap} onClick={()=>setLightbox(src)} style={{ borderRadius:14, overflow:"hidden", boxShadow:"0 3px 16px rgba(0,0,0,0.08)", cursor:"zoom-in", position:"relative" }}>
                <img src={src} alt={cap} style={{ width:"100%", height:200, objectFit:"cover", objectPosition:"center 30%", display:"block" }}/>
                <div style={{ position:"absolute", bottom:0, left:0, right:0, background:"linear-gradient(to top,rgba(0,0,0,0.6),transparent)", padding:"20px 14px 10px" }}>
                  <div style={{ color:"white", fontSize:12, fontWeight:700 }}>{cap}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Pre-School */}
          <div style={{ fontSize:13, fontWeight:800, color:TEAL, letterSpacing:1, textTransform:"uppercase", marginBottom:16 }}>{'🌱'} Pre-School & Nursery</div>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))", gap:14, marginBottom:48 }}>
            {[[NURSERY_CLASSES,"Nursery Class"],[KG_CLASSES,"KG Class"],[SMALL_CLASSES_2,"Early Years"],[PLAYGROUND_PREP_1,"Pre-School Playground"],[PLAYGROUND_PREP_2,"Pre-School Playground"]].map(([src,cap])=>(
              <div key={cap} onClick={()=>setLightbox(src)} style={{ borderRadius:14, overflow:"hidden", boxShadow:"0 3px 16px rgba(0,0,0,0.08)", cursor:"zoom-in", position:"relative" }}>
                <img src={src} alt={cap} style={{ width:"100%", height:170, objectFit:"cover", objectPosition:"center 30%", display:"block" }}/>
                <div style={{ position:"absolute", bottom:0, left:0, right:0, background:"linear-gradient(to top,rgba(0,0,0,0.55),transparent)", padding:"16px 12px 8px" }}>
                  <div style={{ color:"white", fontSize:11, fontWeight:700 }}>{cap}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Hifz & Tarbiyah */}
          <div className="qka-2col" style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))", gap:32 }}>
            <div>
              <div style={{ fontSize:13, fontWeight:800, color:"#7c3aed", letterSpacing:1, textTransform:"uppercase", marginBottom:16 }}>{'📖'} Hifz Classes</div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
                {[[HIFZ_CLASS_2,"Hifz Session"],[HIFZ_CLASS_3,"Quran Memorisation"]].map(([src,cap])=>(
                  <div key={cap} onClick={()=>setLightbox(src)} style={{ borderRadius:12, overflow:"hidden", cursor:"zoom-in", position:"relative" }}>
                    <img src={src} alt={cap} style={{ width:"100%", height:200, objectFit:"cover", display:"block" }}/>
                    <div style={{ position:"absolute", bottom:0, left:0, right:0, background:"linear-gradient(to top,rgba(0,0,0,0.6),transparent)", padding:"16px 12px 8px" }}>
                      <div style={{ color:"white", fontSize:11, fontWeight:700 }}>{cap}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <div style={{ fontSize:13, fontWeight:800, color:gradStart, letterSpacing:1, textTransform:"uppercase", marginBottom:16 }}>{'🕌'} Tarbiyah & Character</div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
                {[[TARBIYAH_CLASS_1,"Tarbiyah Circle"],[TARBIYAH_CLASS_2,"Islamic Values"]].map(([src,cap])=>(
                  <div key={cap} onClick={()=>setLightbox(src)} style={{ borderRadius:12, overflow:"hidden", cursor:"zoom-in", position:"relative" }}>
                    <img src={src} alt={cap} style={{ width:"100%", height:200, objectFit:"cover", display:"block" }}/>
                    <div style={{ position:"absolute", bottom:0, left:0, right:0, background:"linear-gradient(to top,rgba(0,0,0,0.6),transparent)", padding:"16px 12px 8px" }}>
                      <div style={{ color:"white", fontSize:11, fontWeight:700 }}>{cap}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Container>
      </Section>

      {/* Campus beauty strip */}
      <Section style={{ background:CREAM, paddingBottom:60 }}>
        <Container>
          <div style={{ fontSize:13, fontWeight:800, color:gradStart, letterSpacing:1, textTransform:"uppercase", marginBottom:16 }}>{'🏛️'} Our Corridors & Spaces</div>
        </Container>
        <div className="qka-strip-4" style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr 1fr", height:280, overflow:"hidden" }}>
          {[[CORR_LONG1,"Islamic Art Corridors"],[CAMPUS_COURTYARD_2,"Academy Campus"],[CORR_HIFZ,"Hifz Corridor"],[STAIRS,"Academy Stairs"]].map(([src,cap])=>(
            <div key={cap} style={{ position:"relative", overflow:"hidden", cursor:"zoom-in" }} onClick={()=>setLightbox(src)}>
              <img src={src} style={{ width:"100%", height:"100%", objectFit:"cover", objectPosition:"center 30%" }} alt={cap}/>
              <div style={{ position:"absolute", inset:0, background:"rgba(0,0,0,0.25)" }}/>
              <div style={{ position:"absolute", bottom:14, left:14, color:"white", fontSize:11, fontWeight:700, textShadow:"0 1px 4px rgba(0,0,0,0.7)" }}>{cap}</div>
            </div>
          ))}
        </div>
        <Container>
          <p style={{ fontSize:14, color:"#6b7280", textAlign:"center", marginTop:24, lineHeight:1.8 }}>
            Every corner of QKA reflects our values {'—'} Islamic art, Quranic calligraphy and inspiring murals fill our corridors from ground to ceiling.
          </p>
        </Container>
      </Section>
    </div>
  );

  // ── COMMUNITY ─────────────────────────────────────────────────────
  const Community = () => (
    <div>
      {/* Hero */}
      <div style={{ position:"relative", padding:"72px 0 60px", overflow:"hidden" }}>
        <img src={EXT_GARDEN} alt="Community" style={{ position:"absolute", inset:0, width:"100%", height:"100%", objectFit:"cover", objectPosition:"center 50%", zIndex:0 }}/>
        <div style={{ position:"absolute", inset:0, background:`linear-gradient(135deg,${gradStart}e8,${GD}cc)`, zIndex:1 }}/>
        <Container style={{ position:"relative", zIndex:2 }}>
          <Tag color="rgba(255,255,255,0.7)">Giving Back</Tag>
          <h1 style={{ fontSize:"clamp(28px,5vw,46px)", fontWeight:900, color:"white", margin:"0 0 14px" }}>Community Work</h1>
          <p style={{ fontSize:16, color:"rgba(255,255,255,0.85)", maxWidth:580, lineHeight:1.8 }}>
            At QKA, education doesn't stop at the school gate. Our students and staff actively serve Gorsian village and beyond — addressing real problems with real solutions.
          </p>
        </Container>
      </div>

      {/* Academy community initiatives */}
      <Section style={{ background:"white" }}>
        <Container>
          <Tag>Academy Initiatives</Tag>
          <H2>How QKA Serves the Community</H2>
          <Divider/>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))", gap:24 }}>
            {[
              { icon:"💧", t:"Free Clean Drinking Water", c:TEAL, d:"A 400-foot deep tube well was installed and 2 water wells were dug free of cost — meeting the drinking water needs of four neighbouring villages.", img:CAMPUS_2 },
              { icon:"🕌", t:"Jamia Masjid", c:gradStart, d:"A mosque built to accommodate 3,000 people — serving the entire community for Friday prayers and daily salah every day of the year.", img:SUNSET },
              { icon:"🐄", t:"Eid ul-Adha Qurbani", c:"#d97706", d:"Every year QKA arranges Qurbani and distributes meat to needy families. Over 26 years: 260+ cows and 130+ goats distributed to the local community." },
            ].map(p=>(
              <div key={p.t} style={{ borderRadius:16, overflow:"hidden", border:`1px solid ${p.c}20`, background:"white", boxShadow:"0 2px 20px rgba(0,0,0,0.05)" }}>
                {p.img && <div onClick={()=>setLightbox(p.img)} style={{ height:200, overflow:"hidden", cursor:"zoom-in" }}><img src={p.img} alt={p.t} style={{ width:"100%", height:"100%", objectFit:"cover", objectPosition:"center 40%" }}/></div>}
                <div style={{ padding:"24px" }}>
                  <div style={{ fontSize:40, marginBottom:12 }}>{p.icon}</div>
                  <h3 style={{ fontSize:18, fontWeight:800, color:p.c, margin:"0 0 10px" }}>{p.t}</h3>
                  <p style={{ fontSize:14, color:"#374151", lineHeight:1.8, margin:0 }}>{p.d}</p>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </Section>

      {/* Student Community Projects */}
      <Section style={{ background:CREAM }}>
        <Container>
          <div style={{ display:"flex", alignItems:"center", gap:14, marginBottom:12 }}>
            <div style={{ background:"linear-gradient(135deg,#7c3aed,#5b21b6)", borderRadius:10, padding:"6px 18px" }}>
              <span style={{ fontSize:12, fontWeight:800, color:"white", letterSpacing:2, textTransform:"uppercase" }}>Summer 2025</span>
            </div>
            <div style={{ height:2, flex:1, background:"linear-gradient(to right,#7c3aed20,transparent)" }}/>
          </div>
          <h2 style={{ fontSize:"clamp(24px,4vw,36px)", fontWeight:900, color:"#1a1a1a", margin:"0 0 8px", letterSpacing:"-0.5px", lineHeight:1.2 }}>Student Community Projects</h2>
          <Divider color="#7c3aed"/>
          <p style={{ fontSize:15, color:"#6b7280", lineHeight:1.8, marginBottom:48, maxWidth:680 }}>
            In Summer 2025, QKA students took on real community challenges in Gorsian village {'—'} researching, investigating and presenting solutions to local authorities. Here's what they accomplished.
          </p>

          {/* Project cards */}
          <div style={{ display:"flex", flexDirection:"column", gap:48 }}>

            {/* Plantation */}
            <div style={{ background:"white", borderRadius:20, overflow:"hidden", boxShadow:"0 4px 24px rgba(0,0,0,0.07)", border:"1px solid #16a34a20" }}>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))" }}>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gridTemplateRows:"1fr 1fr", height:300 }}>
                  {[[CP_GREEN_1],[CP_GREEN_2],[CP_GREEN_3],[CP_GREEN_POSTER]].map(([src],i)=>(
                    <div key={i} onClick={()=>setLightbox(src)} style={{ overflow:"hidden", cursor:"zoom-in" }}>
                      <img src={src} style={{ width:"100%", height:"100%", objectFit:"cover" }} alt="Green Project"/>
                    </div>
                  ))}
                </div>
                <div style={{ padding:"32px 28px" }}>
                  <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:16 }}>
                    <div style={{ fontSize:36 }}>{'🌱'}</div>
                    <div>
                      <div style={{ fontSize:11, fontWeight:700, color:"#16a34a", letterSpacing:1, textTransform:"uppercase" }}>Environmental Awareness</div>
                      <h3 style={{ fontSize:20, fontWeight:900, color:"#1a1a1a", margin:0 }}>Green Legacy {'—'} Plantation Drive</h3>
                    </div>
                  </div>
                  <p style={{ fontSize:14, color:"#374151", lineHeight:1.9, marginBottom:16 }}>
                    Students launched an environmental awareness campaign in Gorsian village, creating posters, designing project logos and identifying plants suited to the local environment. They built a model village featuring artificial trees, planters, benches and street lights {'—'} combining creativity with a powerful message of sustainability.
                  </p>
                  <p style={{ fontSize:14, color:"#374151", lineHeight:1.9, marginBottom:16 }}>
                    Most notably, every student at QKA was given 3{'–'}4 plants to grow in their own villages {'—'} turning the project into a community-wide green movement that extended well beyond the classroom.
                  </p>
                  <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                    {["Plantation Drive","Environmental Awareness","Model Village","Community Outreach"].map(t=>(
                      <span key={t} style={{ background:"#dcfce7", color:"#16a34a", borderRadius:20, padding:"4px 12px", fontSize:11, fontWeight:700 }}>{t}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Social Wellbeing */}
            <div style={{ background:"white", borderRadius:20, overflow:"hidden", boxShadow:"0 4px 24px rgba(0,0,0,0.07)", border:"1px solid #0891b220" }}>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))" }}>
                <div style={{ padding:"32px 28px" }}>
                  <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:16 }}>
                    <div style={{ fontSize:36 }}>{'🏘️'}</div>
                    <div>
                      <div style={{ fontSize:11, fontWeight:700, color:"#0891b2", letterSpacing:1, textTransform:"uppercase" }}>Social Wellbeing</div>
                      <h3 style={{ fontSize:20, fontWeight:900, color:"#1a1a1a", margin:0 }}>Model Village {'—'} Gorsian</h3>
                    </div>
                  </div>
                  <p style={{ fontSize:14, color:"#374151", lineHeight:1.9, marginBottom:16 }}>
                    Students designed and built a detailed scale model of Gorsian village, crafting swings, dustbins, doors, planters, artificial trees, benches and street lights using everyday materials like ice cream sticks, cardboard and clay {'—'} envisioning a cleaner, better-planned community of the future.
                  </p>
                  <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                    {["Scale Model","Community Planning","Teamwork","Creative Design"].map(t=>(
                      <span key={t} style={{ background:"#e0f7fa", color:"#0891b2", borderRadius:20, padding:"4px 12px", fontSize:11, fontWeight:700 }}>{t}</span>
                    ))}
                  </div>
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", height:280 }}>
                  {[CP_SOCIAL_1,CP_SOCIAL_2,CP_SOCIAL_3,CP_SOCIAL_1].map((src,i)=>(
                    <div key={i} onClick={()=>setLightbox(src)} style={{ overflow:"hidden", cursor:"zoom-in" }}>
                      <img src={src} style={{ width:"100%", height:"100%", objectFit:"cover" }} alt="Social Project"/>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Cleanliness */}
            <div style={{ background:"white", borderRadius:20, overflow:"hidden", boxShadow:"0 4px 24px rgba(0,0,0,0.07)", border:"1px solid #d9770620" }}>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))" }}>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gridTemplateRows:"1fr 1fr", height:300 }}>
                  <div onClick={()=>setLightbox(CP_CLEAN_1)} style={{ overflow:"hidden", cursor:"zoom-in", gridColumn:"1/-1" }}>
                    <img src={CP_CLEAN_1} style={{ width:"100%", height:"100%", objectFit:"cover" }} alt="Cleanliness 1"/>
                  </div>
                  {[CP_CLEAN_2,CP_CLEAN_3].map((src,i)=>(
                    <div key={i} onClick={()=>setLightbox(src)} style={{ overflow:"hidden", cursor:"zoom-in" }}>
                      <img src={src} style={{ width:"100%", height:"100%", objectFit:"cover" }} alt="Cleanliness"/>
                    </div>
                  ))}
                </div>
                <div style={{ padding:"32px 28px" }}>
                  <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:16 }}>
                    <div style={{ fontSize:36 }}>{'🧹'}</div>
                    <div>
                      <div style={{ fontSize:11, fontWeight:700, color:"#d97706", letterSpacing:1, textTransform:"uppercase" }}>Community Hygiene</div>
                      <h3 style={{ fontSize:20, fontWeight:900, color:"#1a1a1a", margin:0 }}>Cleanliness Campaign</h3>
                    </div>
                  </div>
                  <p style={{ fontSize:14, color:"#374151", lineHeight:1.9, marginBottom:12 }}>
                    Students surveyed Gorsian's 500+ homes across 5 main streets and found just 3 dustbins serving the entire village. They conducted community visits, documented blocked drains and scattered waste, and created awareness posters — spreading the Islamic message that cleanliness is half of faith.
                  </p>
                  <p style={{ fontSize:14, color:"#374151", lineHeight:1.9, marginBottom:16 }}>
                    They also recycled plastic bottles into pen holders and flower pots {'—'} turning waste into something useful and beautiful.
                  </p>
                  <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                    {["Community Survey","Recycling","Awareness Campaign","Hygiene Education"].map(t=>(
                      <span key={t} style={{ background:"#fef3c7", color:"#d97706", borderRadius:20, padding:"4px 12px", fontSize:11, fontWeight:700 }}>{t}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Solar */}
            <div style={{ background:"white", borderRadius:20, overflow:"hidden", boxShadow:"0 4px 24px rgba(0,0,0,0.07)", border:"1px solid #f59e0b20" }}>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))" }}>
                <div style={{ padding:"32px 28px" }}>
                  <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:16 }}>
                    <div style={{ fontSize:36 }}>{'☀️'}</div>
                    <div>
                      <div style={{ fontSize:11, fontWeight:700, color:"#f59e0b", letterSpacing:1, textTransform:"uppercase" }}>Renewable Energy</div>
                      <h3 style={{ fontSize:20, fontWeight:900, color:"#1a1a1a", margin:0 }}>Solar Energy {'—'} Home Visit</h3>
                    </div>
                  </div>
                  <p style={{ fontSize:14, color:"#374151", lineHeight:1.9, marginBottom:12 }}>
                    Students visited a solar-powered home in Gorsian and interviewed the owner about real-life installation. They learned about solar plates, inverters and green meters {'—'} discovering that the PKR 800,000 system generates surplus electricity sold back to the grid at PKR 25/unit.
                  </p>
                  <p style={{ fontSize:14, color:"#374151", lineHeight:1.9, marginBottom:16 }}>
                    The visit inspired students to advocate for solar adoption as a practical solution to Pakistan's energy crisis — concluding that clean energy is both affordable and essential for rural communities.
                  </p>
                  <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                    {["Solar Energy","Renewable Tech","Home Visit","Energy Awareness"].map(t=>(
                      <span key={t} style={{ background:"#fef9c3", color:"#ca8a04", borderRadius:20, padding:"4px 12px", fontSize:11, fontWeight:700 }}>{t}</span>
                    ))}
                  </div>
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", height:280 }}>
                  {[CP_SOLAR_1,CP_SOLAR_2].map((src,i)=>(
                    <div key={i} onClick={()=>setLightbox(src)} style={{ overflow:"hidden", cursor:"zoom-in" }}>
                      <img src={src} style={{ width:"100%", height:"100%", objectFit:"cover" }} alt="Solar Project"/>
                    </div>
                  ))}
                  <div style={{ background:"linear-gradient(135deg,#f59e0b,#d97706)", display:"flex", alignItems:"center", justifyContent:"center", flexDirection:"column", padding:20, textAlign:"center" }}>
                    <div style={{ fontSize:40, marginBottom:8 }}>{'⚡'}</div>
                    <div style={{ fontSize:12, fontWeight:800, color:"white" }}>PKR 25/unit sold to grid</div>
                    <div style={{ fontSize:11, color:"rgba(255,255,255,0.8)", marginTop:4 }}>vs PKR 85/unit from WAPDA</div>
                  </div>
                  <div style={{ background:"linear-gradient(135deg,#16a34a,#15803d)", display:"flex", alignItems:"center", justifyContent:"center", flexDirection:"column", padding:20, textAlign:"center" }}>
                    <div style={{ fontSize:40, marginBottom:8 }}>{'🌍'}</div>
                    <div style={{ fontSize:12, fontWeight:800, color:"white" }}>Clean & Sustainable</div>
                    <div style={{ fontSize:11, color:"rgba(255,255,255,0.8)", marginTop:4 }}>Zero emissions energy</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Health, Electricity, Water — icon cards */}
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))", gap:24 }}>
              {[
                { icon:"🏥", t:"Health Facilities Project", c:"#e11d48", bg:"linear-gradient(135deg,#e11d48,#be123c)",
                  d:"Over 6 weeks, students surveyed Gorsian's health infrastructure, interviewed residents and visited the Basic Health Unit in Devi. They identified critical gaps — no permanent doctor, no ambulance, unqualified practitioners — and presented a detailed funding proposal estimating PKR 2.5–3M for an ambulance and PKR 150–200K for a first aid room.",
                  stats:["No permanent doctor","No ambulance","500+ homes affected","Proposal submitted to authorities"] },
                { icon:"⚡", t:"Electricity Shortage Project", c:"#7c3aed", bg:"linear-gradient(135deg,#7c3aed,#5b21b6)",
                  d:"Students investigated Gorsian's chronic power outages by visiting homes, shops and interviewing WAPDA staff. They mapped electrical load distribution, designed awareness posters and presented affordable solutions — LED adoption, load management and solar alternatives — to school and local committee.",
                  stats:["Long daily outages","Voltage drops","Load map created","Solutions presented"] },
                { icon:"💧", t:"Water Scarcity Project", c:"#0891b2", bg:"linear-gradient(135deg,#0891b2,#0e7490)",
                  d:"With only a handful of wells serving the entire village, students spent 6 weeks documenting Gorsian's drinking water crisis. Through field visits, community interviews and data analysis, they mapped water sources, identified usage patterns and presented affordable solutions to school and local leaders.",
                  stats:["Few wells for 500+ homes","Field visits conducted","Awareness videos made","Presented to local leaders"] },
              ].map(p=>(
                <div key={p.t} style={{ borderRadius:20, overflow:"hidden", boxShadow:"0 4px 24px rgba(0,0,0,0.08)" }}>
                  <div style={{ background:p.bg, padding:"28px 24px", display:"flex", flexDirection:"column", alignItems:"center", textAlign:"center" }}>
                    <div style={{ fontSize:56, marginBottom:12 }}>{p.icon}</div>
                    <div style={{ fontSize:11, fontWeight:700, color:"rgba(255,255,255,0.7)", letterSpacing:1.5, textTransform:"uppercase", marginBottom:6 }}>Summer 2025</div>
                    <h3 style={{ fontSize:18, fontWeight:900, color:"white", margin:0 }}>{p.t}</h3>
                  </div>
                  <div style={{ background:"white", padding:"24px" }}>
                    <p style={{ fontSize:13, color:"#374151", lineHeight:1.8, marginBottom:16 }}>{p.d}</p>
                    <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                      {p.stats.map(s=>(
                        <div key={s} style={{ display:"flex", gap:8, alignItems:"center" }}>
                          <div style={{ width:6, height:6, borderRadius:"50%", background:p.c, flexShrink:0 }}/>
                          <span style={{ fontSize:12, color:"#6b7280" }}>{s}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </Container>
      </Section>
    </div>
  );

  // ── CONTACT ───────────────────────────────────────────────────────
  const Contact = () => (
    <div>
      <div style={{ background:grad, padding:"64px 0 52px", position:"relative", overflow:"hidden" }}>
        <img src={SUNSET} alt="QKA Contact" style={{ position:"absolute", inset:0, width:"100%", height:"100%", objectFit:"cover", objectPosition:"center 40%", zIndex:0 }}/>
        <div style={{ position:"absolute", inset:0, background:`linear-gradient(135deg,${gradStart}e8,${GD}cc)`, zIndex:1 }}/>
        <Container style={{ position:"relative", zIndex:2 }}>
          <Tag color="rgba(255,255,255,0.7)">Get in Touch</Tag>
          <h1 style={{ fontSize:"clamp(28px,5vw,46px)", fontWeight:900, color:"white", margin:"0 0 14px" }}>Contact Us</h1>
          <p style={{ fontSize:16, color:"rgba(255,255,255,0.8)", maxWidth:520 }}>We'd love to hear from you. Visit us, call us, or send an email — we're happy to answer any questions about admissions.</p>
        </Container>
      </div>

      <Section style={{ background:"white" }}>
        <Container>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(300px, 1fr))", gap:56, alignItems:"start" }}>
            <div>
              <Tag>Reach Us</Tag>
              <H2>Contact Information</H2>
              <Divider/>
              <div style={{ display:"flex", flexDirection:"column", gap:20, marginBottom:32 }}>
                {[
                  { icon:"📞", t:"Phone", v:"0326-5632236", sub:"Mon–Sat, 8am–4pm", href:"tel:+923265632236" },
                  { icon:"💬", t:"WhatsApp", v:"Chat with us", sub:"Quick enquiries & admissions", href:`https://wa.me/${WHATSAPP_NUMBER}?text=Assalamu%20Alaikum%2C%20I%20would%20like%20to%20enquire%20about%20admissions%20at%20QKA.` },
                  { icon:"✉️", t:"Email", v:"qkaacademy@gmail.com", sub:"We reply within 24 hours", href:"mailto:qkaacademy@gmail.com" },
                  { icon:"📍", t:"Address", v:"Gorsian, Devi Rd., Jatli", sub:"Dist. Rawalpindi, Punjab, Pakistan · Click for directions", href:"https://maps.app.goo.gl/vNGyXXRrtSAbTEG86" },
                  { icon:"🗓️", t:"Admissions", v:"Open Now", sub:"Classes start 1st March · First come, first served" },
                ].map(c=>(
                  <div key={c.t} style={{ display:"flex", gap:16, alignItems:"flex-start" }}>
                    <div style={{ width:48, height:48, borderRadius:12, background:CREAM, display:"flex", alignItems:"center", justifyContent:"center", fontSize:22, flexShrink:0 }}>{c.icon}</div>
                    <div>
                      <div style={{ fontSize:11, fontWeight:700, color:"#9ca3af", textTransform:"uppercase", letterSpacing:1, marginBottom:2 }}>{c.t}</div>
                      {c.href
                        ? <a href={c.href} target="_blank" rel="noopener noreferrer" style={{ fontWeight:800, color:gradStart, fontSize:15, textDecoration:"none" }}>{c.v}</a>
                        : <div style={{ fontWeight:800, color:"#1a1a1a", fontSize:15 }}>{c.v}</div>}
                      <div style={{ fontSize:12, color:"#9ca3af" }}>{c.sub}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <Tag>For Parents</Tag>
              <H2 style={{ fontSize:26 }}>How to Apply</H2>
              <Divider/>
              <div style={{ display:"flex", flexDirection:"column", gap:16 }}>
                {[
                  { s:"Apply online or visit the academy", d:"Submit your application through our online portal or visit us in person during school hours — our team will be delighted to welcome you." },
                  { s:"Collect the prospectus & information pack", d:"Receive our detailed prospectus, application form and complete fee structure so you have everything you need to make an informed decision." },
                  { s:"Appear for the admission assessment", d:"Students applying for Primary and Middle programs sit a short, friendly assessment to help us place them in the right class and stream." },
                  { s:"Attend the parent & student interview", d:"You and your child will be invited for a brief, relaxed interview. Bring the required documents — our team will guide you through every step." },
                  { s:"Receive confirmation & complete enrolment", d:"You will be notified of the outcome promptly. Upon confirmation, complete the enrolment and officially welcome your child to the QKA family!" },
                ].map((item,i)=>(
                  <div key={i} style={{ display:"flex", gap:14, alignItems:"flex-start" }}>
                    <div style={{ width:30, height:30, borderRadius:"50%", background:grad, display:"flex", alignItems:"center", justifyContent:"center", fontSize:12, fontWeight:900, color:"white", flexShrink:0, marginTop:2 }}>{i+1}</div>
                    <div>
                      <div style={{ fontWeight:800, color:"#111827", fontSize:14, marginBottom:3 }}>{item.s}</div>
                      <div style={{ fontSize:13, color:"#6b7280", lineHeight:1.7 }}>{item.d}</div>
                    </div>
                  </div>
                ))}
              </div>

              <div style={{ marginTop:28, background:grad, borderRadius:14, padding:"24px" }}>
                <div style={{ fontFamily:"'Noto Nastaliq Urdu',serif", fontSize:18, color:"rgba(255,255,255,0.85)", marginBottom:12, lineHeight:1.8 }}>
                  {'السَّلَامُ'} {'عَلَيْكُمْ'} {'وَرَحْمَةُ'} {'اللَّهِ'} {'وَبَرَكَاتُهُ'}
                </div>
                <p style={{ fontSize:14, color:"rgba(255,255,255,0.85)", lineHeight:1.7, margin:"0 0 16px" }}>
                  We warmly invite you to visit QKA and experience the environment your child will grow in. Seats are limited {'—'} we encourage early applications to avoid disappointment.
                </p>
                <div style={{ display:"flex", gap:10, flexWrap:"wrap" }}>
                  <button onClick={()=>setAdmissionFormOpen(true)}
                    style={{ background:"white", color:gradStart, border:"none", borderRadius:8, padding:"10px 20px", fontWeight:800, fontSize:13, cursor:"pointer" }}>
                    Apply Online {'→'}
                  </button>
                  <a href="https://maps.app.goo.gl/vNGyXXRrtSAbTEG86" target="_blank" rel="noopener noreferrer"
                    style={{ background:"rgba(255,255,255,0.15)", color:"white", border:"1.5px solid rgba(255,255,255,0.35)", borderRadius:8, padding:"10px 20px", fontWeight:700, fontSize:13, cursor:"pointer", textDecoration:"none" }}>
                    {'📍'} Get Directions
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Google Map */}
          <div style={{ marginTop:52 }}>
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:16, flexWrap:"wrap", gap:12 }}>
              <div>
                <Tag>Find Us</Tag>
                <H2>Our Location</H2>
                <Divider/>
              </div>
              <a href="https://maps.app.goo.gl/vNGyXXRrtSAbTEG86" target="_blank" rel="noopener noreferrer"
                style={{ background:gradStart, color:"white", borderRadius:10, padding:"10px 20px", fontWeight:700, fontSize:13, textDecoration:"none", display:"inline-flex", alignItems:"center", gap:6 }}>
                {'📍'} Open in Google Maps
              </a>
            </div>
            <a href="https://maps.app.goo.gl/vNGyXXRrtSAbTEG86" target="_blank" rel="noopener noreferrer" style={{ display:"block", textDecoration:"none" }}>
              <div style={{ borderRadius:16, overflow:"hidden", border:`2px solid ${G}20`, boxShadow:"0 4px 24px rgba(0,0,0,0.08)", position:"relative" }}>
                <iframe
                  src="https://maps.google.com/maps?q=33.1932,73.046&z=15&output=embed"
                  width="100%" height="380" style={{ border:0, display:"block" }}
                  allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"
                  title="QKA Location"/>
                <div style={{ position:"absolute", inset:0, cursor:"pointer" }} onClick={()=>window.open("https://maps.app.goo.gl/vNGyXXRrtSAbTEG86","_blank")}/>
              </div>
            </a>
            <div style={{ marginTop:12, fontSize:13, color:"#6b7280", textAlign:"center" }}>
              {'📍'} Gorsian, Devi Road, Jatli {'—'} District Rawalpindi, Punjab, Pakistan {'·'} <a href="https://maps.app.goo.gl/vNGyXXRrtSAbTEG86" target="_blank" rel="noopener noreferrer" style={{ color:gradStart, fontWeight:700 }}>Open in Google Maps</a>
            </div>
          </div>
        </Container>
      </Section>
    </div>
  );

  // ── ACTIVITIES & STUDENT LIFE ─────────────────────────────────────
  const Activities = () => (
    <div>
      {/* Hero */}
      <div style={{ position:"relative", padding:"72px 0 60px", overflow:"hidden" }}>
        <img src={SPORTS_DAY} alt="Student Activities" style={{ position:"absolute", inset:0, width:"100%", height:"100%", objectFit:"cover", objectPosition:"center 30%", zIndex:0 }}/>
        <div style={{ position:"absolute", inset:0, background:`linear-gradient(135deg,${gradStart}e0,${GD}c0)`, zIndex:1 }}/>
        <Container style={{ position:"relative", zIndex:2 }}>
          <Tag color="rgba(255,255,255,0.7)">Thriving Students</Tag>
          <h1 style={{ fontSize:"clamp(28px,5vw,46px)", fontWeight:900, color:"white", margin:"0 0 14px" }}>Activities & Student Life</h1>
          <p style={{ fontSize:16, color:"rgba(255,255,255,0.85)", maxWidth:580, lineHeight:1.8 }}>
            A healthy mind lives in a healthy body. At QKA, education goes far beyond the classroom {'—'} we nurture confident, curious and well-rounded young Muslims.
          </p>
        </Container>
      </div>

      {/* Assembly Video Hero */}
      <div style={{ position:"relative", height:600, overflow:"hidden", background:"#0a1022" }}>
        {/* Static blurred ASSEMBLY photo fills any exposed edges */}
        <div style={{ position:"absolute", inset:0, zIndex:0, backgroundImage:`url(${ASSEMBLY})`, backgroundSize:"cover", backgroundPosition:"center 30%", filter:"blur(5px) brightness(0.6)", transform:"scale(1.08)" }}/>
        {/* Main video: contain shows full frame */}
        <video autoPlay muted loop playsInline poster={ASSEMBLY}
          style={{ position:"absolute", inset:0, width:"100%", height:"100%", objectFit:"contain", zIndex:1, filter:"brightness(1.12) contrast(1.08) saturate(1.1)" }}>
          <source src="/assembly-video.mp4" type="video/mp4"/>
        </video>
        <div style={{ position:"absolute", inset:0, background:"linear-gradient(105deg,rgba(10,16,34,0.88) 0%,rgba(10,16,34,0.60) 50%,rgba(0,0,0,0.10) 100%)", zIndex:2 }}/>
        <Container style={{ position:"relative", zIndex:3, height:"100%", display:"flex", alignItems:"center" }}>
          <div style={{ display:"grid", gridTemplateColumns:"1fr auto", gap:48, alignItems:"center", width:"100%", padding:"48px 0" }}>
            <div>
              <div style={{ display:"flex", alignItems:"center", gap:14, marginBottom:20 }}>
                <div style={{ width:3, height:52, background:TEAL, borderRadius:2, flexShrink:0 }}/>
                <div>
                  <div style={{ fontSize:10, fontWeight:700, color:TEAL, letterSpacing:3, textTransform:"uppercase", marginBottom:4 }}>Daily Routine</div>
                  <h2 style={{ fontSize:"clamp(26px,5vw,44px)", fontWeight:900, color:"white", margin:0, lineHeight:1.1 }}>Morning Assembly</h2>
                </div>
              </div>
              <p style={{ fontSize:15, color:"rgba(255,255,255,0.82)", lineHeight:1.9, maxWidth:520, margin:"0 0 14px" }}>
                Every school day at QKA begins with a structured morning assembly {'—'} students line up in orderly rows along the academy's iconic arched corridor, dressed in crisp white shalwar kameez.
              </p>
              <p style={{ fontSize:14, color:"rgba(255,255,255,0.68)", lineHeight:1.9, maxWidth:520, margin:"0 0 24px" }}>
                The assembly includes Quran recitation, du'a, national anthem and brief Islamic reminders {'—'} setting the tone for a disciplined, focused and spiritually connected day of learning.
              </p>
              <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                {["📖 Quran Recitation","🇵🇰 National Anthem","🤲 Du'a","🌟 Tarbiyah","⏰ Discipline & Punctuality"].map(t=>(
                  <span key={t} style={{ background:"rgba(255,255,255,0.12)", border:"1px solid rgba(255,255,255,0.25)", backdropFilter:"blur(6px)", WebkitBackdropFilter:"blur(6px)", borderRadius:22, padding:"6px 14px", fontSize:12, fontWeight:600, color:"white" }}>{t}</span>
                ))}
              </div>
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, flexShrink:0, minWidth:240 }}>
              {[["📅","Daily","Morning Routine"],["🕌","Islamic","Character Building"],["👥","All Students","Participate Together"],["🌄","7:30am","Assembly Start"]].map(([icon,n,l])=>(
                <div key={l} style={{ background:"rgba(255,255,255,0.10)", backdropFilter:"blur(14px)", WebkitBackdropFilter:"blur(14px)", border:"1px solid rgba(255,255,255,0.18)", borderRadius:16, padding:"18px 14px", textAlign:"center" }}>
                  <div style={{ fontSize:26, marginBottom:4 }}>{icon}</div>
                  <div style={{ fontSize:18, fontWeight:900, color:"white", lineHeight:1 }}>{n}</div>
                  <div style={{ fontSize:11, color:"rgba(255,255,255,0.65)", marginTop:5 }}>{l}</div>
                </div>
              ))}
            </div>
          </div>
        </Container>
      </div>

      {/* Sports Day */}
      <Section style={{ background:"white" }}>
        <Container>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(300px, 1fr))", gap:48, alignItems:"center" }}>
            <div>
              <Tag>Annual Event</Tag>
              <H2>Sports Day</H2>
              <Divider/>
              <p style={{ fontSize:15, color:"#374151", lineHeight:1.9, marginBottom:16 }}>
                QKA's annual Sports Day is one of the most anticipated events of the year — a day of energy, laughter and healthy competition. Students compete in physical activities and games on the academy courtyard, decorated beautifully with colourful banners featuring Arabic calligraphy and Islamic names.
              </p>
              <p style={{ fontSize:15, color:"#374151", lineHeight:1.9 }}>
                Sports at QKA is not just about winning {'—'} it's about building character, instilling discipline, learning to follow rules and discovering the value of self-control. Every student participates, every student shines.
              </p>
              <div style={{ marginTop:20, display:"flex", gap:10, flexWrap:"wrap" }}>
                {["Team Building","Healthy Competition","Character Development","Islamic Values"].map(t=>(
                  <span key={t} style={{ background:`${G}12`, color:gradStart, borderRadius:20, padding:"5px 14px", fontSize:12, fontWeight:700 }}>{'✓'} {t}</span>
                ))}
              </div>
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(140px, 1fr))", gap:12 }}>
              <div style={{ borderRadius:14, overflow:"hidden", gridColumn:"1/-1", height:220 }}>
                <img src={SPORTS_DAY} onClick={()=>setLightbox(SPORTS_DAY)} style={{ width:"100%", height:"100%", objectFit:"cover", cursor:"zoom-in" }} alt="Sports Day"/>
              </div>
              <div style={{ borderRadius:14, overflow:"hidden", height:160 }}>
                <img src={SPORTS_DAY2} onClick={()=>setLightbox(SPORTS_DAY2)} style={{ width:"100%", height:"100%", objectFit:"cover", cursor:"zoom-in" }} alt="Sports Day 2"/>
              </div>
              <div style={{ borderRadius:14, overflow:"hidden", height:160, background:`${G}15`, display:"flex", alignItems:"center", justifyContent:"center" }}>
                <div style={{ textAlign:"center", color:gradStart }}>
                  <div style={{ fontSize:36 }}>{'🏆'}</div>
                  <div style={{ fontSize:13, fontWeight:700, marginTop:8 }}>Annual Competition</div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </Section>

      {/* National Days */}
      <Section style={{ background:CREAM }}>
        <Container>
          <Tag>National Celebrations</Tag>
          <H2>Independence Day & Iqbal Day</H2>
          <Divider/>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(300px, 1fr))", gap:28 }}>
            {/* Independence Day */}
            <div style={{ borderRadius:16, overflow:"hidden", boxShadow:"0 4px 24px rgba(0,0,0,0.08)", background:"white" }}>
              <div style={{ position:"relative", height:260, overflow:"hidden" }}>
                <img src={IND_DAY} onClick={()=>setLightbox(IND_DAY)} style={{ width:"100%", height:"100%", objectFit:"cover", objectPosition:"center 30%", cursor:"zoom-in" }} alt="Independence Day"/>
                <div style={{ position:"absolute", inset:0, background:"linear-gradient(to top,rgba(0,0,0,0.55),transparent)" }}/>
                <div style={{ position:"absolute", top:14, left:14, background:"#006600", color:"white", borderRadius:20, padding:"4px 14px", fontSize:11, fontWeight:700 }}>14th August 2025</div>
                <div style={{ position:"absolute", bottom:14, left:16, color:"white", fontWeight:900, fontSize:17 }}>{'یوم'} {'آزادی'} {'—'} Independence Day</div>
              </div>
              <div style={{ padding:"22px 24px" }}>
                <p style={{ fontSize:14, color:"#374151", lineHeight:1.8, margin:0 }}>
                  On 14th August 2025 {'—'} Pakistan's 78th Independence Day — QKA held a special flag-hoisting ceremony in the presence of Founder Dr. Hafiz Muhammad Afzal. Students waved the national flag, recited national poetry and reflected on the sacrifices that gave Pakistan its independence. A proud, patriotic and deeply Islamic celebration.
                </p>
              </div>
            </div>
            {/* Iqbal Day */}
            <div style={{ borderRadius:16, overflow:"hidden", boxShadow:"0 4px 24px rgba(0,0,0,0.08)", background:"white" }}>
              <div style={{ position:"relative", height:260, overflow:"hidden" }}>
                <img src={IQBAL_DAY} onClick={()=>setLightbox(IQBAL_DAY)} style={{ width:"100%", height:"100%", objectFit:"cover", objectPosition:"center 30%", cursor:"zoom-in" }} alt="Iqbal Day"/>
                <div style={{ position:"absolute", inset:0, background:"linear-gradient(to top,rgba(0,0,0,0.55),transparent)" }}/>
                <div style={{ position:"absolute", top:14, left:14, background:NAVY, color:"white", borderRadius:20, padding:"4px 14px", fontSize:11, fontWeight:700 }}>9th November</div>
                <div style={{ position:"absolute", bottom:14, left:16, color:"white", fontWeight:900, fontSize:17 }}>{'یوم'} {'اقبال'} {'—'} Iqbal Day</div>
              </div>
              <div style={{ padding:"22px 24px" }}>
                <p style={{ fontSize:14, color:"#374151", lineHeight:1.8, margin:0 }}>
                  Every year QKA commemorates Allama Iqbal Day with speeches, poetry recitation and discussions on Iqbal's philosophy of Islamic revival and the pursuit of knowledge. Students are inspired by the words of the Poet of the East — شاعرِ مشرق — whose vision of a confident, educated Muslim youth remains our guiding light.
                </p>
              </div>
            </div>
          </div>
        </Container>
      </Section>

      {/* Trips */}
      <Section style={{ background:CREAM }}>
        <Container>
          <Tag color="#7c3aed">Educational Excursions</Tag>
          <H2>School Trips</H2>
          <Divider color="#7c3aed"/>
          <p style={{ fontSize:15, color:"#6b7280", lineHeight:1.8, marginBottom:40, maxWidth:640 }}>
            We believe real-world learning inspires students in ways no classroom can. Our carefully planned trips combine history, nature, science and Islamic heritage {'—'} giving students experiences they carry for life.
          </p>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(300px, 1fr))", gap:28 }}>
            {/* Islamabad Heritage Trip — 2025 (LEFT) */}
            <div style={{ borderRadius:16, overflow:"hidden", background:"white", boxShadow:"0 4px 24px rgba(0,0,0,0.08)" }}>
              <div style={{ position:"relative", height:260, overflow:"hidden", cursor:"zoom-in" }} onClick={()=>setLightbox(AUGUST_TRIP_1)}>
                <img src={AUGUST_TRIP_1} style={{ width:"100%", height:"100%", objectFit:"cover", objectPosition:"center 20%" }} alt="Islamabad Trip"/>
                <div style={{ position:"absolute", inset:0, background:"linear-gradient(to top,rgba(0,0,0,0.6),rgba(0,0,0,0.1))" }}/>
                <div style={{ position:"absolute", top:14, left:14, background:G, color:"white", borderRadius:20, padding:"4px 14px", fontSize:11, fontWeight:700 }}>August 2025</div>
                <div style={{ position:"absolute", bottom:14, left:16, right:16, color:"white" }}>
                  <div style={{ fontWeight:900, fontSize:17 }}>Heritage Trip {'—'} Islamabad & Rawat</div>
                </div>
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:6, padding:10 }}>
                {[[NATIONAL_MUSEUM_1,"National Museum"],[NATIONAL_MUSEUM_2,"Museum Visit"],[ISLOO_TRIP,"Islamabad Trip"],[ISLOO_TRIP2,"Heritage Tour"]].map(([src,cap])=>(
                  <div key={cap} onClick={()=>setLightbox(src)} style={{ cursor:"zoom-in", borderRadius:8, overflow:"hidden" }}>
                    <img src={src} style={{ width:"100%", height:90, objectFit:"cover" }} alt={cap}/>
                  </div>
                ))}
              </div>
              <div style={{ padding:"4px 20px 20px" }}>
                <div style={{ fontSize:12, fontWeight:700, color:gradStart, marginBottom:8 }}>Destinations visited</div>
                {["Faisal Mosque, Islamabad","National Museum of Natural History","Shakarparian Hills","Rawat Fort (historic Mughal)"].map(i=>(
                  <div key={i} style={{ fontSize:12, color:"#374151", marginBottom:3 }}>{'•'} {i}</div>
                ))}
                <p style={{ fontSize:13, color:"#374151", lineHeight:1.8, margin:"10px 0 0" }}>
                  A full-day journey through Pakistan's heart — Islamic architecture at the magnificent Faisal Mosque, natural science at the National Museum, panoramic views from Shakarparian, and centuries of Mughal history at Rawat Fort.
                </p>
              </div>
            </div>
            {/* Ayub Park Trip — January 2026 (RIGHT) */}
            <div style={{ borderRadius:16, overflow:"hidden", background:"white", boxShadow:"0 4px 24px rgba(0,0,0,0.08)" }}>
              <div style={{ position:"relative", height:260, overflow:"hidden", cursor:"zoom-in" }} onClick={()=>setLightbox(AYUB_TRIP)}>
                <img src={AYUB_TRIP} style={{ width:"100%", height:"100%", objectFit:"cover", objectPosition:"center 25%" }} alt="Ayub Park Trip"/>
                <div style={{ position:"absolute", inset:0, background:"linear-gradient(to top,rgba(0,0,0,0.6),rgba(0,0,0,0.1))" }}/>
                <div style={{ position:"absolute", top:14, left:14, background:"#7c3aed", color:"white", borderRadius:20, padding:"4px 14px", fontSize:11, fontWeight:700 }}>January 2026</div>
                <div style={{ position:"absolute", bottom:14, left:16, right:16, color:"white" }}>
                  <div style={{ fontWeight:900, fontSize:17 }}>Ayub National Park, Rawalpindi</div>
                </div>
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8, padding:12 }}>
                <div onClick={()=>setLightbox(AYUB_TRIP2)} style={{ cursor:"zoom-in", borderRadius:10, overflow:"hidden" }}>
                  <img src={AYUB_TRIP2} style={{ width:"100%", height:110, objectFit:"cover" }} alt="Ayub Park 2"/>
                </div>
                <div onClick={()=>setLightbox(AYUB_PARK_2)} style={{ cursor:"zoom-in", borderRadius:10, overflow:"hidden" }}>
                  <img src={AYUB_PARK_2} style={{ width:"100%", height:110, objectFit:"cover" }} alt="Ayub Park 3"/>
                </div>
              </div>
              <div style={{ padding:"4px 20px 20px" }}>
                <div style={{ fontSize:12, fontWeight:700, color:"#7c3aed", marginBottom:8 }}>What students explored</div>
                {["Lush green walking trails","Wildlife & plant life","Team bonding activities","Fresh air & open spaces"].map(i=>(
                  <div key={i} style={{ fontSize:12, color:"#374151", marginBottom:3 }}>{'•'} {i}</div>
                ))}
                <p style={{ fontSize:13, color:"#374151", lineHeight:1.8, margin:"10px 0 0" }}>
                  Students explored Ayub National Park in Rawalpindi {'—'} Pakistan's oldest preserved green space. The trip combined nature education, physical activity and joyful team bonding in the crisp January air.
                </p>
              </div>
            </div>
          </div>
        </Container>
      </Section>

      {/* International Guest Lecture Series */}
      <Section style={{ background:"white" }}>
        <Container>
          {/* Series header */}
          <div style={{ textAlign:"center", marginBottom:52 }}>
            <Tag color="#7c3aed">{'🌍'} International Guest Lecture Series</Tag>
            <H2>Where the World Comes to QKA</H2>
            <Divider color="#7c3aed"/>
            <p style={{ fontSize:15, color:"#6b7280", maxWidth:660, margin:"0 auto 16px", lineHeight:1.9 }}>
              From Silicon Valley AI tools to engineering design thinking {'—'} QKA brings internationally recognised faculty directly into our classrooms, ensuring our students experience world-class learning without leaving Gorsian.
            </p>
            <div style={{ background:`${G}08`, borderRadius:14, padding:"18px 24px", maxWidth:660, margin:"0 auto", border:`1px solid ${G}20` }}>
              <div style={{ fontSize:14, fontWeight:800, color:gradStart, marginBottom:6 }}>{'🤖'} Our Mission {'—'} AI & Digital Awareness</div>
              <p style={{ fontSize:14, color:"#374151", lineHeight:1.8, margin:0 }}>
                At QKA, we believe every student and teacher must be equipped for the world they will live and work in. Through our short courses and guest sessions, we aim to build genuine awareness of Artificial Intelligence and modern digital tools {'—'} not just as subjects, but as practical superpowers for everyday life, learning and career. An educated community is an empowered one.
              </p>
            </div>
          </div>

          {/* Two session cards */}
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))", gap:28, marginBottom:20 }}>

            {/* Session 01 — AI */}
            <div style={{ background:CREAM, borderRadius:20, overflow:"hidden", border:"1px solid #c4b5fd" }}>
              <div style={{ background:"linear-gradient(135deg,#7c3aed,#5b21b6)", padding:"18px 24px", display:"flex", alignItems:"center", gap:14 }}>
                <div style={{ background:"rgba(255,255,255,0.15)", borderRadius:10, padding:"8px 14px", fontSize:11, fontWeight:800, color:"white", letterSpacing:1 }}>SESSION 01</div>
                <div style={{ fontSize:13, fontWeight:700, color:"rgba(255,255,255,0.85)" }}>Artificial Intelligence</div>
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8, padding:12 }}>
                <div onClick={()=>setLightbox(AI_COURSE_1)} style={{ borderRadius:10, overflow:"hidden", cursor:"zoom-in", gridColumn:"1/-1" }}>
                  <img src={AI_COURSE_1} alt="AI Course" style={{ width:"100%", height:200, objectFit:"cover", display:"block" }}/>
                </div>
                <div onClick={()=>setLightbox(AI_COURSE_2)} style={{ borderRadius:10, overflow:"hidden", cursor:"zoom-in", gridColumn:"1/-1" }}>
                  <img src={AI_COURSE_2} alt="AI Course 2" style={{ width:"100%", height:150, objectFit:"cover", display:"block" }}/>
                </div>
              </div>
              <div style={{ padding:"0 22px 24px" }}>
                <h3 style={{ fontSize:17, fontWeight:900, color:"#1a1a1a", margin:"0 0 10px" }}>Artificial Intelligence Course</h3>
                <p style={{ fontSize:13, color:"#374151", lineHeight:1.9, marginBottom:14 }}>
                  Students completed a comprehensive AI course covering <strong>ChatGPT, Microsoft Copilot, Google Gemini and Claude</strong>. Delivered by faculty from an International University, the sessions were hands-on, interactive and genuinely eye-opening {'—'} integrating modern technology with traditional Islamic education.
                </p>
                <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginBottom:14 }}>
                  {["ChatGPT","Copilot","Gemini","Claude AI"].map(t=>(
                    <span key={t} style={{ background:"#f3e8ff", color:"#7c3aed", borderRadius:20, padding:"4px 12px", fontSize:11, fontWeight:700 }}>{'🤖'} {t}</span>
                  ))}
                </div>
                <div style={{ background:"#f3e8ff", borderRadius:10, padding:"12px 16px", borderLeft:"4px solid #7c3aed" }}>
                  <div style={{ fontSize:12, fontWeight:800, color:"#6d28d9" }}>{'🏛️'} Delivered by Faculty {'—'} International University</div>
                </div>
              </div>
            </div>

            {/* Session 02 — Engineering */}
            <div style={{ background:CREAM, borderRadius:20, overflow:"hidden", border:"1px solid #fed7aa" }}>
              <div style={{ background:"linear-gradient(135deg,#d97706,#b45309)", padding:"18px 24px", display:"flex", alignItems:"center", gap:14 }}>
                <div style={{ background:"rgba(255,255,255,0.15)", borderRadius:10, padding:"8px 14px", fontSize:11, fontWeight:800, color:"white", letterSpacing:1 }}>SESSION 02</div>
                <div style={{ fontSize:13, fontWeight:700, color:"rgba(255,255,255,0.85)" }}>Engineering & Design</div>
              </div>
              <div style={{ padding:12 }}>
                <div style={{ background:"linear-gradient(135deg,#d97706,#b45309)", borderRadius:10, height:200, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", textAlign:"center", padding:24 }}>
                  <div style={{ fontSize:56, marginBottom:10 }}>{'⚙️'}</div>
                  <div style={{ fontSize:15, fontWeight:900, color:"white", lineHeight:1.4 }}>Engineering the Future {'—'}<br/>One Young Mind at a Time</div>
                </div>
              </div>
              <div style={{ padding:"0 22px 24px" }}>
                <h3 style={{ fontSize:17, fontWeight:900, color:"#1a1a1a", margin:"0 0 10px" }}>Introduction to Engineering & Design</h3>
                <p style={{ fontSize:13, color:"#374151", lineHeight:1.9, marginBottom:14 }}>
                  Faculty from a renowned university delivered an inspiring short course on engineering design thinking. Students explored how engineers identify problems, sketch solutions and build prototypes {'—'} from bridge curves to circuit boards. Hands-on, visual and unforgettable.
                </p>
                <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginBottom:14 }}>
                  {["Design Thinking","Problem Solving","STEM","Prototyping"].map(t=>(
                    <span key={t} style={{ background:"#fef3c7", color:"#b45309", borderRadius:20, padding:"4px 12px", fontSize:11, fontWeight:700 }}>{'⚙️'} {t}</span>
                  ))}
                </div>
                <div style={{ background:"#fef3c7", borderRadius:10, padding:"12px 16px", borderLeft:"4px solid #d97706" }}>
                  <div style={{ fontSize:12, fontWeight:800, color:"#92400e" }}>{'🏛️'} Delivered by Faculty {'—'} Renowned University</div>
                </div>
              </div>
            </div>
          </div>

          {/* Series note */}
          <div style={{ background:`linear-gradient(135deg,${gradStart},${GD})`, borderRadius:14, padding:"20px 28px", display:"flex", alignItems:"center", gap:20, flexWrap:"wrap" }}>
            <div style={{ fontSize:32 }}>{'🌍'}</div>
            <div>
              <div style={{ fontSize:14, fontWeight:800, color:"white", marginBottom:4 }}>More sessions coming {'—'} watch this space</div>
              <div style={{ fontSize:13, color:"rgba(255,255,255,0.82)", lineHeight:1.7 }}>QKA is committed to bringing international expertise to our students every year. These short courses are part of our ongoing mission to prepare young minds for both Deen and Duniya.</div>
            </div>
          </div>
        </Container>
      </Section>

      {/* Staff Excellence */}
      <Section style={{ background:CREAM }}>
        <Container>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))", gap:48, alignItems:"center" }}>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
              {[[TEACHERS_TRAINING_1,"Training Session 1"],[TEACHERS_TRAINING_2,"Training Session 2"]].map(([src,cap])=>(
                <div key={cap} onClick={()=>setLightbox(src)} style={{ borderRadius:14, overflow:"hidden", boxShadow:"0 4px 20px rgba(0,0,0,0.1)", cursor:"zoom-in" }}>
                  <img src={src} alt={cap} style={{ width:"100%", height:200, objectFit:"cover", display:"block" }}/>
                </div>
              ))}
              <div style={{ gridColumn:"1/-1", background:`linear-gradient(135deg,${gradStart},${GD})`, borderRadius:14, padding:"20px 22px" }}>
                <div style={{ fontSize:13, fontWeight:800, color:"white", marginBottom:6 }}>Since 2020 {'—'} Ongoing</div>
                <div style={{ display:"flex", gap:12, flexWrap:"wrap", marginTop:8 }}>
                  {["🇬🇧 UK","🇸🇦 Saudi Arabia","International Universities"].map(t=>(
                    <span key={t} style={{ background:"rgba(255,255,255,0.15)", borderRadius:20, padding:"4px 12px", fontSize:11, fontWeight:700, color:"white" }}>{t}</span>
                  ))}
                </div>
              </div>
            </div>
            <div>
              <Tag color={NAVY}>{'👨‍🏫'} Staff Excellence Programme</Tag>
              <H2>Training the Teachers Who Shape Tomorrow</H2>
              <Divider color={NAVY}/>
              <p style={{ fontSize:15, color:"#374151", lineHeight:1.9, marginBottom:14 }}>
                Since our modern expansion in 2020, QKA has made staff development a cornerstone of its vision. Our teachers undergo <strong>regular, structured training</strong> delivered by internationally recognised faculty from universities in the <strong>UK and Saudi Arabia</strong>.
              </p>
              <p style={{ fontSize:15, color:"#374151", lineHeight:1.9, marginBottom:20 }}>
                Sessions cover modern pedagogy, creative teaching tools, classroom innovation, child psychology and Islamic values in education {'—'} ensuring every QKA teacher is not just qualified, but genuinely inspired. <em>Because when teachers grow, students soar.</em>
              </p>
              <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                {[
                  "Modern pedagogy and curriculum delivery",
                  "Creative tools and technology-integrated teaching",
                  "Child psychology and student wellbeing",
                  "Islamic values woven into everyday teaching",
                  "Continuous professional development every year",
                ].map(f=>(
                  <div key={f} style={{ display:"flex", gap:10, alignItems:"flex-start" }}>
                    <Check color={NAVY}/>
                    <span style={{ fontSize:14, color:"#374151" }}>{f}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Container>
      </Section>

      {/* CTA */}
      <div style={{ background:grad, padding:"52px 24px", textAlign:"center" }}>
        <Container style={{ maxWidth:600 }}>
          <h2 style={{ fontSize:28, fontWeight:900, color:"white", margin:"0 0 12px" }}>Give Your Child More Than Education</h2>
          <p style={{ color:"rgba(255,255,255,0.82)", fontSize:15, lineHeight:1.8, marginBottom:24 }}>At QKA, every student is seen, valued and nurtured {'—'} in the classroom, on the sports ground, and beyond.</p>
          <button onClick={()=>setAdmissionFormOpen(true)}
            style={{ background:"white", color:gradStart, border:"none", borderRadius:10, padding:"13px 32px", fontWeight:800, fontSize:14, cursor:"pointer" }}>
            Apply Online for Admissions {'→'}
          </button>
        </Container>
      </div>
    </div>
  );

  // ── RENDER ─────────────────────────────────────────────────────────
  return (
    <div style={{ minHeight:"100vh", fontFamily:"'Plus Jakarta Sans',sans-serif", background:"white" }}>
      {showLogin && <LoginModal onClose={()=>setShowLogin(false)} onLogin={s=>{setShowLogin(false);onLogin(s);}} S={S}/>}
      {admissionFormOpen && <AdmissionFormModal onClose={()=>setAdmissionFormOpen(false)} gradStart={gradStart} G={G} GOLD={GOLD} CREAM={CREAM} GD={GD} />}
      {Lightbox()}
      <AnnouncementPopup/>

      {/* Floating WhatsApp Button */}
      <a href={`https://wa.me/${WHATSAPP_NUMBER}?text=Assalamu%20Alaikum%2C%20I%20would%20like%20to%20enquire%20about%20admissions%20at%20QKA.`}
        target="_blank" rel="noopener noreferrer"
        title="Chat with us on WhatsApp"
        style={{ position:"fixed", bottom:28, right:24, zIndex:9998, width:56, height:56, borderRadius:"50%", background:"#25d366", display:"flex", alignItems:"center", justifyContent:"center", boxShadow:"0 4px 20px rgba(37,211,102,0.5)", textDecoration:"none", transition:"transform .2s" }}
        onMouseEnter={e=>e.currentTarget.style.transform="scale(1.1)"}
        onMouseLeave={e=>e.currentTarget.style.transform="scale(1)"}>
        <svg width="28" height="28" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
      </a>

      {Nav()}
      <main>
        { page==="home"        ? Home()        :
          page==="about"       ? About()       :
          page==="programs"    ? Programs()    :
          page==="admissions"  ? Admissions()  :
          page==="facilities"  ? Facilities()  :
          page==="campus-life" ? CampusLife()  :
          page==="activities"  ? Activities()  :
          page==="community"   ? Community()   :
          page==="contact"     ? Contact()     :
          Home() }
      </main>
      <footer style={{ background:"#111827", padding:"36px 24px" }}>
        <Container>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(200px, 1fr))", gap:32, marginBottom:28 }}>
            <div>
              <div style={{ fontFamily:"'Noto Nastaliq Urdu',serif", fontSize:20, color:"white", marginBottom:6 }}>{schoolUr}</div>
              <div style={{ fontSize:13, fontWeight:700, color:"rgba(255,255,255,0.8)", marginBottom:4 }}>{schoolEn}</div>
              <div style={{ fontSize:12, color:"rgba(255,255,255,0.45)", lineHeight:1.7 }}>{affil}<br/>{address}<br/>Reg. No: {regNo}</div>
            </div>
            <div>
              <div style={{ fontSize:12, fontWeight:700, color:"rgba(255,255,255,0.5)", textTransform:"uppercase", letterSpacing:1, marginBottom:14 }}>Quick Links</div>
              {PAGES.map((p,i)=><button key={p} onClick={()=>go(p)} style={{ display:"block", background:"none", border:"none", color:"rgba(255,255,255,0.6)", fontSize:13, cursor:"pointer", padding:"3px 0", textAlign:"left" }}>{NAV[i]}</button>)}
            </div>
            <div>
              <div style={{ fontSize:12, fontWeight:700, color:"rgba(255,255,255,0.5)", textTransform:"uppercase", letterSpacing:1, marginBottom:14 }}>Contact</div>
              {[["📞","0326-5632236","tel:+923265632236"],["✉️","qkaacademy@gmail.com","mailto:qkaacademy@gmail.com"],["📍","Gorsian, Devi Rd., Jatli, Rawalpindi","https://maps.app.goo.gl/vNGyXXRrtSAbTEG86"]].map(([i,t,href])=>(
                <a key={t} href={href} target="_blank" rel="noopener noreferrer" style={{ display:"flex", gap:8, marginBottom:8, alignItems:"flex-start", textDecoration:"none" }}>
                  <span style={{ fontSize:14 }}>{i}</span>
                  <span style={{ fontSize:12, color:"rgba(255,255,255,0.6)", lineHeight:1.5 }}>{t}</span>
                </a>
              ))}
            </div>
          </div>
          <div style={{ borderTop:"1px solid rgba(255,255,255,0.08)", paddingTop:20, display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:14 }}>
            <div style={{ fontSize:12, color:"rgba(255,255,255,0.3)", display:"flex", alignItems:"center", gap:12, flexWrap:"wrap" }}>
              <span>{'©'} {new Date().getFullYear()} Quran Karim Academy (Waqf) Pakistan. All rights reserved.</span>
              <span style={{ display:"flex", alignItems:"center", gap:6 }}>
                Designed & built with {'✨'} by
                <span style={{ width:24, height:24, borderRadius:"50%", background:"linear-gradient(135deg,#1a6b3c,#f0a500)", display:"inline-flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                  <span style={{ color:"white", fontSize:8, fontWeight:700, letterSpacing:1 }}>AR</span>
                </span>
              </span>
            </div>
            <button onClick={()=>{ if(onPortalClick) onPortalClick(); else setShowLogin(true); }} style={{ background:`${G}30`, color:accent, border:`1px solid ${G}50`, borderRadius:8, padding:"6px 16px", fontSize:12, fontWeight:700, cursor:"pointer" }}>Portal</button>
          </div>
        </Container>
      </footer>
    </div>
  );
}
/**
 * AnnouncementPopup.jsx
 * ─────────────────────────────────────────────────────────────
 * Drop this anywhere in your Next.js app (e.g. _app.jsx or layout.jsx).
 * It fetches the latest active popup announcement from Supabase and
 * shows it once per day (respects "Don't show again today").
 *
 * SETUP:
 *  1. npm install @supabase/supabase-js   (if not already)
 *  2. Set NEXT_PUBLIC_SUPABASE_URL and NEXT_PUBLIC_SUPABASE_ANON_KEY
 *     in your .env.local
 *  3. Run the SQL below in Supabase SQL Editor (adds popup columns)
 *  4. Import and render <AnnouncementPopup /> in your _app.jsx or layout
 *
 * SQL (run once in Supabase):
 * ─────────────────────────────────────────────────────────────
 *   ALTER TABLE announcements ADD COLUMN IF NOT EXISTS show_as_popup      BOOLEAN DEFAULT FALSE;
 *   ALTER TABLE announcements ADD COLUMN IF NOT EXISTS popup_image_url    TEXT;
 *   ALTER TABLE announcements ADD COLUMN IF NOT EXISTS popup_button_text  TEXT DEFAULT 'Learn More';
 *   ALTER TABLE announcements ADD COLUMN IF NOT EXISTS popup_button_url   TEXT;
 *   ALTER TABLE announcements ADD COLUMN IF NOT EXISTS popup_expires_at   DATE;
 * ─────────────────────────────────────────────────────────────
 */

"use client"; // remove this line if you're using Next.js pages/ directory (not app/)

// ── School branding ─────────────────────────────────────────────
const SCHOOL_NAME    = "QUR'AN-E-KARIM ACADEMY";
const SCHOOL_NAME_UR = "قرآن کریم اکیڈمی";
const BRAND_COLOR    = "#1a6b3c";  // dark green
const LOGO_URL       = "";         // optional: set to your logo URL e.g. "/logo.png"

// ── Storage key (one dismiss per day) ───────────────────────────
const storageKey = (id) => `qka_popup_dismissed_${id}_${new Date().toISOString().split("T")[0]}`;



export function AnnouncementPopup() {
  const [popup,   setPopup]   = useState(null);  // the announcement object
  const [visible, setVisible] = useState(false);
  const [imgErr,  setImgErr]  = useState(false);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    fetchPopup();
  }, []);

  async function fetchPopup() {
    try {
      const today = new Date().toISOString().split("T")[0];

      const { data, error } = await supabase
        .from("announcements")
        .select("id, title, body, popup_image_url, popup_button_text, popup_button_url, popup_expires_at, popup_overlay_opacity, popup_width, popup_card_style, created_at")
        .eq("is_published", true)
        .eq("show_as_popup", true)
        .or(`popup_expires_at.is.null,popup_expires_at.gte.${today}`)
        .order("created_at", { ascending: false })
        .limit(1)
        .single();

      if (error || !data) return;

      // Check if already dismissed today
      if (typeof window !== "undefined") {
        const dismissed = localStorage.getItem(storageKey(data.id));
        if (dismissed) return;
      }

      setPopup(data);
      // Small delay so page loads first
      setTimeout(() => setVisible(true), 800);
    } catch (e) {
      console.warn("AnnouncementPopup fetch error:", e);
    }
  }

  function dismiss(remember = false) {
    setClosing(true);
    setTimeout(() => {
      setVisible(false);
      setClosing(false);
      if (remember && popup && typeof window !== "undefined") {
        localStorage.setItem(storageKey(popup.id), "1");
      }
    }, 300);
  }

  if (!visible || !popup) return null;

  const hasImage  = popup.popup_image_url && !imgErr;
  const hasButton = popup.popup_button_text && popup.popup_button_url;
  const bodyShort = (popup.body || "").length > 220
    ? popup.body.slice(0, 220) + "…"
    : popup.body;

  return (
    <>
      {/* ── Backdrop ── */}
      <div
        onClick={() => dismiss(false)}
        style={{
          position:        "fixed",
          inset:           0,
          background:      `rgba(0,0,0,${((popup.popup_overlay_opacity??60)/100).toFixed(2)})`,
          zIndex:          9998,
          backdropFilter:  "blur(3px)",
          WebkitBackdropFilter: "blur(3px)",
          animation:       closing ? "qka_fadeOut .3s ease forwards" : "qka_fadeIn .3s ease forwards",
        }}
      />

      {/* ── Modal ── */}
      <div
        role="dialog"
        aria-modal="true"
        aria-label={popup.title}
        style={{
          position:     "fixed",
          top:          "50%",
          left:         "50%",
          transform:    "translate(-50%, -50%)",
          zIndex:       9999,
          width:        `min(96vw, ${{compact:480,standard:680,wide:860}[popup.popup_width]||680}px)`,
          maxHeight:    "90vh",
          overflowY:    "auto",
          borderRadius: 24,
          overflow:     "hidden",
          boxShadow:    "0 20px 60px rgba(0,0,0,0.45), 0 0 0 1px rgba(255,255,255,0.08)",
          animation:    closing ? "qka_slideOut .3s ease forwards" : "qka_slideIn .35s cubic-bezier(.34,1.56,.64,1) forwards",
          background:   popup.popup_card_style==="frosted"?"rgba(255,255,255,0.82)":popup.popup_card_style==="clear"?"rgba(255,255,255,0.52)":"#ffffff",
          backdropFilter:       popup.popup_card_style!=="solid"?"blur(18px)":"none",
          WebkitBackdropFilter: popup.popup_card_style!=="solid"?"blur(18px)":"none",
        }}
      >
        {/* ── Hero image area ── */}
        <div style={{ position: "relative", height: hasImage ? 320 : 140, overflow: "hidden", flexShrink: 0 }}>
          {/* Background */}
          {hasImage ? (
            <img
              src={popup.popup_image_url}
              alt=""
              onError={() => setImgErr(true)}
              style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
            />
          ) : (
            <div style={{
              width:      "100%",
              height:     "100%",
              background: `linear-gradient(135deg, ${BRAND_COLOR} 0%, #0a4a24 50%, #2d9e6b 100%)`,
            }} />
          )}

          {/* Gradient overlay */}
          <div style={{
            position:   "absolute",
            inset:      0,
            background: hasImage
              ? "linear-gradient(to bottom, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.72) 100%)"
              : "linear-gradient(to bottom, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.4) 100%)",
          }}/>

          {/* School branding */}
          <div style={{
            position:   "absolute",
            top:        16,
            left:       18,
            display:    "flex",
            alignItems: "center",
            gap:        10,
          }}>
            {LOGO_URL && (
              <img src={LOGO_URL} alt="logo" style={{ width: 36, height: 36, borderRadius: "50%", border: "2px solid rgba(255,255,255,0.8)", objectFit: "cover" }}/>
            )}
            <div>
              <div style={{ color: "white", fontWeight: 900, fontSize: 12, letterSpacing: 0.5, lineHeight: 1.2 }}>{SCHOOL_NAME}</div>
              <div style={{ color: "rgba(255,255,255,0.75)", fontSize: 10, fontFamily: "serif", marginTop: 1 }}>{SCHOOL_NAME_UR}</div>
            </div>
          </div>

          {/* Close button */}
          <button
            onClick={() => dismiss(false)}
            aria-label="Close popup"
            style={{
              position:     "absolute",
              top:          12,
              right:        12,
              width:        32,
              height:       32,
              borderRadius: "50%",
              border:       "none",
              background:   "rgba(255,255,255,0.9)",
              color:        "#374151",
              fontSize:     16,
              fontWeight:   900,
              cursor:       "pointer",
              display:      "flex",
              alignItems:   "center",
              justifyContent: "center",
              lineHeight:   1,
              boxShadow:    "0 2px 8px rgba(0,0,0,0.2)",
              transition:   "background .15s, transform .15s",
            }}
            onMouseEnter={e => { e.currentTarget.style.background = "white"; e.currentTarget.style.transform = "scale(1.1)"; }}
            onMouseLeave={e => { e.currentTarget.style.background = "rgba(255,255,255,0.9)"; e.currentTarget.style.transform = "scale(1)"; }}
          >
            ✕
          </button>

          {/* Title overlay on image */}
          {hasImage && (
            <div style={{
              position:   "absolute",
              bottom:     0,
              left:       0,
              right:      0,
              padding:    "16px 20px 14px",
            }}>
              <div style={{
                color:      "white",
                fontWeight: 900,
                fontSize:   18,
                lineHeight: 1.3,
                textShadow: "0 1px 4px rgba(0,0,0,0.4)",
              }}>
                {popup.title}
              </div>
            </div>
          )}
        </div>

        {/* ── Body ── */}
        <div style={{ padding: "18px 22px 0" }}>
          {/* Title (only when no image) */}
          {!hasImage && (
            <div style={{
              color:        BRAND_COLOR,
              fontWeight:   900,
              fontSize:     19,
              lineHeight:   1.3,
              marginBottom: 10,
            }}>
              {popup.title}
            </div>
          )}

          <p style={{
            margin:     0,
            fontSize:   14,
            color:      "#374151",
            lineHeight: 1.75,
            fontFamily: "Georgia, serif",
          }}>
            {bodyShort}
          </p>
        </div>

        {/* ── Footer ── */}
        <div style={{
          padding:    "16px 22px 20px",
          display:    "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap:        12,
          flexWrap:   "wrap",
        }}>
          {/* Don't show again */}
          <button
            onClick={() => dismiss(true)}
            style={{
              background: "none",
              border:     "none",
              fontSize:   12,
              color:      "#9ca3af",
              cursor:     "pointer",
              padding:    0,
              fontFamily: "inherit",
              textDecoration: "underline",
              textUnderlineOffset: 3,
            }}
          >
            Don't show again today
          </button>

          <div style={{ display: "flex", gap: 8 }}>
            <button
              onClick={() => dismiss(false)}
              style={{
                background:   "#f3f4f6",
                border:       "none",
                borderRadius: 9,
                padding:      "9px 18px",
                fontSize:     13,
                fontWeight:   700,
                color:        "#374151",
                cursor:       "pointer",
                fontFamily:   "inherit",
              }}
            >
              Close
            </button>

            {hasButton && (
              <a
                href={popup.popup_button_url}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => dismiss(true)}
                style={{
                  background:     BRAND_COLOR,
                  color:          "white",
                  borderRadius:   9,
                  padding:        "9px 20px",
                  fontSize:       13,
                  fontWeight:     800,
                  textDecoration: "none",
                  display:        "inline-flex",
                  alignItems:     "center",
                  gap:            6,
                  boxShadow:      `0 3px 12px ${BRAND_COLOR}55`,
                  transition:     "opacity .15s",
                }}
                onMouseEnter={e => e.currentTarget.style.opacity = "0.88"}
                onMouseLeave={e => e.currentTarget.style.opacity = "1"}
              >
                {popup.popup_button_text} →
              </a>
            )}
          </div>
        </div>
      </div>

      {/* ── Keyframe animations ── */}
      <style>{`
        @keyframes qka_fadeIn    { from { opacity: 0 } to { opacity: 1 } }
        @keyframes qka_fadeOut   { from { opacity: 1 } to { opacity: 0 } }
        @keyframes qka_slideIn   { from { opacity: 0; transform: translate(-50%, -46%) scale(.94) } to { opacity: 1; transform: translate(-50%, -50%) scale(1) } }
        @keyframes qka_slideOut  { from { opacity: 1; transform: translate(-50%, -50%) scale(1)   } to { opacity: 0; transform: translate(-50%, -46%) scale(.94) } }
      `}</style>
    </>
  );
}
